export const tweets = {
  '1794130302530736270': {
    __typename: 'Tweet',
    in_reply_to_screen_name: 'EonianFinance',
    in_reply_to_status_id_str: '1789924316739412125',
    in_reply_to_user_id_str: '1584314875991523328',
    lang: 'en',
    favorite_count: 0,
    created_at: '2024-05-24T22:16:12.000Z',
    display_text_range: [15, 60],
    entities: {
      hashtags: [],
      urls: [],
      user_mentions: [
        {
          id_str: '1584314875991523328',
          indices: [0, 14],
          name: 'Eonian',
          screen_name: 'EonianFinance',
        },
      ],
      symbols: [],
    },
    id_str: '1794130302530736270',
    text: '@EonianFinance Very nice and prosperous project\n🎉🎉🎉🎊🎊🎊',
    user: {
      id_str: '1630493926867222528',
      name: 'Jend Empire $OMNI 🅾️',
      profile_image_url_https: 'https://pbs.twimg.com/profile_images/1792624159907803136/zE5UoKrF_normal.jpg',
      screen_name: 'JendEmpire',
      verified: false,
      is_blue_verified: false,
      profile_image_shape: 'Circle',
    },
    edit_control: {
      edit_tweet_ids: ['1794130302530736270'],
      editable_until_msecs: '1716592572000',
      is_edit_eligible: false,
      edits_remaining: '5',
    },
    conversation_count: 0,
    news_action_type: 'conversation',
    parent: {
      lang: 'en',
      reply_count: 35,
      retweet_count: 34,
      favorite_count: 38,
      possibly_sensitive: false,
      created_at: '2024-05-13T07:43:06.000Z',
      display_text_range: [0, 276],
      entities: {
        hashtags: [],
        urls: [],
        user_mentions: [],
        symbols: [],
        media: [
          {
            display_url: 'pic.x.com/r6tfmn7acr',
            expanded_url: 'https://twitter.com/EonianFinance/status/1789924316739412125/photo/1',
            indices: [277, 300],
            url: 'https://t.co/r6tfMn7Acr',
          },
        ],
      },
      id_str: '1789924316739412125',
      text: 'Open Beta Announce\nMore than a year ago, we launched our protocol in closed alpha. Since then, we have refined our solution, fixed many bugs, and added awesome features. That means very soon, we will be ready to launch our protocol in open beta and allow anyone to save their… https://t.co/r6tfMn7Acr',
      user: {
        id_str: '1584314875991523328',
        name: 'Eonian',
        profile_image_url_https: 'https://pbs.twimg.com/profile_images/1768404732949733377/T_w4Y8-E_normal.jpg',
        screen_name: 'EonianFinance',
        verified: false,
        is_blue_verified: true,
        profile_image_shape: 'Circle',
      },
      edit_control: {
        edit_tweet_ids: ['1789924316739412125'],
        editable_until_msecs: '1715589786000',
        is_edit_eligible: true,
        edits_remaining: '5',
      },
      mediaDetails: [
        {
          display_url: 'pic.twitter.com/r6tfMn7Acr',
          expanded_url: 'https://twitter.com/EonianFinance/status/1789924316739412125/photo/1',
          ext_media_availability: {
            status: 'Available',
          },
          indices: [277, 300],
          media_url_https: 'https://pbs.twimg.com/media/GNcWIa_W8AAvae_.jpg',
          original_info: {
            height: 1250,
            width: 1250,
            focus_rects: [
              {
                x: 0,
                y: 118,
                w: 1250,
                h: 700,
              },
              {
                x: 0,
                y: 0,
                w: 1250,
                h: 1250,
              },
              {
                x: 45,
                y: 0,
                w: 1096,
                h: 1250,
              },
              {
                x: 281,
                y: 0,
                w: 625,
                h: 1250,
              },
              {
                x: 0,
                y: 0,
                w: 1250,
                h: 1250,
              },
            ],
          },
          sizes: {
            large: {
              h: 1250,
              resize: 'fit',
              w: 1250,
            },
            medium: {
              h: 1200,
              resize: 'fit',
              w: 1200,
            },
            small: {
              h: 680,
              resize: 'fit',
              w: 680,
            },
            thumb: {
              h: 150,
              resize: 'crop',
              w: 150,
            },
          },
          type: 'photo',
          url: 'https://t.co/r6tfMn7Acr',
        },
      ],
      photos: [
        {
          backgroundColor: {
            red: 204,
            green: 214,
            blue: 221,
          },
          cropCandidates: [
            {
              x: 0,
              y: 118,
              w: 1250,
              h: 700,
            },
            {
              x: 0,
              y: 0,
              w: 1250,
              h: 1250,
            },
            {
              x: 45,
              y: 0,
              w: 1096,
              h: 1250,
            },
            {
              x: 281,
              y: 0,
              w: 625,
              h: 1250,
            },
            {
              x: 0,
              y: 0,
              w: 1250,
              h: 1250,
            },
          ],
          expandedUrl: 'https://twitter.com/EonianFinance/status/1789924316739412125/photo/1',
          url: 'https://pbs.twimg.com/media/GNcWIa_W8AAvae_.jpg',
          width: 1250,
          height: 1250,
        },
      ],
      isEdited: false,
      isStaleEdit: false,
    },
    isEdited: false,
    isStaleEdit: false,
  },
  '1697597961503490277': {
    __typename: 'Tweet',
    in_reply_to_screen_name: 'EonianFinance',
    in_reply_to_status_id_str: '1689980176174624768',
    in_reply_to_user_id_str: '1584314875991523328',
    lang: 'en',
    favorite_count: 0,
    created_at: '2023-09-01T13:11:08.000Z',
    display_text_range: [15, 97],
    entities: {
      hashtags: [
        {
          indices: [65, 79],
          text: 'EonianFinance',
        },
      ],
      urls: [],
      user_mentions: [
        {
          id_str: '1584314875991523328',
          indices: [0, 14],
          name: 'Eonian',
          screen_name: 'EonianFinance',
        },
      ],
      symbols: [],
    },
    id_str: '1697597961503490277',
    text: '@EonianFinance Wish to be guided on proper risk management . Let #EonianFinance be your sure plug',
    user: {
      id_str: '1481494764927307776',
      name: 'Awasiakan Udo',
      profile_image_url_https: 'https://pbs.twimg.com/profile_images/1788583962845032448/0d_Y2SCW_normal.jpg',
      screen_name: 'AwasiakanUdo',
      verified: false,
      is_blue_verified: false,
      profile_image_shape: 'Circle',
    },
    edit_control: {
      edit_tweet_ids: ['1697597961503490277'],
      editable_until_msecs: '1693577468000',
      is_edit_eligible: false,
      edits_remaining: '5',
    },
    conversation_count: 0,
    news_action_type: 'conversation',
    parent: {
      lang: 'en',
      reply_count: 44,
      retweet_count: 33,
      favorite_count: 39,
      possibly_sensitive: false,
      created_at: '2023-08-11T12:40:46.000Z',
      display_text_range: [0, 277],
      entities: {
        hashtags: [],
        urls: [],
        user_mentions: [],
        symbols: [],
        media: [
          {
            display_url: 'pic.x.com/eswflvhvvs',
            expanded_url: 'https://twitter.com/EonianFinance/status/1689980176174624768/photo/1',
            indices: [278, 301],
            url: 'https://t.co/eSWFlvhvVs',
          },
        ],
      },
      id_str: '1689980176174624768',
      text: 'Are you an investor looking out for the best way to make money in crypto? It\'s important to be aware of potential risks before investing in the world of Decentralized Finance.\n\nUnderstanding the Risks of DeFi Investments\n\n10 risks of investment every investor must know. Let’s… https://t.co/eSWFlvhvVs',
      user: {
        id_str: '1584314875991523328',
        name: 'Eonian',
        profile_image_url_https: 'https://pbs.twimg.com/profile_images/1768404732949733377/T_w4Y8-E_normal.jpg',
        screen_name: 'EonianFinance',
        verified: false,
        is_blue_verified: true,
        profile_image_shape: 'Circle',
      },
      edit_control: {
        edit_tweet_ids: ['1689980176174624768'],
        editable_until_msecs: '1691761246000',
        is_edit_eligible: false,
        edits_remaining: '5',
      },
      mediaDetails: [
        {
          display_url: 'pic.twitter.com/eSWFlvhvVs',
          expanded_url: 'https://twitter.com/EonianFinance/status/1689980176174624768/photo/1',
          ext_media_availability: {
            status: 'Available',
          },
          indices: [278, 301],
          media_url_https: 'https://pbs.twimg.com/media/F3QEAj6W4AEUtTP.jpg',
          original_info: {
            height: 900,
            width: 1600,
            focus_rects: [
              {
                x: 0,
                y: 0,
                w: 1600,
                h: 896,
              },
              {
                x: 700,
                y: 0,
                w: 900,
                h: 900,
              },
              {
                x: 811,
                y: 0,
                w: 789,
                h: 900,
              },
              {
                x: 1095,
                y: 0,
                w: 450,
                h: 900,
              },
              {
                x: 0,
                y: 0,
                w: 1600,
                h: 900,
              },
            ],
          },
          sizes: {
            large: {
              h: 900,
              resize: 'fit',
              w: 1600,
            },
            medium: {
              h: 675,
              resize: 'fit',
              w: 1200,
            },
            small: {
              h: 383,
              resize: 'fit',
              w: 680,
            },
            thumb: {
              h: 150,
              resize: 'crop',
              w: 150,
            },
          },
          type: 'photo',
          url: 'https://t.co/eSWFlvhvVs',
        },
      ],
      photos: [
        {
          backgroundColor: {
            red: 204,
            green: 214,
            blue: 221,
          },
          cropCandidates: [
            {
              x: 0,
              y: 0,
              w: 1600,
              h: 896,
            },
            {
              x: 700,
              y: 0,
              w: 900,
              h: 900,
            },
            {
              x: 811,
              y: 0,
              w: 789,
              h: 900,
            },
            {
              x: 1095,
              y: 0,
              w: 450,
              h: 900,
            },
            {
              x: 0,
              y: 0,
              w: 1600,
              h: 900,
            },
          ],
          expandedUrl: 'https://twitter.com/EonianFinance/status/1689980176174624768/photo/1',
          url: 'https://pbs.twimg.com/media/F3QEAj6W4AEUtTP.jpg',
          width: 1600,
          height: 900,
        },
      ],
      isEdited: false,
      isStaleEdit: false,
    },
    isEdited: false,
    isStaleEdit: false,
  },
  '1752601486692159938': {
    __typename: 'Tweet',
    in_reply_to_screen_name: 'EonianFinance',
    in_reply_to_status_id_str: '1751444681634787806',
    in_reply_to_user_id_str: '1584314875991523328',
    lang: 'en',
    favorite_count: 1,
    created_at: '2024-01-31T07:55:30.000Z',
    display_text_range: [15, 35],
    entities: {
      hashtags: [],
      urls: [],
      user_mentions: [
        {
          id_str: '1584314875991523328',
          indices: [0, 14],
          name: 'Eonian',
          screen_name: 'EonianFinance',
        },
      ],
      symbols: [],
    },
    id_str: '1752601486692159938',
    text: '@EonianFinance let\'s go to the moon',
    user: {
      id_str: '1605583637319016448',
      name: 'Thang l❤️ $WELL l NavyAi',
      profile_image_url_https: 'https://pbs.twimg.com/profile_images/1714159541510938624/5k7FoLrk_normal.jpg',
      screen_name: 'TrinhNguyen8867',
      verified: false,
      is_blue_verified: false,
      profile_image_shape: 'Circle',
    },
    edit_control: {
      edit_tweet_ids: ['1752601486692159938'],
      editable_until_msecs: '1706691330000',
      is_edit_eligible: false,
      edits_remaining: '5',
    },
    conversation_count: 1,
    news_action_type: 'conversation',
    parent: {
      lang: 'en',
      reply_count: 119,
      retweet_count: 224,
      favorite_count: 310,
      possibly_sensitive: false,
      created_at: '2024-01-28T03:18:47.000Z',
      display_text_range: [0, 219],
      entities: {
        hashtags: [
          {
            indices: [58, 65],
            text: 'crypto',
          },
        ],
        urls: [
          {
            display_url: 'eonian.finance',
            expanded_url: 'https://eonian.finance',
            indices: [196, 219],
            url: 'https://t.co/ieieSlLHh5',
          },
        ],
        user_mentions: [],
        symbols: [],
        media: [
          {
            display_url: 'pic.x.com/l6kgkoakqj',
            expanded_url: 'https://twitter.com/EonianFinance/status/1751444681634787806/video/1',
            indices: [220, 243],
            url: 'https://t.co/L6KGKOAkQJ',
          },
        ],
      },
      id_str: '1751444681634787806',
      text: 'Launch of First Decentralized Savings Account\nInsure your #crypto from wallet hacks with zero fees, while passively earning savings premium on your holdings.\n\nLearn more and keep your money safe: https://t.co/ieieSlLHh5 https://t.co/L6KGKOAkQJ',
      user: {
        id_str: '1584314875991523328',
        name: 'Eonian',
        profile_image_url_https: 'https://pbs.twimg.com/profile_images/1768404732949733377/T_w4Y8-E_normal.jpg',
        screen_name: 'EonianFinance',
        verified: false,
        is_blue_verified: true,
        profile_image_shape: 'Circle',
      },
      edit_control: {
        edit_tweet_ids: ['1751444681634787806'],
        editable_until_msecs: '1706415527000',
        is_edit_eligible: true,
        edits_remaining: '5',
      },
      mediaDetails: [
        {
          additional_media_info: {},
          display_url: 'pic.twitter.com/L6KGKOAkQJ',
          expanded_url: 'https://twitter.com/EonianFinance/status/1751444681634787806/video/1',
          ext_media_availability: {
            status: 'Available',
          },
          indices: [220, 243],
          media_url_https: 'https://pbs.twimg.com/ext_tw_video_thumb/1751443920339226624/pu/img/M2wWH3j9NagQhB4p.jpg',
          original_info: {
            height: 1080,
            width: 1920,
            focus_rects: [],
          },
          sizes: {
            large: {
              h: 1080,
              resize: 'fit',
              w: 1920,
            },
            medium: {
              h: 675,
              resize: 'fit',
              w: 1200,
            },
            small: {
              h: 383,
              resize: 'fit',
              w: 680,
            },
            thumb: {
              h: 150,
              resize: 'crop',
              w: 150,
            },
          },
          type: 'video',
          url: 'https://t.co/L6KGKOAkQJ',
          video_info: {
            aspect_ratio: [16, 9],
            duration_millis: 26221,
            variants: [
              {
                content_type: 'application/x-mpegURL',
                url: 'https://video.twimg.com/ext_tw_video/1751443920339226624/pu/pl/5V9UUfMQpj2Is9tO.m3u8?tag=14',
              },
              {
                bitrate: 256000,
                content_type: 'video/mp4',
                url: 'https://video.twimg.com/ext_tw_video/1751443920339226624/pu/vid/avc1/480x270/hgqlrSCMAe91lext.mp4?tag=14',
              },
              {
                bitrate: 832000,
                content_type: 'video/mp4',
                url: 'https://video.twimg.com/ext_tw_video/1751443920339226624/pu/vid/avc1/640x360/QGmXdt2Y5iBrAyVR.mp4?tag=14',
              },
              {
                bitrate: 2176000,
                content_type: 'video/mp4',
                url: 'https://video.twimg.com/ext_tw_video/1751443920339226624/pu/vid/avc1/1280x720/kFv4jIOxO3dF12WE.mp4?tag=14',
              },
              {
                bitrate: 10368000,
                content_type: 'video/mp4',
                url: 'https://video.twimg.com/ext_tw_video/1751443920339226624/pu/vid/avc1/1920x1080/GWono6WDbJZs1sSX.mp4?tag=14',
              },
            ],
          },
        },
      ],
      photos: [],
      video: {
        aspectRatio: [16, 9],
        contentType: 'media_entity',
        durationMs: 26221,
        mediaAvailability: {
          status: 'available',
        },
        poster: 'https://pbs.twimg.com/ext_tw_video_thumb/1751443920339226624/pu/img/M2wWH3j9NagQhB4p.jpg',
        variants: [
          {
            type: 'application/x-mpegURL',
            src: 'https://video.twimg.com/ext_tw_video/1751443920339226624/pu/pl/5V9UUfMQpj2Is9tO.m3u8?tag=14',
          },
          {
            type: 'video/mp4',
            src: 'https://video.twimg.com/ext_tw_video/1751443920339226624/pu/vid/avc1/480x270/hgqlrSCMAe91lext.mp4?tag=14',
          },
          {
            type: 'video/mp4',
            src: 'https://video.twimg.com/ext_tw_video/1751443920339226624/pu/vid/avc1/640x360/QGmXdt2Y5iBrAyVR.mp4?tag=14',
          },
          {
            type: 'video/mp4',
            src: 'https://video.twimg.com/ext_tw_video/1751443920339226624/pu/vid/avc1/1280x720/kFv4jIOxO3dF12WE.mp4?tag=14',
          },
          {
            type: 'video/mp4',
            src: 'https://video.twimg.com/ext_tw_video/1751443920339226624/pu/vid/avc1/1920x1080/GWono6WDbJZs1sSX.mp4?tag=14',
          },
        ],
        videoId: {
          type: 'tweet',
          id: '1751444681634787806',
        },
        viewCount: 0,
      },
      isEdited: false,
      isStaleEdit: false,
    },
    isEdited: false,
    isStaleEdit: false,
  },
  '1793528774027509972': {
    __typename: 'Tweet',
    in_reply_to_screen_name: 'EonianFinance',
    in_reply_to_status_id_str: '1751444681634787806',
    in_reply_to_user_id_str: '1584314875991523328',
    lang: 'en',
    favorite_count: 0,
    created_at: '2024-05-23T06:25:56.000Z',
    display_text_range: [15, 107],
    entities: {
      hashtags: [],
      urls: [],
      user_mentions: [
        {
          id_str: '1584314875991523328',
          indices: [0, 14],
          name: 'Eonian',
          screen_name: 'EonianFinance',
        },
      ],
      symbols: [],
    },
    id_str: '1793528774027509972',
    text: '@EonianFinance Given how security is essentian in the crypto space, this sounds like a very worthy project.',
    user: {
      id_str: '61748645',
      name: 'Filmalter',
      profile_image_url_https:
        'https://pbs.twimg.com/profile_images/3084582885/75358f98bbfba2488db7de081663bf21_normal.jpeg',
      screen_name: 'Filmalter',
      verified: false,
      is_blue_verified: false,
      profile_image_shape: 'Circle',
    },
    edit_control: {
      edit_tweet_ids: ['1793528774027509972'],
      editable_until_msecs: '1716449156000',
      is_edit_eligible: false,
      edits_remaining: '5',
    },
    conversation_count: 0,
    news_action_type: 'conversation',
    parent: {
      lang: 'en',
      reply_count: 119,
      retweet_count: 224,
      favorite_count: 310,
      possibly_sensitive: false,
      created_at: '2024-01-28T03:18:47.000Z',
      display_text_range: [0, 219],
      entities: {
        hashtags: [
          {
            indices: [58, 65],
            text: 'crypto',
          },
        ],
        urls: [
          {
            display_url: 'eonian.finance',
            expanded_url: 'https://eonian.finance',
            indices: [196, 219],
            url: 'https://t.co/ieieSlLHh5',
          },
        ],
        user_mentions: [],
        symbols: [],
        media: [
          {
            display_url: 'pic.x.com/l6kgkoakqj',
            expanded_url: 'https://twitter.com/EonianFinance/status/1751444681634787806/video/1',
            indices: [220, 243],
            url: 'https://t.co/L6KGKOAkQJ',
          },
        ],
      },
      id_str: '1751444681634787806',
      text: 'Launch of First Decentralized Savings Account\nInsure your #crypto from wallet hacks with zero fees, while passively earning savings premium on your holdings.\n\nLearn more and keep your money safe: https://t.co/ieieSlLHh5 https://t.co/L6KGKOAkQJ',
      user: {
        id_str: '1584314875991523328',
        name: 'Eonian',
        profile_image_url_https: 'https://pbs.twimg.com/profile_images/1768404732949733377/T_w4Y8-E_normal.jpg',
        screen_name: 'EonianFinance',
        verified: false,
        is_blue_verified: true,
        profile_image_shape: 'Circle',
      },
      edit_control: {
        edit_tweet_ids: ['1751444681634787806'],
        editable_until_msecs: '1706415527000',
        is_edit_eligible: true,
        edits_remaining: '5',
      },
      mediaDetails: [
        {
          additional_media_info: {},
          display_url: 'pic.twitter.com/L6KGKOAkQJ',
          expanded_url: 'https://twitter.com/EonianFinance/status/1751444681634787806/video/1',
          ext_media_availability: {
            status: 'Available',
          },
          indices: [220, 243],
          media_url_https: 'https://pbs.twimg.com/ext_tw_video_thumb/1751443920339226624/pu/img/M2wWH3j9NagQhB4p.jpg',
          original_info: {
            height: 1080,
            width: 1920,
            focus_rects: [],
          },
          sizes: {
            large: {
              h: 1080,
              resize: 'fit',
              w: 1920,
            },
            medium: {
              h: 675,
              resize: 'fit',
              w: 1200,
            },
            small: {
              h: 383,
              resize: 'fit',
              w: 680,
            },
            thumb: {
              h: 150,
              resize: 'crop',
              w: 150,
            },
          },
          type: 'video',
          url: 'https://t.co/L6KGKOAkQJ',
          video_info: {
            aspect_ratio: [16, 9],
            duration_millis: 26221,
            variants: [
              {
                content_type: 'application/x-mpegURL',
                url: 'https://video.twimg.com/ext_tw_video/1751443920339226624/pu/pl/5V9UUfMQpj2Is9tO.m3u8?tag=14',
              },
              {
                bitrate: 256000,
                content_type: 'video/mp4',
                url: 'https://video.twimg.com/ext_tw_video/1751443920339226624/pu/vid/avc1/480x270/hgqlrSCMAe91lext.mp4?tag=14',
              },
              {
                bitrate: 832000,
                content_type: 'video/mp4',
                url: 'https://video.twimg.com/ext_tw_video/1751443920339226624/pu/vid/avc1/640x360/QGmXdt2Y5iBrAyVR.mp4?tag=14',
              },
              {
                bitrate: 2176000,
                content_type: 'video/mp4',
                url: 'https://video.twimg.com/ext_tw_video/1751443920339226624/pu/vid/avc1/1280x720/kFv4jIOxO3dF12WE.mp4?tag=14',
              },
              {
                bitrate: 10368000,
                content_type: 'video/mp4',
                url: 'https://video.twimg.com/ext_tw_video/1751443920339226624/pu/vid/avc1/1920x1080/GWono6WDbJZs1sSX.mp4?tag=14',
              },
            ],
          },
        },
      ],
      photos: [],
      video: {
        aspectRatio: [16, 9],
        contentType: 'media_entity',
        durationMs: 26221,
        mediaAvailability: {
          status: 'available',
        },
        poster: 'https://pbs.twimg.com/ext_tw_video_thumb/1751443920339226624/pu/img/M2wWH3j9NagQhB4p.jpg',
        variants: [
          {
            type: 'application/x-mpegURL',
            src: 'https://video.twimg.com/ext_tw_video/1751443920339226624/pu/pl/5V9UUfMQpj2Is9tO.m3u8?tag=14',
          },
          {
            type: 'video/mp4',
            src: 'https://video.twimg.com/ext_tw_video/1751443920339226624/pu/vid/avc1/480x270/hgqlrSCMAe91lext.mp4?tag=14',
          },
          {
            type: 'video/mp4',
            src: 'https://video.twimg.com/ext_tw_video/1751443920339226624/pu/vid/avc1/640x360/QGmXdt2Y5iBrAyVR.mp4?tag=14',
          },
          {
            type: 'video/mp4',
            src: 'https://video.twimg.com/ext_tw_video/1751443920339226624/pu/vid/avc1/1280x720/kFv4jIOxO3dF12WE.mp4?tag=14',
          },
          {
            type: 'video/mp4',
            src: 'https://video.twimg.com/ext_tw_video/1751443920339226624/pu/vid/avc1/1920x1080/GWono6WDbJZs1sSX.mp4?tag=14',
          },
        ],
        videoId: {
          type: 'tweet',
          id: '1751444681634787806',
        },
        viewCount: 0,
      },
      isEdited: false,
      isStaleEdit: false,
    },
    isEdited: false,
    isStaleEdit: false,
  },
  '1767178284628873338': {
    __typename: 'Tweet',
    in_reply_to_screen_name: 'EonianFinance',
    in_reply_to_status_id_str: '1751444681634787806',
    in_reply_to_user_id_str: '1584314875991523328',
    lang: 'en',
    favorite_count: 0,
    created_at: '2024-03-11T13:18:30.000Z',
    display_text_range: [15, 34],
    entities: {
      hashtags: [],
      urls: [],
      user_mentions: [
        {
          id_str: '1584314875991523328',
          indices: [0, 14],
          name: 'Eonian',
          screen_name: 'EonianFinance',
        },
      ],
      symbols: [],
    },
    id_str: '1767178284628873338',
    text: '@EonianFinance Look interesting 👀',
    user: {
      id_str: '1677646243609075712',
      name: '-CryptoXP-',
      profile_image_url_https: 'https://pbs.twimg.com/profile_images/1702051315130519552/UwS-eUtF_normal.jpg',
      screen_name: 'CryptoXP_11',
      verified: false,
      is_blue_verified: false,
      profile_image_shape: 'Circle',
    },
    edit_control: {
      edit_tweet_ids: ['1767178284628873338'],
      editable_until_msecs: '1710166710000',
      is_edit_eligible: false,
      edits_remaining: '5',
    },
    conversation_count: 0,
    news_action_type: 'conversation',
    parent: {
      lang: 'en',
      reply_count: 119,
      retweet_count: 224,
      favorite_count: 310,
      possibly_sensitive: false,
      created_at: '2024-01-28T03:18:47.000Z',
      display_text_range: [0, 219],
      entities: {
        hashtags: [
          {
            indices: [58, 65],
            text: 'crypto',
          },
        ],
        urls: [
          {
            display_url: 'eonian.finance',
            expanded_url: 'https://eonian.finance',
            indices: [196, 219],
            url: 'https://t.co/ieieSlLHh5',
          },
        ],
        user_mentions: [],
        symbols: [],
        media: [
          {
            display_url: 'pic.x.com/l6kgkoakqj',
            expanded_url: 'https://twitter.com/EonianFinance/status/1751444681634787806/video/1',
            indices: [220, 243],
            url: 'https://t.co/L6KGKOAkQJ',
          },
        ],
      },
      id_str: '1751444681634787806',
      text: 'Launch of First Decentralized Savings Account\nInsure your #crypto from wallet hacks with zero fees, while passively earning savings premium on your holdings.\n\nLearn more and keep your money safe: https://t.co/ieieSlLHh5 https://t.co/L6KGKOAkQJ',
      user: {
        id_str: '1584314875991523328',
        name: 'Eonian',
        profile_image_url_https: 'https://pbs.twimg.com/profile_images/1768404732949733377/T_w4Y8-E_normal.jpg',
        screen_name: 'EonianFinance',
        verified: false,
        is_blue_verified: true,
        profile_image_shape: 'Circle',
      },
      edit_control: {
        edit_tweet_ids: ['1751444681634787806'],
        editable_until_msecs: '1706415527000',
        is_edit_eligible: true,
        edits_remaining: '5',
      },
      mediaDetails: [
        {
          additional_media_info: {},
          display_url: 'pic.twitter.com/L6KGKOAkQJ',
          expanded_url: 'https://twitter.com/EonianFinance/status/1751444681634787806/video/1',
          ext_media_availability: {
            status: 'Available',
          },
          indices: [220, 243],
          media_url_https: 'https://pbs.twimg.com/ext_tw_video_thumb/1751443920339226624/pu/img/M2wWH3j9NagQhB4p.jpg',
          original_info: {
            height: 1080,
            width: 1920,
            focus_rects: [],
          },
          sizes: {
            large: {
              h: 1080,
              resize: 'fit',
              w: 1920,
            },
            medium: {
              h: 675,
              resize: 'fit',
              w: 1200,
            },
            small: {
              h: 383,
              resize: 'fit',
              w: 680,
            },
            thumb: {
              h: 150,
              resize: 'crop',
              w: 150,
            },
          },
          type: 'video',
          url: 'https://t.co/L6KGKOAkQJ',
          video_info: {
            aspect_ratio: [16, 9],
            duration_millis: 26221,
            variants: [
              {
                content_type: 'application/x-mpegURL',
                url: 'https://video.twimg.com/ext_tw_video/1751443920339226624/pu/pl/5V9UUfMQpj2Is9tO.m3u8?tag=14',
              },
              {
                bitrate: 256000,
                content_type: 'video/mp4',
                url: 'https://video.twimg.com/ext_tw_video/1751443920339226624/pu/vid/avc1/480x270/hgqlrSCMAe91lext.mp4?tag=14',
              },
              {
                bitrate: 832000,
                content_type: 'video/mp4',
                url: 'https://video.twimg.com/ext_tw_video/1751443920339226624/pu/vid/avc1/640x360/QGmXdt2Y5iBrAyVR.mp4?tag=14',
              },
              {
                bitrate: 2176000,
                content_type: 'video/mp4',
                url: 'https://video.twimg.com/ext_tw_video/1751443920339226624/pu/vid/avc1/1280x720/kFv4jIOxO3dF12WE.mp4?tag=14',
              },
              {
                bitrate: 10368000,
                content_type: 'video/mp4',
                url: 'https://video.twimg.com/ext_tw_video/1751443920339226624/pu/vid/avc1/1920x1080/GWono6WDbJZs1sSX.mp4?tag=14',
              },
            ],
          },
        },
      ],
      photos: [],
      video: {
        aspectRatio: [16, 9],
        contentType: 'media_entity',
        durationMs: 26221,
        mediaAvailability: {
          status: 'available',
        },
        poster: 'https://pbs.twimg.com/ext_tw_video_thumb/1751443920339226624/pu/img/M2wWH3j9NagQhB4p.jpg',
        variants: [
          {
            type: 'application/x-mpegURL',
            src: 'https://video.twimg.com/ext_tw_video/1751443920339226624/pu/pl/5V9UUfMQpj2Is9tO.m3u8?tag=14',
          },
          {
            type: 'video/mp4',
            src: 'https://video.twimg.com/ext_tw_video/1751443920339226624/pu/vid/avc1/480x270/hgqlrSCMAe91lext.mp4?tag=14',
          },
          {
            type: 'video/mp4',
            src: 'https://video.twimg.com/ext_tw_video/1751443920339226624/pu/vid/avc1/640x360/QGmXdt2Y5iBrAyVR.mp4?tag=14',
          },
          {
            type: 'video/mp4',
            src: 'https://video.twimg.com/ext_tw_video/1751443920339226624/pu/vid/avc1/1280x720/kFv4jIOxO3dF12WE.mp4?tag=14',
          },
          {
            type: 'video/mp4',
            src: 'https://video.twimg.com/ext_tw_video/1751443920339226624/pu/vid/avc1/1920x1080/GWono6WDbJZs1sSX.mp4?tag=14',
          },
        ],
        videoId: {
          type: 'tweet',
          id: '1751444681634787806',
        },
        viewCount: 0,
      },
      isEdited: false,
      isStaleEdit: false,
    },
    isEdited: false,
    isStaleEdit: false,
  },
  '1791843687674126794': {
    __typename: 'Tweet',
    in_reply_to_screen_name: 'EonianFinance',
    in_reply_to_status_id_str: '1789924316739412125',
    in_reply_to_user_id_str: '1584314875991523328',
    lang: 'en',
    favorite_count: 0,
    created_at: '2024-05-18T14:50:00.000Z',
    display_text_range: [15, 54],
    entities: {
      hashtags: [],
      urls: [],
      user_mentions: [
        {
          id_str: '1584314875991523328',
          indices: [0, 14],
          name: 'Eonian',
          screen_name: 'EonianFinance',
        },
      ],
      symbols: [],
    },
    id_str: '1791843687674126794',
    text: '@EonianFinance Very exciting project. Glad to be here!',
    user: {
      id_str: '1758747538629267456',
      name: 'Anya (🎮,🟢)',
      profile_image_url_https: 'https://pbs.twimg.com/profile_images/1758747652127092736/dARcUKdT_normal.jpg',
      screen_name: 'ANYA_rekt',
      verified: false,
      is_blue_verified: false,
      profile_image_shape: 'Circle',
    },
    edit_control: {
      edit_tweet_ids: ['1791843687674126794'],
      editable_until_msecs: '1716047400000',
      is_edit_eligible: false,
      edits_remaining: '5',
    },
    conversation_count: 0,
    news_action_type: 'conversation',
    parent: {
      lang: 'en',
      reply_count: 35,
      retweet_count: 34,
      favorite_count: 38,
      possibly_sensitive: false,
      created_at: '2024-05-13T07:43:06.000Z',
      display_text_range: [0, 276],
      entities: {
        hashtags: [],
        urls: [],
        user_mentions: [],
        symbols: [],
        media: [
          {
            display_url: 'pic.x.com/r6tfmn7acr',
            expanded_url: 'https://twitter.com/EonianFinance/status/1789924316739412125/photo/1',
            indices: [277, 300],
            url: 'https://t.co/r6tfMn7Acr',
          },
        ],
      },
      id_str: '1789924316739412125',
      text: 'Open Beta Announce\nMore than a year ago, we launched our protocol in closed alpha. Since then, we have refined our solution, fixed many bugs, and added awesome features. That means very soon, we will be ready to launch our protocol in open beta and allow anyone to save their… https://t.co/r6tfMn7Acr',
      user: {
        id_str: '1584314875991523328',
        name: 'Eonian',
        profile_image_url_https: 'https://pbs.twimg.com/profile_images/1768404732949733377/T_w4Y8-E_normal.jpg',
        screen_name: 'EonianFinance',
        verified: false,
        is_blue_verified: true,
        profile_image_shape: 'Circle',
      },
      edit_control: {
        edit_tweet_ids: ['1789924316739412125'],
        editable_until_msecs: '1715589786000',
        is_edit_eligible: true,
        edits_remaining: '5',
      },
      mediaDetails: [
        {
          display_url: 'pic.twitter.com/r6tfMn7Acr',
          expanded_url: 'https://twitter.com/EonianFinance/status/1789924316739412125/photo/1',
          ext_media_availability: {
            status: 'Available',
          },
          indices: [277, 300],
          media_url_https: 'https://pbs.twimg.com/media/GNcWIa_W8AAvae_.jpg',
          original_info: {
            height: 1250,
            width: 1250,
            focus_rects: [
              {
                x: 0,
                y: 118,
                w: 1250,
                h: 700,
              },
              {
                x: 0,
                y: 0,
                w: 1250,
                h: 1250,
              },
              {
                x: 45,
                y: 0,
                w: 1096,
                h: 1250,
              },
              {
                x: 281,
                y: 0,
                w: 625,
                h: 1250,
              },
              {
                x: 0,
                y: 0,
                w: 1250,
                h: 1250,
              },
            ],
          },
          sizes: {
            large: {
              h: 1250,
              resize: 'fit',
              w: 1250,
            },
            medium: {
              h: 1200,
              resize: 'fit',
              w: 1200,
            },
            small: {
              h: 680,
              resize: 'fit',
              w: 680,
            },
            thumb: {
              h: 150,
              resize: 'crop',
              w: 150,
            },
          },
          type: 'photo',
          url: 'https://t.co/r6tfMn7Acr',
        },
      ],
      photos: [
        {
          backgroundColor: {
            red: 204,
            green: 214,
            blue: 221,
          },
          cropCandidates: [
            {
              x: 0,
              y: 118,
              w: 1250,
              h: 700,
            },
            {
              x: 0,
              y: 0,
              w: 1250,
              h: 1250,
            },
            {
              x: 45,
              y: 0,
              w: 1096,
              h: 1250,
            },
            {
              x: 281,
              y: 0,
              w: 625,
              h: 1250,
            },
            {
              x: 0,
              y: 0,
              w: 1250,
              h: 1250,
            },
          ],
          expandedUrl: 'https://twitter.com/EonianFinance/status/1789924316739412125/photo/1',
          url: 'https://pbs.twimg.com/media/GNcWIa_W8AAvae_.jpg',
          width: 1250,
          height: 1250,
        },
      ],
      isEdited: false,
      isStaleEdit: false,
    },
    isEdited: false,
    isStaleEdit: false,
  },
  '1752137237750563015': {
    __typename: 'Tweet',
    in_reply_to_screen_name: 'EonianFinance',
    in_reply_to_status_id_str: '1751444681634787806',
    in_reply_to_user_id_str: '1584314875991523328',
    lang: 'en',
    favorite_count: 1,
    created_at: '2024-01-30T01:10:45.000Z',
    display_text_range: [15, 55],
    entities: {
      hashtags: [],
      urls: [],
      user_mentions: [
        {
          id_str: '1584314875991523328',
          indices: [0, 14],
          name: 'Eonian',
          screen_name: 'EonianFinance',
        },
      ],
      symbols: [],
    },
    id_str: '1752137237750563015',
    text: '@EonianFinance Keep building for the sake of community.',
    user: {
      id_str: '1418246700414631937',
      name: '🦉🦉0xNadskie🕷️🕷️🛹🛹',
      profile_image_url_https: 'https://pbs.twimg.com/profile_images/1795754347126788096/7hOGbeQw_normal.jpg',
      screen_name: 'nadskie_18',
      verified: false,
      is_blue_verified: false,
      profile_image_shape: 'Circle',
    },
    edit_control: {
      edit_tweet_ids: ['1752137237750563015'],
      editable_until_msecs: '1706580645000',
      is_edit_eligible: false,
      edits_remaining: '5',
    },
    conversation_count: 1,
    news_action_type: 'conversation',
    parent: {
      lang: 'en',
      reply_count: 119,
      retweet_count: 224,
      favorite_count: 310,
      possibly_sensitive: false,
      created_at: '2024-01-28T03:18:47.000Z',
      display_text_range: [0, 219],
      entities: {
        hashtags: [
          {
            indices: [58, 65],
            text: 'crypto',
          },
        ],
        urls: [
          {
            display_url: 'eonian.finance',
            expanded_url: 'https://eonian.finance',
            indices: [196, 219],
            url: 'https://t.co/ieieSlLHh5',
          },
        ],
        user_mentions: [],
        symbols: [],
        media: [
          {
            display_url: 'pic.x.com/l6kgkoakqj',
            expanded_url: 'https://twitter.com/EonianFinance/status/1751444681634787806/video/1',
            indices: [220, 243],
            url: 'https://t.co/L6KGKOAkQJ',
          },
        ],
      },
      id_str: '1751444681634787806',
      text: 'Launch of First Decentralized Savings Account\nInsure your #crypto from wallet hacks with zero fees, while passively earning savings premium on your holdings.\n\nLearn more and keep your money safe: https://t.co/ieieSlLHh5 https://t.co/L6KGKOAkQJ',
      user: {
        id_str: '1584314875991523328',
        name: 'Eonian',
        profile_image_url_https: 'https://pbs.twimg.com/profile_images/1768404732949733377/T_w4Y8-E_normal.jpg',
        screen_name: 'EonianFinance',
        verified: false,
        is_blue_verified: true,
        profile_image_shape: 'Circle',
      },
      edit_control: {
        edit_tweet_ids: ['1751444681634787806'],
        editable_until_msecs: '1706415527000',
        is_edit_eligible: true,
        edits_remaining: '5',
      },
      mediaDetails: [
        {
          additional_media_info: {},
          display_url: 'pic.twitter.com/L6KGKOAkQJ',
          expanded_url: 'https://twitter.com/EonianFinance/status/1751444681634787806/video/1',
          ext_media_availability: {
            status: 'Available',
          },
          indices: [220, 243],
          media_url_https: 'https://pbs.twimg.com/ext_tw_video_thumb/1751443920339226624/pu/img/M2wWH3j9NagQhB4p.jpg',
          original_info: {
            height: 1080,
            width: 1920,
            focus_rects: [],
          },
          sizes: {
            large: {
              h: 1080,
              resize: 'fit',
              w: 1920,
            },
            medium: {
              h: 675,
              resize: 'fit',
              w: 1200,
            },
            small: {
              h: 383,
              resize: 'fit',
              w: 680,
            },
            thumb: {
              h: 150,
              resize: 'crop',
              w: 150,
            },
          },
          type: 'video',
          url: 'https://t.co/L6KGKOAkQJ',
          video_info: {
            aspect_ratio: [16, 9],
            duration_millis: 26221,
            variants: [
              {
                content_type: 'application/x-mpegURL',
                url: 'https://video.twimg.com/ext_tw_video/1751443920339226624/pu/pl/5V9UUfMQpj2Is9tO.m3u8?tag=14',
              },
              {
                bitrate: 256000,
                content_type: 'video/mp4',
                url: 'https://video.twimg.com/ext_tw_video/1751443920339226624/pu/vid/avc1/480x270/hgqlrSCMAe91lext.mp4?tag=14',
              },
              {
                bitrate: 832000,
                content_type: 'video/mp4',
                url: 'https://video.twimg.com/ext_tw_video/1751443920339226624/pu/vid/avc1/640x360/QGmXdt2Y5iBrAyVR.mp4?tag=14',
              },
              {
                bitrate: 2176000,
                content_type: 'video/mp4',
                url: 'https://video.twimg.com/ext_tw_video/1751443920339226624/pu/vid/avc1/1280x720/kFv4jIOxO3dF12WE.mp4?tag=14',
              },
              {
                bitrate: 10368000,
                content_type: 'video/mp4',
                url: 'https://video.twimg.com/ext_tw_video/1751443920339226624/pu/vid/avc1/1920x1080/GWono6WDbJZs1sSX.mp4?tag=14',
              },
            ],
          },
        },
      ],
      photos: [],
      video: {
        aspectRatio: [16, 9],
        contentType: 'media_entity',
        durationMs: 26221,
        mediaAvailability: {
          status: 'available',
        },
        poster: 'https://pbs.twimg.com/ext_tw_video_thumb/1751443920339226624/pu/img/M2wWH3j9NagQhB4p.jpg',
        variants: [
          {
            type: 'application/x-mpegURL',
            src: 'https://video.twimg.com/ext_tw_video/1751443920339226624/pu/pl/5V9UUfMQpj2Is9tO.m3u8?tag=14',
          },
          {
            type: 'video/mp4',
            src: 'https://video.twimg.com/ext_tw_video/1751443920339226624/pu/vid/avc1/480x270/hgqlrSCMAe91lext.mp4?tag=14',
          },
          {
            type: 'video/mp4',
            src: 'https://video.twimg.com/ext_tw_video/1751443920339226624/pu/vid/avc1/640x360/QGmXdt2Y5iBrAyVR.mp4?tag=14',
          },
          {
            type: 'video/mp4',
            src: 'https://video.twimg.com/ext_tw_video/1751443920339226624/pu/vid/avc1/1280x720/kFv4jIOxO3dF12WE.mp4?tag=14',
          },
          {
            type: 'video/mp4',
            src: 'https://video.twimg.com/ext_tw_video/1751443920339226624/pu/vid/avc1/1920x1080/GWono6WDbJZs1sSX.mp4?tag=14',
          },
        ],
        videoId: {
          type: 'tweet',
          id: '1751444681634787806',
        },
        viewCount: 0,
      },
      isEdited: false,
      isStaleEdit: false,
    },
    isEdited: false,
    isStaleEdit: false,
  },
  '1789954693709336841': {
    __typename: 'Tweet',
    in_reply_to_screen_name: 'EonianFinance',
    in_reply_to_status_id_str: '1789924316739412125',
    in_reply_to_user_id_str: '1584314875991523328',
    lang: 'en',
    place: {
      full_name: 'Kosovo',
      id: 'ce840961e49976cf',
    },
    favorite_count: 0,
    created_at: '2024-05-13T09:43:49.000Z',
    display_text_range: [15, 41],
    entities: {
      hashtags: [],
      urls: [],
      user_mentions: [
        {
          id_str: '1584314875991523328',
          indices: [0, 14],
          name: 'Eonian',
          screen_name: 'EonianFinance',
        },
      ],
      symbols: [],
    },
    id_str: '1789954693709336841',
    text: '@EonianFinance something indeed is coming',
    user: {
      id_str: '387337141',
      name: 'Qazim Rama 🥷',
      profile_image_url_https: 'https://pbs.twimg.com/profile_images/1506332833857552394/Kwrt1V_6_normal.png',
      screen_name: 'qazim_rama',
      verified: false,
      is_blue_verified: false,
      profile_image_shape: 'Circle',
    },
    edit_control: {
      edit_tweet_ids: ['1789954693709336841'],
      editable_until_msecs: '1715597029000',
      is_edit_eligible: false,
      edits_remaining: '5',
    },
    conversation_count: 0,
    news_action_type: 'conversation',
    parent: {
      lang: 'en',
      reply_count: 35,
      retweet_count: 34,
      favorite_count: 38,
      possibly_sensitive: false,
      created_at: '2024-05-13T07:43:06.000Z',
      display_text_range: [0, 276],
      entities: {
        hashtags: [],
        urls: [],
        user_mentions: [],
        symbols: [],
        media: [
          {
            display_url: 'pic.x.com/r6tfmn7acr',
            expanded_url: 'https://twitter.com/EonianFinance/status/1789924316739412125/photo/1',
            indices: [277, 300],
            url: 'https://t.co/r6tfMn7Acr',
          },
        ],
      },
      id_str: '1789924316739412125',
      text: 'Open Beta Announce\nMore than a year ago, we launched our protocol in closed alpha. Since then, we have refined our solution, fixed many bugs, and added awesome features. That means very soon, we will be ready to launch our protocol in open beta and allow anyone to save their… https://t.co/r6tfMn7Acr',
      user: {
        id_str: '1584314875991523328',
        name: 'Eonian',
        profile_image_url_https: 'https://pbs.twimg.com/profile_images/1768404732949733377/T_w4Y8-E_normal.jpg',
        screen_name: 'EonianFinance',
        verified: false,
        is_blue_verified: true,
        profile_image_shape: 'Circle',
      },
      edit_control: {
        edit_tweet_ids: ['1789924316739412125'],
        editable_until_msecs: '1715589786000',
        is_edit_eligible: true,
        edits_remaining: '5',
      },
      mediaDetails: [
        {
          display_url: 'pic.twitter.com/r6tfMn7Acr',
          expanded_url: 'https://twitter.com/EonianFinance/status/1789924316739412125/photo/1',
          ext_media_availability: {
            status: 'Available',
          },
          indices: [277, 300],
          media_url_https: 'https://pbs.twimg.com/media/GNcWIa_W8AAvae_.jpg',
          original_info: {
            height: 1250,
            width: 1250,
            focus_rects: [
              {
                x: 0,
                y: 118,
                w: 1250,
                h: 700,
              },
              {
                x: 0,
                y: 0,
                w: 1250,
                h: 1250,
              },
              {
                x: 45,
                y: 0,
                w: 1096,
                h: 1250,
              },
              {
                x: 281,
                y: 0,
                w: 625,
                h: 1250,
              },
              {
                x: 0,
                y: 0,
                w: 1250,
                h: 1250,
              },
            ],
          },
          sizes: {
            large: {
              h: 1250,
              resize: 'fit',
              w: 1250,
            },
            medium: {
              h: 1200,
              resize: 'fit',
              w: 1200,
            },
            small: {
              h: 680,
              resize: 'fit',
              w: 680,
            },
            thumb: {
              h: 150,
              resize: 'crop',
              w: 150,
            },
          },
          type: 'photo',
          url: 'https://t.co/r6tfMn7Acr',
        },
      ],
      photos: [
        {
          backgroundColor: {
            red: 204,
            green: 214,
            blue: 221,
          },
          cropCandidates: [
            {
              x: 0,
              y: 118,
              w: 1250,
              h: 700,
            },
            {
              x: 0,
              y: 0,
              w: 1250,
              h: 1250,
            },
            {
              x: 45,
              y: 0,
              w: 1096,
              h: 1250,
            },
            {
              x: 281,
              y: 0,
              w: 625,
              h: 1250,
            },
            {
              x: 0,
              y: 0,
              w: 1250,
              h: 1250,
            },
          ],
          expandedUrl: 'https://twitter.com/EonianFinance/status/1789924316739412125/photo/1',
          url: 'https://pbs.twimg.com/media/GNcWIa_W8AAvae_.jpg',
          width: 1250,
          height: 1250,
        },
      ],
      isEdited: false,
      isStaleEdit: false,
    },
    isEdited: false,
    isStaleEdit: false,
  },
  '1697744396374950148': {
    __typename: 'Tweet',
    in_reply_to_screen_name: 'EonianFinance',
    in_reply_to_status_id_str: '1680276680319836162',
    in_reply_to_user_id_str: '1584314875991523328',
    lang: 'en',
    favorite_count: 0,
    created_at: '2023-09-01T22:53:01.000Z',
    display_text_range: [15, 31],
    entities: {
      hashtags: [],
      urls: [],
      user_mentions: [
        {
          id_str: '1584314875991523328',
          indices: [0, 14],
          name: 'Eonian',
          screen_name: 'EonianFinance',
        },
      ],
      symbols: [],
    },
    id_str: '1697744396374950148',
    text: '@EonianFinance Awesome guys🚀😍',
    user: {
      id_str: '1694673245948063745',
      name: 'sherrif bayo',
      profile_image_url_https: 'https://pbs.twimg.com/profile_images/1694673577847529472/jh3tMBGD_normal.jpg',
      screen_name: 'BayoSherri60626',
      verified: false,
      is_blue_verified: false,
      profile_image_shape: 'Circle',
    },
    edit_control: {
      edit_tweet_ids: ['1697744396374950148'],
      editable_until_msecs: '1693612381000',
      is_edit_eligible: false,
      edits_remaining: '5',
    },
    conversation_count: 0,
    news_action_type: 'conversation',
    parent: {
      lang: 'en',
      reply_count: 75,
      retweet_count: 49,
      favorite_count: 64,
      possibly_sensitive: false,
      created_at: '2023-07-15T18:02:33.000Z',
      display_text_range: [0, 279],
      entities: {
        hashtags: [],
        urls: [
          {
            display_url: 'leovs09.notion.site/Community-Rewa…',
            expanded_url: 'https://leovs09.notion.site/Community-Rewards-System-eaa37db4f9944fddabaf2bca1e1066a0',
            indices: [256, 279],
            url: 'https://t.co/KEl9uFuL53',
          },
        ],
        user_mentions: [],
        symbols: [],
      },
      id_str: '1680276680319836162',
      text: 'We are glad to announce the launch of Our Level-Up Channel &amp; Rewards System!\n\nGet reward for engaging in our community. Earn points to level up and gain new roles, to qualify for token retrodrops. Higher roles = bigger rewards\n\nMore info in our Docs : https://t.co/KEl9uFuL53',
      user: {
        id_str: '1584314875991523328',
        name: 'Eonian',
        profile_image_url_https: 'https://pbs.twimg.com/profile_images/1768404732949733377/T_w4Y8-E_normal.jpg',
        screen_name: 'EonianFinance',
        verified: false,
        is_blue_verified: true,
        profile_image_shape: 'Circle',
      },
      edit_control: {
        edit_tweet_ids: ['1680276680319836162'],
        editable_until_msecs: '1689447753000',
        is_edit_eligible: true,
        edits_remaining: '5',
      },
      card: {
        card_platform: {
          platform: {
            audience: {
              name: 'production',
            },
            device: {
              name: 'iPhone',
              version: '13',
            },
          },
        },
        name: 'summary_large_image',
        url: 'https://t.co/KEl9uFuL53',
        binding_values: {
          photo_image_full_size_large: {
            image_value: {
              height: 419,
              width: 800,
              url: 'https://pbs.twimg.com/card_img/1800430057942294529/3zHgWOy8?format=jpg&name=800x419',
            },
            type: 'IMAGE',
          },
          thumbnail_image: {
            image_value: {
              height: 144,
              width: 144,
              url: 'https://pbs.twimg.com/card_img/1800430057942294529/3zHgWOy8?format=jpg&name=144x144',
            },
            type: 'IMAGE',
          },
          description: {
            string_value: 'Welcome to our in-depth guide to our Rewards System in the Discord community.',
            type: 'STRING',
          },
          domain: {
            string_value: 'leovs09.notion.site',
            type: 'STRING',
          },
          thumbnail_image_large: {
            image_value: {
              height: 320,
              width: 320,
              url: 'https://pbs.twimg.com/card_img/1800430057942294529/3zHgWOy8?format=jpg&name=800x320_1',
            },
            type: 'IMAGE',
          },
          summary_photo_image_small: {
            image_value: {
              height: 202,
              width: 386,
              url: 'https://pbs.twimg.com/card_img/1800430057942294529/3zHgWOy8?format=jpg&name=386x202',
            },
            type: 'IMAGE',
          },
          thumbnail_image_original: {
            image_value: {
              height: 2000,
              width: 2000,
              url: 'https://pbs.twimg.com/card_img/1800430057942294529/3zHgWOy8?format=jpg&name=orig',
            },
            type: 'IMAGE',
          },
          photo_image_full_size_small: {
            image_value: {
              height: 202,
              width: 386,
              url: 'https://pbs.twimg.com/card_img/1800430057942294529/3zHgWOy8?format=jpg&name=386x202',
            },
            type: 'IMAGE',
          },
          summary_photo_image_large: {
            image_value: {
              height: 419,
              width: 800,
              url: 'https://pbs.twimg.com/card_img/1800430057942294529/3zHgWOy8?format=jpg&name=800x419',
            },
            type: 'IMAGE',
          },
          thumbnail_image_small: {
            image_value: {
              height: 100,
              width: 100,
              url: 'https://pbs.twimg.com/card_img/1800430057942294529/3zHgWOy8?format=jpg&name=100x100',
            },
            type: 'IMAGE',
          },
          thumbnail_image_x_large: {
            image_value: {
              height: 2000,
              width: 2000,
              url: 'https://pbs.twimg.com/card_img/1800430057942294529/3zHgWOy8?format=png&name=2048x2048_2_exp',
            },
            type: 'IMAGE',
          },
          photo_image_full_size_original: {
            image_value: {
              height: 2000,
              width: 2000,
              url: 'https://pbs.twimg.com/card_img/1800430057942294529/3zHgWOy8?format=jpg&name=orig',
            },
            type: 'IMAGE',
          },
          vanity_url: {
            scribe_key: 'vanity_url',
            string_value: 'leovs09.notion.site',
            type: 'STRING',
          },
          photo_image_full_size: {
            image_value: {
              height: 314,
              width: 600,
              url: 'https://pbs.twimg.com/card_img/1800430057942294529/3zHgWOy8?format=jpg&name=600x314',
            },
            type: 'IMAGE',
          },
          thumbnail_image_color: {
            image_color_value: {
              palette: [
                {
                  rgb: {
                    blue: 83,
                    green: 44,
                    red: 216,
                  },
                  percentage: 17.88,
                },
                {
                  rgb: {
                    blue: 115,
                    green: 60,
                    red: 193,
                  },
                  percentage: 16.71,
                },
                {
                  rgb: {
                    blue: 205,
                    green: 88,
                    red: 88,
                  },
                  percentage: 12.9,
                },
                {
                  rgb: {
                    blue: 148,
                    green: 70,
                    red: 159,
                  },
                  percentage: 12.13,
                },
                {
                  rgb: {
                    blue: 187,
                    green: 112,
                    red: 133,
                  },
                  percentage: 10,
                },
              ],
            },
            type: 'IMAGE_COLOR',
          },
          title: {
            string_value: 'Community Rewards System | Notion',
            type: 'STRING',
          },
          summary_photo_image_color: {
            image_color_value: {
              palette: [
                {
                  rgb: {
                    blue: 83,
                    green: 44,
                    red: 216,
                  },
                  percentage: 17.88,
                },
                {
                  rgb: {
                    blue: 115,
                    green: 60,
                    red: 193,
                  },
                  percentage: 16.71,
                },
                {
                  rgb: {
                    blue: 205,
                    green: 88,
                    red: 88,
                  },
                  percentage: 12.9,
                },
                {
                  rgb: {
                    blue: 148,
                    green: 70,
                    red: 159,
                  },
                  percentage: 12.13,
                },
                {
                  rgb: {
                    blue: 187,
                    green: 112,
                    red: 133,
                  },
                  percentage: 10,
                },
              ],
            },
            type: 'IMAGE_COLOR',
          },
          summary_photo_image_x_large: {
            image_value: {
              height: 2000,
              width: 2000,
              url: 'https://pbs.twimg.com/card_img/1800430057942294529/3zHgWOy8?format=png&name=2048x2048_2_exp',
            },
            type: 'IMAGE',
          },
          summary_photo_image: {
            image_value: {
              height: 314,
              width: 600,
              url: 'https://pbs.twimg.com/card_img/1800430057942294529/3zHgWOy8?format=jpg&name=600x314',
            },
            type: 'IMAGE',
          },
          photo_image_full_size_color: {
            image_color_value: {
              palette: [
                {
                  rgb: {
                    blue: 83,
                    green: 44,
                    red: 216,
                  },
                  percentage: 17.88,
                },
                {
                  rgb: {
                    blue: 115,
                    green: 60,
                    red: 193,
                  },
                  percentage: 16.71,
                },
                {
                  rgb: {
                    blue: 205,
                    green: 88,
                    red: 88,
                  },
                  percentage: 12.9,
                },
                {
                  rgb: {
                    blue: 148,
                    green: 70,
                    red: 159,
                  },
                  percentage: 12.13,
                },
                {
                  rgb: {
                    blue: 187,
                    green: 112,
                    red: 133,
                  },
                  percentage: 10,
                },
              ],
            },
            type: 'IMAGE_COLOR',
          },
          photo_image_full_size_x_large: {
            image_value: {
              height: 2000,
              width: 2000,
              url: 'https://pbs.twimg.com/card_img/1800430057942294529/3zHgWOy8?format=png&name=2048x2048_2_exp',
            },
            type: 'IMAGE',
          },
          card_url: {
            scribe_key: 'card_url',
            string_value: 'https://t.co/KEl9uFuL53',
            type: 'STRING',
          },
          summary_photo_image_original: {
            image_value: {
              height: 2000,
              width: 2000,
              url: 'https://pbs.twimg.com/card_img/1800430057942294529/3zHgWOy8?format=jpg&name=orig',
            },
            type: 'IMAGE',
          },
        },
      },
      isEdited: false,
      isStaleEdit: false,
    },
    isEdited: false,
    isStaleEdit: false,
  },
  '1790006969123607025': {
    __typename: 'Tweet',
    in_reply_to_screen_name: 'EonianFinance',
    in_reply_to_status_id_str: '1789924316739412125',
    in_reply_to_user_id_str: '1584314875991523328',
    lang: 'en',
    favorite_count: 0,
    created_at: '2024-05-13T13:11:32.000Z',
    display_text_range: [15, 74],
    entities: {
      hashtags: [],
      urls: [],
      user_mentions: [
        {
          id_str: '1584314875991523328',
          indices: [0, 14],
          name: 'Eonian',
          screen_name: 'EonianFinance',
        },
      ],
      symbols: [],
    },
    id_str: '1790006969123607025',
    text: '@EonianFinance I enthusiastically participate in this and also support it.',
    user: {
      id_str: '1751208246155644928',
      name: 'Viktor Zahar♦️Tabi',
      profile_image_url_https: 'https://pbs.twimg.com/profile_images/1751210115628195841/OmmlFZQf_normal.jpg',
      screen_name: 'ViktorZ90',
      verified: false,
      is_blue_verified: false,
      profile_image_shape: 'Circle',
    },
    edit_control: {
      edit_tweet_ids: ['1790006969123607025'],
      editable_until_msecs: '1715609492000',
      is_edit_eligible: false,
      edits_remaining: '5',
    },
    conversation_count: 0,
    news_action_type: 'conversation',
    parent: {
      lang: 'en',
      reply_count: 35,
      retweet_count: 34,
      favorite_count: 38,
      possibly_sensitive: false,
      created_at: '2024-05-13T07:43:06.000Z',
      display_text_range: [0, 276],
      entities: {
        hashtags: [],
        urls: [],
        user_mentions: [],
        symbols: [],
        media: [
          {
            display_url: 'pic.x.com/r6tfmn7acr',
            expanded_url: 'https://twitter.com/EonianFinance/status/1789924316739412125/photo/1',
            indices: [277, 300],
            url: 'https://t.co/r6tfMn7Acr',
          },
        ],
      },
      id_str: '1789924316739412125',
      text: 'Open Beta Announce\nMore than a year ago, we launched our protocol in closed alpha. Since then, we have refined our solution, fixed many bugs, and added awesome features. That means very soon, we will be ready to launch our protocol in open beta and allow anyone to save their… https://t.co/r6tfMn7Acr',
      user: {
        id_str: '1584314875991523328',
        name: 'Eonian',
        profile_image_url_https: 'https://pbs.twimg.com/profile_images/1768404732949733377/T_w4Y8-E_normal.jpg',
        screen_name: 'EonianFinance',
        verified: false,
        is_blue_verified: true,
        profile_image_shape: 'Circle',
      },
      edit_control: {
        edit_tweet_ids: ['1789924316739412125'],
        editable_until_msecs: '1715589786000',
        is_edit_eligible: true,
        edits_remaining: '5',
      },
      mediaDetails: [
        {
          display_url: 'pic.twitter.com/r6tfMn7Acr',
          expanded_url: 'https://twitter.com/EonianFinance/status/1789924316739412125/photo/1',
          ext_media_availability: {
            status: 'Available',
          },
          indices: [277, 300],
          media_url_https: 'https://pbs.twimg.com/media/GNcWIa_W8AAvae_.jpg',
          original_info: {
            height: 1250,
            width: 1250,
            focus_rects: [
              {
                x: 0,
                y: 118,
                w: 1250,
                h: 700,
              },
              {
                x: 0,
                y: 0,
                w: 1250,
                h: 1250,
              },
              {
                x: 45,
                y: 0,
                w: 1096,
                h: 1250,
              },
              {
                x: 281,
                y: 0,
                w: 625,
                h: 1250,
              },
              {
                x: 0,
                y: 0,
                w: 1250,
                h: 1250,
              },
            ],
          },
          sizes: {
            large: {
              h: 1250,
              resize: 'fit',
              w: 1250,
            },
            medium: {
              h: 1200,
              resize: 'fit',
              w: 1200,
            },
            small: {
              h: 680,
              resize: 'fit',
              w: 680,
            },
            thumb: {
              h: 150,
              resize: 'crop',
              w: 150,
            },
          },
          type: 'photo',
          url: 'https://t.co/r6tfMn7Acr',
        },
      ],
      photos: [
        {
          backgroundColor: {
            red: 204,
            green: 214,
            blue: 221,
          },
          cropCandidates: [
            {
              x: 0,
              y: 118,
              w: 1250,
              h: 700,
            },
            {
              x: 0,
              y: 0,
              w: 1250,
              h: 1250,
            },
            {
              x: 45,
              y: 0,
              w: 1096,
              h: 1250,
            },
            {
              x: 281,
              y: 0,
              w: 625,
              h: 1250,
            },
            {
              x: 0,
              y: 0,
              w: 1250,
              h: 1250,
            },
          ],
          expandedUrl: 'https://twitter.com/EonianFinance/status/1789924316739412125/photo/1',
          url: 'https://pbs.twimg.com/media/GNcWIa_W8AAvae_.jpg',
          width: 1250,
          height: 1250,
        },
      ],
      isEdited: false,
      isStaleEdit: false,
    },
    isEdited: false,
    isStaleEdit: false,
  },
  '1765167523941826602': {
    __typename: 'Tweet',
    in_reply_to_screen_name: 'EonianFinance',
    in_reply_to_status_id_str: '1751444681634787806',
    in_reply_to_user_id_str: '1584314875991523328',
    lang: 'en',
    favorite_count: 0,
    created_at: '2024-03-06T00:08:27.000Z',
    display_text_range: [15, 34],
    entities: {
      hashtags: [],
      urls: [],
      user_mentions: [
        {
          id_str: '1584314875991523328',
          indices: [0, 14],
          name: 'Eonian',
          screen_name: 'EonianFinance',
        },
      ],
      symbols: [],
    },
    id_str: '1765167523941826602',
    text: '@EonianFinance great potential LFG',
    user: {
      id_str: '1738679854193868800',
      name: 'nicu',
      profile_image_url_https: 'https://pbs.twimg.com/profile_images/1750820710334013441/4Wvjs3EP_normal.jpg',
      screen_name: 'much_sin24',
      verified: false,
      is_blue_verified: false,
      profile_image_shape: 'Circle',
    },
    edit_control: {
      edit_tweet_ids: ['1765167523941826602'],
      editable_until_msecs: '1709687307000',
      is_edit_eligible: false,
      edits_remaining: '5',
    },
    conversation_count: 0,
    news_action_type: 'conversation',
    parent: {
      lang: 'en',
      reply_count: 119,
      retweet_count: 224,
      favorite_count: 310,
      possibly_sensitive: false,
      created_at: '2024-01-28T03:18:47.000Z',
      display_text_range: [0, 219],
      entities: {
        hashtags: [
          {
            indices: [58, 65],
            text: 'crypto',
          },
        ],
        urls: [
          {
            display_url: 'eonian.finance',
            expanded_url: 'https://eonian.finance',
            indices: [196, 219],
            url: 'https://t.co/ieieSlLHh5',
          },
        ],
        user_mentions: [],
        symbols: [],
        media: [
          {
            display_url: 'pic.x.com/l6kgkoakqj',
            expanded_url: 'https://twitter.com/EonianFinance/status/1751444681634787806/video/1',
            indices: [220, 243],
            url: 'https://t.co/L6KGKOAkQJ',
          },
        ],
      },
      id_str: '1751444681634787806',
      text: 'Launch of First Decentralized Savings Account\nInsure your #crypto from wallet hacks with zero fees, while passively earning savings premium on your holdings.\n\nLearn more and keep your money safe: https://t.co/ieieSlLHh5 https://t.co/L6KGKOAkQJ',
      user: {
        id_str: '1584314875991523328',
        name: 'Eonian',
        profile_image_url_https: 'https://pbs.twimg.com/profile_images/1768404732949733377/T_w4Y8-E_normal.jpg',
        screen_name: 'EonianFinance',
        verified: false,
        is_blue_verified: true,
        profile_image_shape: 'Circle',
      },
      edit_control: {
        edit_tweet_ids: ['1751444681634787806'],
        editable_until_msecs: '1706415527000',
        is_edit_eligible: true,
        edits_remaining: '5',
      },
      mediaDetails: [
        {
          additional_media_info: {},
          display_url: 'pic.twitter.com/L6KGKOAkQJ',
          expanded_url: 'https://twitter.com/EonianFinance/status/1751444681634787806/video/1',
          ext_media_availability: {
            status: 'Available',
          },
          indices: [220, 243],
          media_url_https: 'https://pbs.twimg.com/ext_tw_video_thumb/1751443920339226624/pu/img/M2wWH3j9NagQhB4p.jpg',
          original_info: {
            height: 1080,
            width: 1920,
            focus_rects: [],
          },
          sizes: {
            large: {
              h: 1080,
              resize: 'fit',
              w: 1920,
            },
            medium: {
              h: 675,
              resize: 'fit',
              w: 1200,
            },
            small: {
              h: 383,
              resize: 'fit',
              w: 680,
            },
            thumb: {
              h: 150,
              resize: 'crop',
              w: 150,
            },
          },
          type: 'video',
          url: 'https://t.co/L6KGKOAkQJ',
          video_info: {
            aspect_ratio: [16, 9],
            duration_millis: 26221,
            variants: [
              {
                content_type: 'application/x-mpegURL',
                url: 'https://video.twimg.com/ext_tw_video/1751443920339226624/pu/pl/5V9UUfMQpj2Is9tO.m3u8?tag=14',
              },
              {
                bitrate: 256000,
                content_type: 'video/mp4',
                url: 'https://video.twimg.com/ext_tw_video/1751443920339226624/pu/vid/avc1/480x270/hgqlrSCMAe91lext.mp4?tag=14',
              },
              {
                bitrate: 832000,
                content_type: 'video/mp4',
                url: 'https://video.twimg.com/ext_tw_video/1751443920339226624/pu/vid/avc1/640x360/QGmXdt2Y5iBrAyVR.mp4?tag=14',
              },
              {
                bitrate: 2176000,
                content_type: 'video/mp4',
                url: 'https://video.twimg.com/ext_tw_video/1751443920339226624/pu/vid/avc1/1280x720/kFv4jIOxO3dF12WE.mp4?tag=14',
              },
              {
                bitrate: 10368000,
                content_type: 'video/mp4',
                url: 'https://video.twimg.com/ext_tw_video/1751443920339226624/pu/vid/avc1/1920x1080/GWono6WDbJZs1sSX.mp4?tag=14',
              },
            ],
          },
        },
      ],
      photos: [],
      video: {
        aspectRatio: [16, 9],
        contentType: 'media_entity',
        durationMs: 26221,
        mediaAvailability: {
          status: 'available',
        },
        poster: 'https://pbs.twimg.com/ext_tw_video_thumb/1751443920339226624/pu/img/M2wWH3j9NagQhB4p.jpg',
        variants: [
          {
            type: 'application/x-mpegURL',
            src: 'https://video.twimg.com/ext_tw_video/1751443920339226624/pu/pl/5V9UUfMQpj2Is9tO.m3u8?tag=14',
          },
          {
            type: 'video/mp4',
            src: 'https://video.twimg.com/ext_tw_video/1751443920339226624/pu/vid/avc1/480x270/hgqlrSCMAe91lext.mp4?tag=14',
          },
          {
            type: 'video/mp4',
            src: 'https://video.twimg.com/ext_tw_video/1751443920339226624/pu/vid/avc1/640x360/QGmXdt2Y5iBrAyVR.mp4?tag=14',
          },
          {
            type: 'video/mp4',
            src: 'https://video.twimg.com/ext_tw_video/1751443920339226624/pu/vid/avc1/1280x720/kFv4jIOxO3dF12WE.mp4?tag=14',
          },
          {
            type: 'video/mp4',
            src: 'https://video.twimg.com/ext_tw_video/1751443920339226624/pu/vid/avc1/1920x1080/GWono6WDbJZs1sSX.mp4?tag=14',
          },
        ],
        videoId: {
          type: 'tweet',
          id: '1751444681634787806',
        },
        viewCount: 0,
      },
      isEdited: false,
      isStaleEdit: false,
    },
    isEdited: false,
    isStaleEdit: false,
  },
  '1697593964205879635': {
    __typename: 'Tweet',
    in_reply_to_screen_name: 'EonianFinance',
    in_reply_to_status_id_str: '1680276680319836162',
    in_reply_to_user_id_str: '1584314875991523328',
    lang: 'en',
    favorite_count: 0,
    created_at: '2023-09-01T12:55:15.000Z',
    display_text_range: [15, 66],
    entities: {
      hashtags: [],
      urls: [],
      user_mentions: [
        {
          id_str: '1584314875991523328',
          indices: [0, 14],
          name: 'Eonian',
          screen_name: 'EonianFinance',
        },
      ],
      symbols: [],
    },
    id_str: '1697593964205879635',
    text: '@EonianFinance Guys, you can\'t miss this, get engage while earning',
    user: {
      id_str: '1481494764927307776',
      name: 'Awasiakan Udo',
      profile_image_url_https: 'https://pbs.twimg.com/profile_images/1788583962845032448/0d_Y2SCW_normal.jpg',
      screen_name: 'AwasiakanUdo',
      verified: false,
      is_blue_verified: false,
      profile_image_shape: 'Circle',
    },
    edit_control: {
      edit_tweet_ids: ['1697593964205879635'],
      editable_until_msecs: '1693576515000',
      is_edit_eligible: false,
      edits_remaining: '5',
    },
    conversation_count: 0,
    news_action_type: 'conversation',
    parent: {
      lang: 'en',
      reply_count: 75,
      retweet_count: 49,
      favorite_count: 64,
      possibly_sensitive: false,
      created_at: '2023-07-15T18:02:33.000Z',
      display_text_range: [0, 279],
      entities: {
        hashtags: [],
        urls: [
          {
            display_url: 'leovs09.notion.site/Community-Rewa…',
            expanded_url: 'https://leovs09.notion.site/Community-Rewards-System-eaa37db4f9944fddabaf2bca1e1066a0',
            indices: [256, 279],
            url: 'https://t.co/KEl9uFuL53',
          },
        ],
        user_mentions: [],
        symbols: [],
      },
      id_str: '1680276680319836162',
      text: 'We are glad to announce the launch of Our Level-Up Channel &amp; Rewards System!\n\nGet reward for engaging in our community. Earn points to level up and gain new roles, to qualify for token retrodrops. Higher roles = bigger rewards\n\nMore info in our Docs : https://t.co/KEl9uFuL53',
      user: {
        id_str: '1584314875991523328',
        name: 'Eonian',
        profile_image_url_https: 'https://pbs.twimg.com/profile_images/1768404732949733377/T_w4Y8-E_normal.jpg',
        screen_name: 'EonianFinance',
        verified: false,
        is_blue_verified: true,
        profile_image_shape: 'Circle',
      },
      edit_control: {
        edit_tweet_ids: ['1680276680319836162'],
        editable_until_msecs: '1689447753000',
        is_edit_eligible: true,
        edits_remaining: '5',
      },
      card: {
        card_platform: {
          platform: {
            audience: {
              name: 'production',
            },
            device: {
              name: 'iPhone',
              version: '13',
            },
          },
        },
        name: 'summary_large_image',
        url: 'https://t.co/KEl9uFuL53',
        binding_values: {
          photo_image_full_size_large: {
            image_value: {
              height: 419,
              width: 800,
              url: 'https://pbs.twimg.com/card_img/1800430057942294529/3zHgWOy8?format=jpg&name=800x419',
            },
            type: 'IMAGE',
          },
          thumbnail_image: {
            image_value: {
              height: 144,
              width: 144,
              url: 'https://pbs.twimg.com/card_img/1800430057942294529/3zHgWOy8?format=jpg&name=144x144',
            },
            type: 'IMAGE',
          },
          description: {
            string_value: 'Welcome to our in-depth guide to our Rewards System in the Discord community.',
            type: 'STRING',
          },
          domain: {
            string_value: 'leovs09.notion.site',
            type: 'STRING',
          },
          thumbnail_image_large: {
            image_value: {
              height: 320,
              width: 320,
              url: 'https://pbs.twimg.com/card_img/1800430057942294529/3zHgWOy8?format=jpg&name=800x320_1',
            },
            type: 'IMAGE',
          },
          summary_photo_image_small: {
            image_value: {
              height: 202,
              width: 386,
              url: 'https://pbs.twimg.com/card_img/1800430057942294529/3zHgWOy8?format=jpg&name=386x202',
            },
            type: 'IMAGE',
          },
          thumbnail_image_original: {
            image_value: {
              height: 2000,
              width: 2000,
              url: 'https://pbs.twimg.com/card_img/1800430057942294529/3zHgWOy8?format=jpg&name=orig',
            },
            type: 'IMAGE',
          },
          photo_image_full_size_small: {
            image_value: {
              height: 202,
              width: 386,
              url: 'https://pbs.twimg.com/card_img/1800430057942294529/3zHgWOy8?format=jpg&name=386x202',
            },
            type: 'IMAGE',
          },
          summary_photo_image_large: {
            image_value: {
              height: 419,
              width: 800,
              url: 'https://pbs.twimg.com/card_img/1800430057942294529/3zHgWOy8?format=jpg&name=800x419',
            },
            type: 'IMAGE',
          },
          thumbnail_image_small: {
            image_value: {
              height: 100,
              width: 100,
              url: 'https://pbs.twimg.com/card_img/1800430057942294529/3zHgWOy8?format=jpg&name=100x100',
            },
            type: 'IMAGE',
          },
          thumbnail_image_x_large: {
            image_value: {
              height: 2000,
              width: 2000,
              url: 'https://pbs.twimg.com/card_img/1800430057942294529/3zHgWOy8?format=png&name=2048x2048_2_exp',
            },
            type: 'IMAGE',
          },
          photo_image_full_size_original: {
            image_value: {
              height: 2000,
              width: 2000,
              url: 'https://pbs.twimg.com/card_img/1800430057942294529/3zHgWOy8?format=jpg&name=orig',
            },
            type: 'IMAGE',
          },
          vanity_url: {
            scribe_key: 'vanity_url',
            string_value: 'leovs09.notion.site',
            type: 'STRING',
          },
          photo_image_full_size: {
            image_value: {
              height: 314,
              width: 600,
              url: 'https://pbs.twimg.com/card_img/1800430057942294529/3zHgWOy8?format=jpg&name=600x314',
            },
            type: 'IMAGE',
          },
          thumbnail_image_color: {
            image_color_value: {
              palette: [
                {
                  rgb: {
                    blue: 83,
                    green: 44,
                    red: 216,
                  },
                  percentage: 17.88,
                },
                {
                  rgb: {
                    blue: 115,
                    green: 60,
                    red: 193,
                  },
                  percentage: 16.71,
                },
                {
                  rgb: {
                    blue: 205,
                    green: 88,
                    red: 88,
                  },
                  percentage: 12.9,
                },
                {
                  rgb: {
                    blue: 148,
                    green: 70,
                    red: 159,
                  },
                  percentage: 12.13,
                },
                {
                  rgb: {
                    blue: 187,
                    green: 112,
                    red: 133,
                  },
                  percentage: 10,
                },
              ],
            },
            type: 'IMAGE_COLOR',
          },
          title: {
            string_value: 'Community Rewards System | Notion',
            type: 'STRING',
          },
          summary_photo_image_color: {
            image_color_value: {
              palette: [
                {
                  rgb: {
                    blue: 83,
                    green: 44,
                    red: 216,
                  },
                  percentage: 17.88,
                },
                {
                  rgb: {
                    blue: 115,
                    green: 60,
                    red: 193,
                  },
                  percentage: 16.71,
                },
                {
                  rgb: {
                    blue: 205,
                    green: 88,
                    red: 88,
                  },
                  percentage: 12.9,
                },
                {
                  rgb: {
                    blue: 148,
                    green: 70,
                    red: 159,
                  },
                  percentage: 12.13,
                },
                {
                  rgb: {
                    blue: 187,
                    green: 112,
                    red: 133,
                  },
                  percentage: 10,
                },
              ],
            },
            type: 'IMAGE_COLOR',
          },
          summary_photo_image_x_large: {
            image_value: {
              height: 2000,
              width: 2000,
              url: 'https://pbs.twimg.com/card_img/1800430057942294529/3zHgWOy8?format=png&name=2048x2048_2_exp',
            },
            type: 'IMAGE',
          },
          summary_photo_image: {
            image_value: {
              height: 314,
              width: 600,
              url: 'https://pbs.twimg.com/card_img/1800430057942294529/3zHgWOy8?format=jpg&name=600x314',
            },
            type: 'IMAGE',
          },
          photo_image_full_size_color: {
            image_color_value: {
              palette: [
                {
                  rgb: {
                    blue: 83,
                    green: 44,
                    red: 216,
                  },
                  percentage: 17.88,
                },
                {
                  rgb: {
                    blue: 115,
                    green: 60,
                    red: 193,
                  },
                  percentage: 16.71,
                },
                {
                  rgb: {
                    blue: 205,
                    green: 88,
                    red: 88,
                  },
                  percentage: 12.9,
                },
                {
                  rgb: {
                    blue: 148,
                    green: 70,
                    red: 159,
                  },
                  percentage: 12.13,
                },
                {
                  rgb: {
                    blue: 187,
                    green: 112,
                    red: 133,
                  },
                  percentage: 10,
                },
              ],
            },
            type: 'IMAGE_COLOR',
          },
          photo_image_full_size_x_large: {
            image_value: {
              height: 2000,
              width: 2000,
              url: 'https://pbs.twimg.com/card_img/1800430057942294529/3zHgWOy8?format=png&name=2048x2048_2_exp',
            },
            type: 'IMAGE',
          },
          card_url: {
            scribe_key: 'card_url',
            string_value: 'https://t.co/KEl9uFuL53',
            type: 'STRING',
          },
          summary_photo_image_original: {
            image_value: {
              height: 2000,
              width: 2000,
              url: 'https://pbs.twimg.com/card_img/1800430057942294529/3zHgWOy8?format=jpg&name=orig',
            },
            type: 'IMAGE',
          },
        },
      },
      isEdited: false,
      isStaleEdit: false,
    },
    isEdited: false,
    isStaleEdit: false,
  },
  '1700279948542370236': {
    __typename: 'Tweet',
    in_reply_to_screen_name: 'EonianFinance',
    in_reply_to_status_id_str: '1680276680319836162',
    in_reply_to_user_id_str: '1584314875991523328',
    lang: 'en',
    favorite_count: 0,
    created_at: '2023-09-08T22:48:24.000Z',
    display_text_range: [15, 40],
    entities: {
      hashtags: [],
      urls: [],
      user_mentions: [
        {
          id_str: '1584314875991523328',
          indices: [0, 14],
          name: 'Eonian',
          screen_name: 'EonianFinance',
        },
      ],
      symbols: [],
    },
    id_str: '1700279948542370236',
    text: '@EonianFinance I am joining this project',
    user: {
      id_str: '1699461723810328576',
      name: 'Alexandra adedayo',
      profile_image_url_https: 'https://pbs.twimg.com/profile_images/1699462002278572032/AjS7A7_F_normal.jpg',
      screen_name: 'Alexandrabayoo',
      verified: false,
      is_blue_verified: false,
      profile_image_shape: 'Circle',
    },
    edit_control: {
      edit_tweet_ids: ['1700279948542370236'],
      editable_until_msecs: '1694216904000',
      is_edit_eligible: false,
      edits_remaining: '5',
    },
    conversation_count: 0,
    news_action_type: 'conversation',
    parent: {
      lang: 'en',
      reply_count: 75,
      retweet_count: 49,
      favorite_count: 64,
      possibly_sensitive: false,
      created_at: '2023-07-15T18:02:33.000Z',
      display_text_range: [0, 279],
      entities: {
        hashtags: [],
        urls: [
          {
            display_url: 'leovs09.notion.site/Community-Rewa…',
            expanded_url: 'https://leovs09.notion.site/Community-Rewards-System-eaa37db4f9944fddabaf2bca1e1066a0',
            indices: [256, 279],
            url: 'https://t.co/KEl9uFuL53',
          },
        ],
        user_mentions: [],
        symbols: [],
      },
      id_str: '1680276680319836162',
      text: 'We are glad to announce the launch of Our Level-Up Channel &amp; Rewards System!\n\nGet reward for engaging in our community. Earn points to level up and gain new roles, to qualify for token retrodrops. Higher roles = bigger rewards\n\nMore info in our Docs : https://t.co/KEl9uFuL53',
      user: {
        id_str: '1584314875991523328',
        name: 'Eonian',
        profile_image_url_https: 'https://pbs.twimg.com/profile_images/1768404732949733377/T_w4Y8-E_normal.jpg',
        screen_name: 'EonianFinance',
        verified: false,
        is_blue_verified: true,
        profile_image_shape: 'Circle',
      },
      edit_control: {
        edit_tweet_ids: ['1680276680319836162'],
        editable_until_msecs: '1689447753000',
        is_edit_eligible: true,
        edits_remaining: '5',
      },
      card: {
        card_platform: {
          platform: {
            audience: {
              name: 'production',
            },
            device: {
              name: 'iPhone',
              version: '13',
            },
          },
        },
        name: 'summary_large_image',
        url: 'https://t.co/KEl9uFuL53',
        binding_values: {
          photo_image_full_size_large: {
            image_value: {
              height: 419,
              width: 800,
              url: 'https://pbs.twimg.com/card_img/1800430057942294529/3zHgWOy8?format=jpg&name=800x419',
            },
            type: 'IMAGE',
          },
          thumbnail_image: {
            image_value: {
              height: 144,
              width: 144,
              url: 'https://pbs.twimg.com/card_img/1800430057942294529/3zHgWOy8?format=jpg&name=144x144',
            },
            type: 'IMAGE',
          },
          description: {
            string_value: 'Welcome to our in-depth guide to our Rewards System in the Discord community.',
            type: 'STRING',
          },
          domain: {
            string_value: 'leovs09.notion.site',
            type: 'STRING',
          },
          thumbnail_image_large: {
            image_value: {
              height: 320,
              width: 320,
              url: 'https://pbs.twimg.com/card_img/1800430057942294529/3zHgWOy8?format=jpg&name=800x320_1',
            },
            type: 'IMAGE',
          },
          summary_photo_image_small: {
            image_value: {
              height: 202,
              width: 386,
              url: 'https://pbs.twimg.com/card_img/1800430057942294529/3zHgWOy8?format=jpg&name=386x202',
            },
            type: 'IMAGE',
          },
          thumbnail_image_original: {
            image_value: {
              height: 2000,
              width: 2000,
              url: 'https://pbs.twimg.com/card_img/1800430057942294529/3zHgWOy8?format=jpg&name=orig',
            },
            type: 'IMAGE',
          },
          photo_image_full_size_small: {
            image_value: {
              height: 202,
              width: 386,
              url: 'https://pbs.twimg.com/card_img/1800430057942294529/3zHgWOy8?format=jpg&name=386x202',
            },
            type: 'IMAGE',
          },
          summary_photo_image_large: {
            image_value: {
              height: 419,
              width: 800,
              url: 'https://pbs.twimg.com/card_img/1800430057942294529/3zHgWOy8?format=jpg&name=800x419',
            },
            type: 'IMAGE',
          },
          thumbnail_image_small: {
            image_value: {
              height: 100,
              width: 100,
              url: 'https://pbs.twimg.com/card_img/1800430057942294529/3zHgWOy8?format=jpg&name=100x100',
            },
            type: 'IMAGE',
          },
          thumbnail_image_x_large: {
            image_value: {
              height: 2000,
              width: 2000,
              url: 'https://pbs.twimg.com/card_img/1800430057942294529/3zHgWOy8?format=png&name=2048x2048_2_exp',
            },
            type: 'IMAGE',
          },
          photo_image_full_size_original: {
            image_value: {
              height: 2000,
              width: 2000,
              url: 'https://pbs.twimg.com/card_img/1800430057942294529/3zHgWOy8?format=jpg&name=orig',
            },
            type: 'IMAGE',
          },
          vanity_url: {
            scribe_key: 'vanity_url',
            string_value: 'leovs09.notion.site',
            type: 'STRING',
          },
          photo_image_full_size: {
            image_value: {
              height: 314,
              width: 600,
              url: 'https://pbs.twimg.com/card_img/1800430057942294529/3zHgWOy8?format=jpg&name=600x314',
            },
            type: 'IMAGE',
          },
          thumbnail_image_color: {
            image_color_value: {
              palette: [
                {
                  rgb: {
                    blue: 83,
                    green: 44,
                    red: 216,
                  },
                  percentage: 17.88,
                },
                {
                  rgb: {
                    blue: 115,
                    green: 60,
                    red: 193,
                  },
                  percentage: 16.71,
                },
                {
                  rgb: {
                    blue: 205,
                    green: 88,
                    red: 88,
                  },
                  percentage: 12.9,
                },
                {
                  rgb: {
                    blue: 148,
                    green: 70,
                    red: 159,
                  },
                  percentage: 12.13,
                },
                {
                  rgb: {
                    blue: 187,
                    green: 112,
                    red: 133,
                  },
                  percentage: 10,
                },
              ],
            },
            type: 'IMAGE_COLOR',
          },
          title: {
            string_value: 'Community Rewards System | Notion',
            type: 'STRING',
          },
          summary_photo_image_color: {
            image_color_value: {
              palette: [
                {
                  rgb: {
                    blue: 83,
                    green: 44,
                    red: 216,
                  },
                  percentage: 17.88,
                },
                {
                  rgb: {
                    blue: 115,
                    green: 60,
                    red: 193,
                  },
                  percentage: 16.71,
                },
                {
                  rgb: {
                    blue: 205,
                    green: 88,
                    red: 88,
                  },
                  percentage: 12.9,
                },
                {
                  rgb: {
                    blue: 148,
                    green: 70,
                    red: 159,
                  },
                  percentage: 12.13,
                },
                {
                  rgb: {
                    blue: 187,
                    green: 112,
                    red: 133,
                  },
                  percentage: 10,
                },
              ],
            },
            type: 'IMAGE_COLOR',
          },
          summary_photo_image_x_large: {
            image_value: {
              height: 2000,
              width: 2000,
              url: 'https://pbs.twimg.com/card_img/1800430057942294529/3zHgWOy8?format=png&name=2048x2048_2_exp',
            },
            type: 'IMAGE',
          },
          summary_photo_image: {
            image_value: {
              height: 314,
              width: 600,
              url: 'https://pbs.twimg.com/card_img/1800430057942294529/3zHgWOy8?format=jpg&name=600x314',
            },
            type: 'IMAGE',
          },
          photo_image_full_size_color: {
            image_color_value: {
              palette: [
                {
                  rgb: {
                    blue: 83,
                    green: 44,
                    red: 216,
                  },
                  percentage: 17.88,
                },
                {
                  rgb: {
                    blue: 115,
                    green: 60,
                    red: 193,
                  },
                  percentage: 16.71,
                },
                {
                  rgb: {
                    blue: 205,
                    green: 88,
                    red: 88,
                  },
                  percentage: 12.9,
                },
                {
                  rgb: {
                    blue: 148,
                    green: 70,
                    red: 159,
                  },
                  percentage: 12.13,
                },
                {
                  rgb: {
                    blue: 187,
                    green: 112,
                    red: 133,
                  },
                  percentage: 10,
                },
              ],
            },
            type: 'IMAGE_COLOR',
          },
          photo_image_full_size_x_large: {
            image_value: {
              height: 2000,
              width: 2000,
              url: 'https://pbs.twimg.com/card_img/1800430057942294529/3zHgWOy8?format=png&name=2048x2048_2_exp',
            },
            type: 'IMAGE',
          },
          card_url: {
            scribe_key: 'card_url',
            string_value: 'https://t.co/KEl9uFuL53',
            type: 'STRING',
          },
          summary_photo_image_original: {
            image_value: {
              height: 2000,
              width: 2000,
              url: 'https://pbs.twimg.com/card_img/1800430057942294529/3zHgWOy8?format=jpg&name=orig',
            },
            type: 'IMAGE',
          },
        },
      },
      isEdited: false,
      isStaleEdit: false,
    },
    isEdited: false,
    isStaleEdit: false,
  },
  '1790174258187923940': {
    __typename: 'Tweet',
    in_reply_to_screen_name: 'EonianFinance',
    in_reply_to_status_id_str: '1789924316739412125',
    in_reply_to_user_id_str: '1584314875991523328',
    lang: 'en',
    favorite_count: 0,
    created_at: '2024-05-14T00:16:17.000Z',
    display_text_range: [15, 61],
    entities: {
      hashtags: [],
      urls: [],
      user_mentions: [
        {
          id_str: '1584314875991523328',
          indices: [0, 14],
          name: 'Eonian',
          screen_name: 'EonianFinance',
        },
      ],
      symbols: [],
    },
    id_str: '1790174258187923940',
    text: '@EonianFinance Finally the highly anticipated news is here 🥰',
    user: {
      id_str: '1676632239814180871',
      name: 'William | DATSProject | #Voiagers 🦆',
      profile_image_url_https: 'https://pbs.twimg.com/profile_images/1788687179448803328/RyuVx_LP_normal.jpg',
      screen_name: 'William299905',
      verified: false,
      is_blue_verified: false,
      profile_image_shape: 'Circle',
    },
    edit_control: {
      edit_tweet_ids: ['1790174258187923940'],
      editable_until_msecs: '1715649377000',
      is_edit_eligible: false,
      edits_remaining: '5',
    },
    conversation_count: 0,
    news_action_type: 'conversation',
    parent: {
      lang: 'en',
      reply_count: 35,
      retweet_count: 34,
      favorite_count: 38,
      possibly_sensitive: false,
      created_at: '2024-05-13T07:43:06.000Z',
      display_text_range: [0, 276],
      entities: {
        hashtags: [],
        urls: [],
        user_mentions: [],
        symbols: [],
        media: [
          {
            display_url: 'pic.x.com/r6tfmn7acr',
            expanded_url: 'https://twitter.com/EonianFinance/status/1789924316739412125/photo/1',
            indices: [277, 300],
            url: 'https://t.co/r6tfMn7Acr',
          },
        ],
      },
      id_str: '1789924316739412125',
      text: 'Open Beta Announce\nMore than a year ago, we launched our protocol in closed alpha. Since then, we have refined our solution, fixed many bugs, and added awesome features. That means very soon, we will be ready to launch our protocol in open beta and allow anyone to save their… https://t.co/r6tfMn7Acr',
      user: {
        id_str: '1584314875991523328',
        name: 'Eonian',
        profile_image_url_https: 'https://pbs.twimg.com/profile_images/1768404732949733377/T_w4Y8-E_normal.jpg',
        screen_name: 'EonianFinance',
        verified: false,
        is_blue_verified: true,
        profile_image_shape: 'Circle',
      },
      edit_control: {
        edit_tweet_ids: ['1789924316739412125'],
        editable_until_msecs: '1715589786000',
        is_edit_eligible: true,
        edits_remaining: '5',
      },
      mediaDetails: [
        {
          display_url: 'pic.twitter.com/r6tfMn7Acr',
          expanded_url: 'https://twitter.com/EonianFinance/status/1789924316739412125/photo/1',
          ext_media_availability: {
            status: 'Available',
          },
          indices: [277, 300],
          media_url_https: 'https://pbs.twimg.com/media/GNcWIa_W8AAvae_.jpg',
          original_info: {
            height: 1250,
            width: 1250,
            focus_rects: [
              {
                x: 0,
                y: 118,
                w: 1250,
                h: 700,
              },
              {
                x: 0,
                y: 0,
                w: 1250,
                h: 1250,
              },
              {
                x: 45,
                y: 0,
                w: 1096,
                h: 1250,
              },
              {
                x: 281,
                y: 0,
                w: 625,
                h: 1250,
              },
              {
                x: 0,
                y: 0,
                w: 1250,
                h: 1250,
              },
            ],
          },
          sizes: {
            large: {
              h: 1250,
              resize: 'fit',
              w: 1250,
            },
            medium: {
              h: 1200,
              resize: 'fit',
              w: 1200,
            },
            small: {
              h: 680,
              resize: 'fit',
              w: 680,
            },
            thumb: {
              h: 150,
              resize: 'crop',
              w: 150,
            },
          },
          type: 'photo',
          url: 'https://t.co/r6tfMn7Acr',
        },
      ],
      photos: [
        {
          backgroundColor: {
            red: 204,
            green: 214,
            blue: 221,
          },
          cropCandidates: [
            {
              x: 0,
              y: 118,
              w: 1250,
              h: 700,
            },
            {
              x: 0,
              y: 0,
              w: 1250,
              h: 1250,
            },
            {
              x: 45,
              y: 0,
              w: 1096,
              h: 1250,
            },
            {
              x: 281,
              y: 0,
              w: 625,
              h: 1250,
            },
            {
              x: 0,
              y: 0,
              w: 1250,
              h: 1250,
            },
          ],
          expandedUrl: 'https://twitter.com/EonianFinance/status/1789924316739412125/photo/1',
          url: 'https://pbs.twimg.com/media/GNcWIa_W8AAvae_.jpg',
          width: 1250,
          height: 1250,
        },
      ],
      isEdited: false,
      isStaleEdit: false,
    },
    isEdited: false,
    isStaleEdit: false,
  },
  '1709136584077914477': {
    __typename: 'Tweet',
    in_reply_to_screen_name: 'EonianFinance',
    in_reply_to_status_id_str: '1680276680319836162',
    in_reply_to_user_id_str: '1584314875991523328',
    lang: 'en',
    favorite_count: 0,
    created_at: '2023-10-03T09:21:30.000Z',
    display_text_range: [15, 64],
    entities: {
      hashtags: [],
      urls: [],
      user_mentions: [
        {
          id_str: '1584314875991523328',
          indices: [0, 14],
          name: 'Eonian',
          screen_name: 'EonianFinance',
        },
      ],
      symbols: [],
    },
    id_str: '1709136584077914477',
    text: '@EonianFinance This is a great reward system you have developed.',
    user: {
      id_str: '1682365334861357056',
      name: 'Precious | AREON',
      profile_image_url_https: 'https://pbs.twimg.com/profile_images/1729679832236138496/2OpGNosW_normal.jpg',
      screen_name: 'Richie__29',
      verified: false,
      is_blue_verified: false,
      profile_image_shape: 'Circle',
    },
    edit_control: {
      edit_tweet_ids: ['1709136584077914477'],
      editable_until_msecs: '1696328490000',
      is_edit_eligible: false,
      edits_remaining: '5',
    },
    conversation_count: 0,
    news_action_type: 'conversation',
    parent: {
      lang: 'en',
      reply_count: 75,
      retweet_count: 49,
      favorite_count: 64,
      possibly_sensitive: false,
      created_at: '2023-07-15T18:02:33.000Z',
      display_text_range: [0, 279],
      entities: {
        hashtags: [],
        urls: [
          {
            display_url: 'leovs09.notion.site/Community-Rewa…',
            expanded_url: 'https://leovs09.notion.site/Community-Rewards-System-eaa37db4f9944fddabaf2bca1e1066a0',
            indices: [256, 279],
            url: 'https://t.co/KEl9uFuL53',
          },
        ],
        user_mentions: [],
        symbols: [],
      },
      id_str: '1680276680319836162',
      text: 'We are glad to announce the launch of Our Level-Up Channel &amp; Rewards System!\n\nGet reward for engaging in our community. Earn points to level up and gain new roles, to qualify for token retrodrops. Higher roles = bigger rewards\n\nMore info in our Docs : https://t.co/KEl9uFuL53',
      user: {
        id_str: '1584314875991523328',
        name: 'Eonian',
        profile_image_url_https: 'https://pbs.twimg.com/profile_images/1768404732949733377/T_w4Y8-E_normal.jpg',
        screen_name: 'EonianFinance',
        verified: false,
        is_blue_verified: true,
        profile_image_shape: 'Circle',
      },
      edit_control: {
        edit_tweet_ids: ['1680276680319836162'],
        editable_until_msecs: '1689447753000',
        is_edit_eligible: true,
        edits_remaining: '5',
      },
      card: {
        card_platform: {
          platform: {
            audience: {
              name: 'production',
            },
            device: {
              name: 'iPhone',
              version: '13',
            },
          },
        },
        name: 'summary_large_image',
        url: 'https://t.co/KEl9uFuL53',
        binding_values: {
          photo_image_full_size_large: {
            image_value: {
              height: 419,
              width: 800,
              url: 'https://pbs.twimg.com/card_img/1800430057942294529/3zHgWOy8?format=jpg&name=800x419',
            },
            type: 'IMAGE',
          },
          thumbnail_image: {
            image_value: {
              height: 144,
              width: 144,
              url: 'https://pbs.twimg.com/card_img/1800430057942294529/3zHgWOy8?format=jpg&name=144x144',
            },
            type: 'IMAGE',
          },
          description: {
            string_value: 'Welcome to our in-depth guide to our Rewards System in the Discord community.',
            type: 'STRING',
          },
          domain: {
            string_value: 'leovs09.notion.site',
            type: 'STRING',
          },
          thumbnail_image_large: {
            image_value: {
              height: 320,
              width: 320,
              url: 'https://pbs.twimg.com/card_img/1800430057942294529/3zHgWOy8?format=jpg&name=800x320_1',
            },
            type: 'IMAGE',
          },
          summary_photo_image_small: {
            image_value: {
              height: 202,
              width: 386,
              url: 'https://pbs.twimg.com/card_img/1800430057942294529/3zHgWOy8?format=jpg&name=386x202',
            },
            type: 'IMAGE',
          },
          thumbnail_image_original: {
            image_value: {
              height: 2000,
              width: 2000,
              url: 'https://pbs.twimg.com/card_img/1800430057942294529/3zHgWOy8?format=jpg&name=orig',
            },
            type: 'IMAGE',
          },
          photo_image_full_size_small: {
            image_value: {
              height: 202,
              width: 386,
              url: 'https://pbs.twimg.com/card_img/1800430057942294529/3zHgWOy8?format=jpg&name=386x202',
            },
            type: 'IMAGE',
          },
          summary_photo_image_large: {
            image_value: {
              height: 419,
              width: 800,
              url: 'https://pbs.twimg.com/card_img/1800430057942294529/3zHgWOy8?format=jpg&name=800x419',
            },
            type: 'IMAGE',
          },
          thumbnail_image_small: {
            image_value: {
              height: 100,
              width: 100,
              url: 'https://pbs.twimg.com/card_img/1800430057942294529/3zHgWOy8?format=jpg&name=100x100',
            },
            type: 'IMAGE',
          },
          thumbnail_image_x_large: {
            image_value: {
              height: 2000,
              width: 2000,
              url: 'https://pbs.twimg.com/card_img/1800430057942294529/3zHgWOy8?format=png&name=2048x2048_2_exp',
            },
            type: 'IMAGE',
          },
          photo_image_full_size_original: {
            image_value: {
              height: 2000,
              width: 2000,
              url: 'https://pbs.twimg.com/card_img/1800430057942294529/3zHgWOy8?format=jpg&name=orig',
            },
            type: 'IMAGE',
          },
          vanity_url: {
            scribe_key: 'vanity_url',
            string_value: 'leovs09.notion.site',
            type: 'STRING',
          },
          photo_image_full_size: {
            image_value: {
              height: 314,
              width: 600,
              url: 'https://pbs.twimg.com/card_img/1800430057942294529/3zHgWOy8?format=jpg&name=600x314',
            },
            type: 'IMAGE',
          },
          thumbnail_image_color: {
            image_color_value: {
              palette: [
                {
                  rgb: {
                    blue: 83,
                    green: 44,
                    red: 216,
                  },
                  percentage: 17.88,
                },
                {
                  rgb: {
                    blue: 115,
                    green: 60,
                    red: 193,
                  },
                  percentage: 16.71,
                },
                {
                  rgb: {
                    blue: 205,
                    green: 88,
                    red: 88,
                  },
                  percentage: 12.9,
                },
                {
                  rgb: {
                    blue: 148,
                    green: 70,
                    red: 159,
                  },
                  percentage: 12.13,
                },
                {
                  rgb: {
                    blue: 187,
                    green: 112,
                    red: 133,
                  },
                  percentage: 10,
                },
              ],
            },
            type: 'IMAGE_COLOR',
          },
          title: {
            string_value: 'Community Rewards System | Notion',
            type: 'STRING',
          },
          summary_photo_image_color: {
            image_color_value: {
              palette: [
                {
                  rgb: {
                    blue: 83,
                    green: 44,
                    red: 216,
                  },
                  percentage: 17.88,
                },
                {
                  rgb: {
                    blue: 115,
                    green: 60,
                    red: 193,
                  },
                  percentage: 16.71,
                },
                {
                  rgb: {
                    blue: 205,
                    green: 88,
                    red: 88,
                  },
                  percentage: 12.9,
                },
                {
                  rgb: {
                    blue: 148,
                    green: 70,
                    red: 159,
                  },
                  percentage: 12.13,
                },
                {
                  rgb: {
                    blue: 187,
                    green: 112,
                    red: 133,
                  },
                  percentage: 10,
                },
              ],
            },
            type: 'IMAGE_COLOR',
          },
          summary_photo_image_x_large: {
            image_value: {
              height: 2000,
              width: 2000,
              url: 'https://pbs.twimg.com/card_img/1800430057942294529/3zHgWOy8?format=png&name=2048x2048_2_exp',
            },
            type: 'IMAGE',
          },
          summary_photo_image: {
            image_value: {
              height: 314,
              width: 600,
              url: 'https://pbs.twimg.com/card_img/1800430057942294529/3zHgWOy8?format=jpg&name=600x314',
            },
            type: 'IMAGE',
          },
          photo_image_full_size_color: {
            image_color_value: {
              palette: [
                {
                  rgb: {
                    blue: 83,
                    green: 44,
                    red: 216,
                  },
                  percentage: 17.88,
                },
                {
                  rgb: {
                    blue: 115,
                    green: 60,
                    red: 193,
                  },
                  percentage: 16.71,
                },
                {
                  rgb: {
                    blue: 205,
                    green: 88,
                    red: 88,
                  },
                  percentage: 12.9,
                },
                {
                  rgb: {
                    blue: 148,
                    green: 70,
                    red: 159,
                  },
                  percentage: 12.13,
                },
                {
                  rgb: {
                    blue: 187,
                    green: 112,
                    red: 133,
                  },
                  percentage: 10,
                },
              ],
            },
            type: 'IMAGE_COLOR',
          },
          photo_image_full_size_x_large: {
            image_value: {
              height: 2000,
              width: 2000,
              url: 'https://pbs.twimg.com/card_img/1800430057942294529/3zHgWOy8?format=png&name=2048x2048_2_exp',
            },
            type: 'IMAGE',
          },
          card_url: {
            scribe_key: 'card_url',
            string_value: 'https://t.co/KEl9uFuL53',
            type: 'STRING',
          },
          summary_photo_image_original: {
            image_value: {
              height: 2000,
              width: 2000,
              url: 'https://pbs.twimg.com/card_img/1800430057942294529/3zHgWOy8?format=jpg&name=orig',
            },
            type: 'IMAGE',
          },
        },
      },
      isEdited: false,
      isStaleEdit: false,
    },
    isEdited: false,
    isStaleEdit: false,
  },
  'default': {
    '1794130302530736270': {
      __typename: 'Tweet',
      in_reply_to_screen_name: 'EonianFinance',
      in_reply_to_status_id_str: '1789924316739412125',
      in_reply_to_user_id_str: '1584314875991523328',
      lang: 'en',
      favorite_count: 0,
      created_at: '2024-05-24T22:16:12.000Z',
      display_text_range: [15, 60],
      entities: {
        hashtags: [],
        urls: [],
        user_mentions: [
          {
            id_str: '1584314875991523328',
            indices: [0, 14],
            name: 'Eonian',
            screen_name: 'EonianFinance',
          },
        ],
        symbols: [],
      },
      id_str: '1794130302530736270',
      text: '@EonianFinance Very nice and prosperous project\n🎉🎉🎉🎊🎊🎊',
      user: {
        id_str: '1630493926867222528',
        name: 'Jend Empire $OMNI 🅾️',
        profile_image_url_https: 'https://pbs.twimg.com/profile_images/1792624159907803136/zE5UoKrF_normal.jpg',
        screen_name: 'JendEmpire',
        verified: false,
        is_blue_verified: false,
        profile_image_shape: 'Circle',
      },
      edit_control: {
        edit_tweet_ids: ['1794130302530736270'],
        editable_until_msecs: '1716592572000',
        is_edit_eligible: false,
        edits_remaining: '5',
      },
      conversation_count: 0,
      news_action_type: 'conversation',
      parent: {
        lang: 'en',
        reply_count: 35,
        retweet_count: 34,
        favorite_count: 38,
        possibly_sensitive: false,
        created_at: '2024-05-13T07:43:06.000Z',
        display_text_range: [0, 276],
        entities: {
          hashtags: [],
          urls: [],
          user_mentions: [],
          symbols: [],
          media: [
            {
              display_url: 'pic.x.com/r6tfmn7acr',
              expanded_url: 'https://twitter.com/EonianFinance/status/1789924316739412125/photo/1',
              indices: [277, 300],
              url: 'https://t.co/r6tfMn7Acr',
            },
          ],
        },
        id_str: '1789924316739412125',
        text: 'Open Beta Announce\nMore than a year ago, we launched our protocol in closed alpha. Since then, we have refined our solution, fixed many bugs, and added awesome features. That means very soon, we will be ready to launch our protocol in open beta and allow anyone to save their… https://t.co/r6tfMn7Acr',
        user: {
          id_str: '1584314875991523328',
          name: 'Eonian',
          profile_image_url_https: 'https://pbs.twimg.com/profile_images/1768404732949733377/T_w4Y8-E_normal.jpg',
          screen_name: 'EonianFinance',
          verified: false,
          is_blue_verified: true,
          profile_image_shape: 'Circle',
        },
        edit_control: {
          edit_tweet_ids: ['1789924316739412125'],
          editable_until_msecs: '1715589786000',
          is_edit_eligible: true,
          edits_remaining: '5',
        },
        mediaDetails: [
          {
            display_url: 'pic.twitter.com/r6tfMn7Acr',
            expanded_url: 'https://twitter.com/EonianFinance/status/1789924316739412125/photo/1',
            ext_media_availability: {
              status: 'Available',
            },
            indices: [277, 300],
            media_url_https: 'https://pbs.twimg.com/media/GNcWIa_W8AAvae_.jpg',
            original_info: {
              height: 1250,
              width: 1250,
              focus_rects: [
                {
                  x: 0,
                  y: 118,
                  w: 1250,
                  h: 700,
                },
                {
                  x: 0,
                  y: 0,
                  w: 1250,
                  h: 1250,
                },
                {
                  x: 45,
                  y: 0,
                  w: 1096,
                  h: 1250,
                },
                {
                  x: 281,
                  y: 0,
                  w: 625,
                  h: 1250,
                },
                {
                  x: 0,
                  y: 0,
                  w: 1250,
                  h: 1250,
                },
              ],
            },
            sizes: {
              large: {
                h: 1250,
                resize: 'fit',
                w: 1250,
              },
              medium: {
                h: 1200,
                resize: 'fit',
                w: 1200,
              },
              small: {
                h: 680,
                resize: 'fit',
                w: 680,
              },
              thumb: {
                h: 150,
                resize: 'crop',
                w: 150,
              },
            },
            type: 'photo',
            url: 'https://t.co/r6tfMn7Acr',
          },
        ],
        photos: [
          {
            backgroundColor: {
              red: 204,
              green: 214,
              blue: 221,
            },
            cropCandidates: [
              {
                x: 0,
                y: 118,
                w: 1250,
                h: 700,
              },
              {
                x: 0,
                y: 0,
                w: 1250,
                h: 1250,
              },
              {
                x: 45,
                y: 0,
                w: 1096,
                h: 1250,
              },
              {
                x: 281,
                y: 0,
                w: 625,
                h: 1250,
              },
              {
                x: 0,
                y: 0,
                w: 1250,
                h: 1250,
              },
            ],
            expandedUrl: 'https://twitter.com/EonianFinance/status/1789924316739412125/photo/1',
            url: 'https://pbs.twimg.com/media/GNcWIa_W8AAvae_.jpg',
            width: 1250,
            height: 1250,
          },
        ],
        isEdited: false,
        isStaleEdit: false,
      },
      isEdited: false,
      isStaleEdit: false,
    },
    '1697597961503490277': {
      __typename: 'Tweet',
      in_reply_to_screen_name: 'EonianFinance',
      in_reply_to_status_id_str: '1689980176174624768',
      in_reply_to_user_id_str: '1584314875991523328',
      lang: 'en',
      favorite_count: 0,
      created_at: '2023-09-01T13:11:08.000Z',
      display_text_range: [15, 97],
      entities: {
        hashtags: [
          {
            indices: [65, 79],
            text: 'EonianFinance',
          },
        ],
        urls: [],
        user_mentions: [
          {
            id_str: '1584314875991523328',
            indices: [0, 14],
            name: 'Eonian',
            screen_name: 'EonianFinance',
          },
        ],
        symbols: [],
      },
      id_str: '1697597961503490277',
      text: '@EonianFinance Wish to be guided on proper risk management . Let #EonianFinance be your sure plug',
      user: {
        id_str: '1481494764927307776',
        name: 'Awasiakan Udo',
        profile_image_url_https: 'https://pbs.twimg.com/profile_images/1788583962845032448/0d_Y2SCW_normal.jpg',
        screen_name: 'AwasiakanUdo',
        verified: false,
        is_blue_verified: false,
        profile_image_shape: 'Circle',
      },
      edit_control: {
        edit_tweet_ids: ['1697597961503490277'],
        editable_until_msecs: '1693577468000',
        is_edit_eligible: false,
        edits_remaining: '5',
      },
      conversation_count: 0,
      news_action_type: 'conversation',
      parent: {
        lang: 'en',
        reply_count: 44,
        retweet_count: 33,
        favorite_count: 39,
        possibly_sensitive: false,
        created_at: '2023-08-11T12:40:46.000Z',
        display_text_range: [0, 277],
        entities: {
          hashtags: [],
          urls: [],
          user_mentions: [],
          symbols: [],
          media: [
            {
              display_url: 'pic.x.com/eswflvhvvs',
              expanded_url: 'https://twitter.com/EonianFinance/status/1689980176174624768/photo/1',
              indices: [278, 301],
              url: 'https://t.co/eSWFlvhvVs',
            },
          ],
        },
        id_str: '1689980176174624768',
        text: 'Are you an investor looking out for the best way to make money in crypto? It\'s important to be aware of potential risks before investing in the world of Decentralized Finance.\n\nUnderstanding the Risks of DeFi Investments\n\n10 risks of investment every investor must know. Let’s… https://t.co/eSWFlvhvVs',
        user: {
          id_str: '1584314875991523328',
          name: 'Eonian',
          profile_image_url_https: 'https://pbs.twimg.com/profile_images/1768404732949733377/T_w4Y8-E_normal.jpg',
          screen_name: 'EonianFinance',
          verified: false,
          is_blue_verified: true,
          profile_image_shape: 'Circle',
        },
        edit_control: {
          edit_tweet_ids: ['1689980176174624768'],
          editable_until_msecs: '1691761246000',
          is_edit_eligible: false,
          edits_remaining: '5',
        },
        mediaDetails: [
          {
            display_url: 'pic.twitter.com/eSWFlvhvVs',
            expanded_url: 'https://twitter.com/EonianFinance/status/1689980176174624768/photo/1',
            ext_media_availability: {
              status: 'Available',
            },
            indices: [278, 301],
            media_url_https: 'https://pbs.twimg.com/media/F3QEAj6W4AEUtTP.jpg',
            original_info: {
              height: 900,
              width: 1600,
              focus_rects: [
                {
                  x: 0,
                  y: 0,
                  w: 1600,
                  h: 896,
                },
                {
                  x: 700,
                  y: 0,
                  w: 900,
                  h: 900,
                },
                {
                  x: 811,
                  y: 0,
                  w: 789,
                  h: 900,
                },
                {
                  x: 1095,
                  y: 0,
                  w: 450,
                  h: 900,
                },
                {
                  x: 0,
                  y: 0,
                  w: 1600,
                  h: 900,
                },
              ],
            },
            sizes: {
              large: {
                h: 900,
                resize: 'fit',
                w: 1600,
              },
              medium: {
                h: 675,
                resize: 'fit',
                w: 1200,
              },
              small: {
                h: 383,
                resize: 'fit',
                w: 680,
              },
              thumb: {
                h: 150,
                resize: 'crop',
                w: 150,
              },
            },
            type: 'photo',
            url: 'https://t.co/eSWFlvhvVs',
          },
        ],
        photos: [
          {
            backgroundColor: {
              red: 204,
              green: 214,
              blue: 221,
            },
            cropCandidates: [
              {
                x: 0,
                y: 0,
                w: 1600,
                h: 896,
              },
              {
                x: 700,
                y: 0,
                w: 900,
                h: 900,
              },
              {
                x: 811,
                y: 0,
                w: 789,
                h: 900,
              },
              {
                x: 1095,
                y: 0,
                w: 450,
                h: 900,
              },
              {
                x: 0,
                y: 0,
                w: 1600,
                h: 900,
              },
            ],
            expandedUrl: 'https://twitter.com/EonianFinance/status/1689980176174624768/photo/1',
            url: 'https://pbs.twimg.com/media/F3QEAj6W4AEUtTP.jpg',
            width: 1600,
            height: 900,
          },
        ],
        isEdited: false,
        isStaleEdit: false,
      },
      isEdited: false,
      isStaleEdit: false,
    },
    '1752601486692159938': {
      __typename: 'Tweet',
      in_reply_to_screen_name: 'EonianFinance',
      in_reply_to_status_id_str: '1751444681634787806',
      in_reply_to_user_id_str: '1584314875991523328',
      lang: 'en',
      favorite_count: 1,
      created_at: '2024-01-31T07:55:30.000Z',
      display_text_range: [15, 35],
      entities: {
        hashtags: [],
        urls: [],
        user_mentions: [
          {
            id_str: '1584314875991523328',
            indices: [0, 14],
            name: 'Eonian',
            screen_name: 'EonianFinance',
          },
        ],
        symbols: [],
      },
      id_str: '1752601486692159938',
      text: '@EonianFinance let\'s go to the moon',
      user: {
        id_str: '1605583637319016448',
        name: 'Thang l❤️ $WELL l NavyAi',
        profile_image_url_https: 'https://pbs.twimg.com/profile_images/1714159541510938624/5k7FoLrk_normal.jpg',
        screen_name: 'TrinhNguyen8867',
        verified: false,
        is_blue_verified: false,
        profile_image_shape: 'Circle',
      },
      edit_control: {
        edit_tweet_ids: ['1752601486692159938'],
        editable_until_msecs: '1706691330000',
        is_edit_eligible: false,
        edits_remaining: '5',
      },
      conversation_count: 1,
      news_action_type: 'conversation',
      parent: {
        lang: 'en',
        reply_count: 119,
        retweet_count: 224,
        favorite_count: 310,
        possibly_sensitive: false,
        created_at: '2024-01-28T03:18:47.000Z',
        display_text_range: [0, 219],
        entities: {
          hashtags: [
            {
              indices: [58, 65],
              text: 'crypto',
            },
          ],
          urls: [
            {
              display_url: 'eonian.finance',
              expanded_url: 'https://eonian.finance',
              indices: [196, 219],
              url: 'https://t.co/ieieSlLHh5',
            },
          ],
          user_mentions: [],
          symbols: [],
          media: [
            {
              display_url: 'pic.x.com/l6kgkoakqj',
              expanded_url: 'https://twitter.com/EonianFinance/status/1751444681634787806/video/1',
              indices: [220, 243],
              url: 'https://t.co/L6KGKOAkQJ',
            },
          ],
        },
        id_str: '1751444681634787806',
        text: 'Launch of First Decentralized Savings Account\nInsure your #crypto from wallet hacks with zero fees, while passively earning savings premium on your holdings.\n\nLearn more and keep your money safe: https://t.co/ieieSlLHh5 https://t.co/L6KGKOAkQJ',
        user: {
          id_str: '1584314875991523328',
          name: 'Eonian',
          profile_image_url_https: 'https://pbs.twimg.com/profile_images/1768404732949733377/T_w4Y8-E_normal.jpg',
          screen_name: 'EonianFinance',
          verified: false,
          is_blue_verified: true,
          profile_image_shape: 'Circle',
        },
        edit_control: {
          edit_tweet_ids: ['1751444681634787806'],
          editable_until_msecs: '1706415527000',
          is_edit_eligible: true,
          edits_remaining: '5',
        },
        mediaDetails: [
          {
            additional_media_info: {},
            display_url: 'pic.twitter.com/L6KGKOAkQJ',
            expanded_url: 'https://twitter.com/EonianFinance/status/1751444681634787806/video/1',
            ext_media_availability: {
              status: 'Available',
            },
            indices: [220, 243],
            media_url_https: 'https://pbs.twimg.com/ext_tw_video_thumb/1751443920339226624/pu/img/M2wWH3j9NagQhB4p.jpg',
            original_info: {
              height: 1080,
              width: 1920,
              focus_rects: [],
            },
            sizes: {
              large: {
                h: 1080,
                resize: 'fit',
                w: 1920,
              },
              medium: {
                h: 675,
                resize: 'fit',
                w: 1200,
              },
              small: {
                h: 383,
                resize: 'fit',
                w: 680,
              },
              thumb: {
                h: 150,
                resize: 'crop',
                w: 150,
              },
            },
            type: 'video',
            url: 'https://t.co/L6KGKOAkQJ',
            video_info: {
              aspect_ratio: [16, 9],
              duration_millis: 26221,
              variants: [
                {
                  content_type: 'application/x-mpegURL',
                  url: 'https://video.twimg.com/ext_tw_video/1751443920339226624/pu/pl/5V9UUfMQpj2Is9tO.m3u8?tag=14',
                },
                {
                  bitrate: 256000,
                  content_type: 'video/mp4',
                  url: 'https://video.twimg.com/ext_tw_video/1751443920339226624/pu/vid/avc1/480x270/hgqlrSCMAe91lext.mp4?tag=14',
                },
                {
                  bitrate: 832000,
                  content_type: 'video/mp4',
                  url: 'https://video.twimg.com/ext_tw_video/1751443920339226624/pu/vid/avc1/640x360/QGmXdt2Y5iBrAyVR.mp4?tag=14',
                },
                {
                  bitrate: 2176000,
                  content_type: 'video/mp4',
                  url: 'https://video.twimg.com/ext_tw_video/1751443920339226624/pu/vid/avc1/1280x720/kFv4jIOxO3dF12WE.mp4?tag=14',
                },
                {
                  bitrate: 10368000,
                  content_type: 'video/mp4',
                  url: 'https://video.twimg.com/ext_tw_video/1751443920339226624/pu/vid/avc1/1920x1080/GWono6WDbJZs1sSX.mp4?tag=14',
                },
              ],
            },
          },
        ],
        photos: [],
        video: {
          aspectRatio: [16, 9],
          contentType: 'media_entity',
          durationMs: 26221,
          mediaAvailability: {
            status: 'available',
          },
          poster: 'https://pbs.twimg.com/ext_tw_video_thumb/1751443920339226624/pu/img/M2wWH3j9NagQhB4p.jpg',
          variants: [
            {
              type: 'application/x-mpegURL',
              src: 'https://video.twimg.com/ext_tw_video/1751443920339226624/pu/pl/5V9UUfMQpj2Is9tO.m3u8?tag=14',
            },
            {
              type: 'video/mp4',
              src: 'https://video.twimg.com/ext_tw_video/1751443920339226624/pu/vid/avc1/480x270/hgqlrSCMAe91lext.mp4?tag=14',
            },
            {
              type: 'video/mp4',
              src: 'https://video.twimg.com/ext_tw_video/1751443920339226624/pu/vid/avc1/640x360/QGmXdt2Y5iBrAyVR.mp4?tag=14',
            },
            {
              type: 'video/mp4',
              src: 'https://video.twimg.com/ext_tw_video/1751443920339226624/pu/vid/avc1/1280x720/kFv4jIOxO3dF12WE.mp4?tag=14',
            },
            {
              type: 'video/mp4',
              src: 'https://video.twimg.com/ext_tw_video/1751443920339226624/pu/vid/avc1/1920x1080/GWono6WDbJZs1sSX.mp4?tag=14',
            },
          ],
          videoId: {
            type: 'tweet',
            id: '1751444681634787806',
          },
          viewCount: 0,
        },
        isEdited: false,
        isStaleEdit: false,
      },
      isEdited: false,
      isStaleEdit: false,
    },
    '1793528774027509972': {
      __typename: 'Tweet',
      in_reply_to_screen_name: 'EonianFinance',
      in_reply_to_status_id_str: '1751444681634787806',
      in_reply_to_user_id_str: '1584314875991523328',
      lang: 'en',
      favorite_count: 0,
      created_at: '2024-05-23T06:25:56.000Z',
      display_text_range: [15, 107],
      entities: {
        hashtags: [],
        urls: [],
        user_mentions: [
          {
            id_str: '1584314875991523328',
            indices: [0, 14],
            name: 'Eonian',
            screen_name: 'EonianFinance',
          },
        ],
        symbols: [],
      },
      id_str: '1793528774027509972',
      text: '@EonianFinance Given how security is essentian in the crypto space, this sounds like a very worthy project.',
      user: {
        id_str: '61748645',
        name: 'Filmalter',
        profile_image_url_https:
          'https://pbs.twimg.com/profile_images/3084582885/75358f98bbfba2488db7de081663bf21_normal.jpeg',
        screen_name: 'Filmalter',
        verified: false,
        is_blue_verified: false,
        profile_image_shape: 'Circle',
      },
      edit_control: {
        edit_tweet_ids: ['1793528774027509972'],
        editable_until_msecs: '1716449156000',
        is_edit_eligible: false,
        edits_remaining: '5',
      },
      conversation_count: 0,
      news_action_type: 'conversation',
      parent: {
        lang: 'en',
        reply_count: 119,
        retweet_count: 224,
        favorite_count: 310,
        possibly_sensitive: false,
        created_at: '2024-01-28T03:18:47.000Z',
        display_text_range: [0, 219],
        entities: {
          hashtags: [
            {
              indices: [58, 65],
              text: 'crypto',
            },
          ],
          urls: [
            {
              display_url: 'eonian.finance',
              expanded_url: 'https://eonian.finance',
              indices: [196, 219],
              url: 'https://t.co/ieieSlLHh5',
            },
          ],
          user_mentions: [],
          symbols: [],
          media: [
            {
              display_url: 'pic.x.com/l6kgkoakqj',
              expanded_url: 'https://twitter.com/EonianFinance/status/1751444681634787806/video/1',
              indices: [220, 243],
              url: 'https://t.co/L6KGKOAkQJ',
            },
          ],
        },
        id_str: '1751444681634787806',
        text: 'Launch of First Decentralized Savings Account\nInsure your #crypto from wallet hacks with zero fees, while passively earning savings premium on your holdings.\n\nLearn more and keep your money safe: https://t.co/ieieSlLHh5 https://t.co/L6KGKOAkQJ',
        user: {
          id_str: '1584314875991523328',
          name: 'Eonian',
          profile_image_url_https: 'https://pbs.twimg.com/profile_images/1768404732949733377/T_w4Y8-E_normal.jpg',
          screen_name: 'EonianFinance',
          verified: false,
          is_blue_verified: true,
          profile_image_shape: 'Circle',
        },
        edit_control: {
          edit_tweet_ids: ['1751444681634787806'],
          editable_until_msecs: '1706415527000',
          is_edit_eligible: true,
          edits_remaining: '5',
        },
        mediaDetails: [
          {
            additional_media_info: {},
            display_url: 'pic.twitter.com/L6KGKOAkQJ',
            expanded_url: 'https://twitter.com/EonianFinance/status/1751444681634787806/video/1',
            ext_media_availability: {
              status: 'Available',
            },
            indices: [220, 243],
            media_url_https: 'https://pbs.twimg.com/ext_tw_video_thumb/1751443920339226624/pu/img/M2wWH3j9NagQhB4p.jpg',
            original_info: {
              height: 1080,
              width: 1920,
              focus_rects: [],
            },
            sizes: {
              large: {
                h: 1080,
                resize: 'fit',
                w: 1920,
              },
              medium: {
                h: 675,
                resize: 'fit',
                w: 1200,
              },
              small: {
                h: 383,
                resize: 'fit',
                w: 680,
              },
              thumb: {
                h: 150,
                resize: 'crop',
                w: 150,
              },
            },
            type: 'video',
            url: 'https://t.co/L6KGKOAkQJ',
            video_info: {
              aspect_ratio: [16, 9],
              duration_millis: 26221,
              variants: [
                {
                  content_type: 'application/x-mpegURL',
                  url: 'https://video.twimg.com/ext_tw_video/1751443920339226624/pu/pl/5V9UUfMQpj2Is9tO.m3u8?tag=14',
                },
                {
                  bitrate: 256000,
                  content_type: 'video/mp4',
                  url: 'https://video.twimg.com/ext_tw_video/1751443920339226624/pu/vid/avc1/480x270/hgqlrSCMAe91lext.mp4?tag=14',
                },
                {
                  bitrate: 832000,
                  content_type: 'video/mp4',
                  url: 'https://video.twimg.com/ext_tw_video/1751443920339226624/pu/vid/avc1/640x360/QGmXdt2Y5iBrAyVR.mp4?tag=14',
                },
                {
                  bitrate: 2176000,
                  content_type: 'video/mp4',
                  url: 'https://video.twimg.com/ext_tw_video/1751443920339226624/pu/vid/avc1/1280x720/kFv4jIOxO3dF12WE.mp4?tag=14',
                },
                {
                  bitrate: 10368000,
                  content_type: 'video/mp4',
                  url: 'https://video.twimg.com/ext_tw_video/1751443920339226624/pu/vid/avc1/1920x1080/GWono6WDbJZs1sSX.mp4?tag=14',
                },
              ],
            },
          },
        ],
        photos: [],
        video: {
          aspectRatio: [16, 9],
          contentType: 'media_entity',
          durationMs: 26221,
          mediaAvailability: {
            status: 'available',
          },
          poster: 'https://pbs.twimg.com/ext_tw_video_thumb/1751443920339226624/pu/img/M2wWH3j9NagQhB4p.jpg',
          variants: [
            {
              type: 'application/x-mpegURL',
              src: 'https://video.twimg.com/ext_tw_video/1751443920339226624/pu/pl/5V9UUfMQpj2Is9tO.m3u8?tag=14',
            },
            {
              type: 'video/mp4',
              src: 'https://video.twimg.com/ext_tw_video/1751443920339226624/pu/vid/avc1/480x270/hgqlrSCMAe91lext.mp4?tag=14',
            },
            {
              type: 'video/mp4',
              src: 'https://video.twimg.com/ext_tw_video/1751443920339226624/pu/vid/avc1/640x360/QGmXdt2Y5iBrAyVR.mp4?tag=14',
            },
            {
              type: 'video/mp4',
              src: 'https://video.twimg.com/ext_tw_video/1751443920339226624/pu/vid/avc1/1280x720/kFv4jIOxO3dF12WE.mp4?tag=14',
            },
            {
              type: 'video/mp4',
              src: 'https://video.twimg.com/ext_tw_video/1751443920339226624/pu/vid/avc1/1920x1080/GWono6WDbJZs1sSX.mp4?tag=14',
            },
          ],
          videoId: {
            type: 'tweet',
            id: '1751444681634787806',
          },
          viewCount: 0,
        },
        isEdited: false,
        isStaleEdit: false,
      },
      isEdited: false,
      isStaleEdit: false,
    },
    '1767178284628873338': {
      __typename: 'Tweet',
      in_reply_to_screen_name: 'EonianFinance',
      in_reply_to_status_id_str: '1751444681634787806',
      in_reply_to_user_id_str: '1584314875991523328',
      lang: 'en',
      favorite_count: 0,
      created_at: '2024-03-11T13:18:30.000Z',
      display_text_range: [15, 34],
      entities: {
        hashtags: [],
        urls: [],
        user_mentions: [
          {
            id_str: '1584314875991523328',
            indices: [0, 14],
            name: 'Eonian',
            screen_name: 'EonianFinance',
          },
        ],
        symbols: [],
      },
      id_str: '1767178284628873338',
      text: '@EonianFinance Look interesting 👀',
      user: {
        id_str: '1677646243609075712',
        name: '-CryptoXP-',
        profile_image_url_https: 'https://pbs.twimg.com/profile_images/1702051315130519552/UwS-eUtF_normal.jpg',
        screen_name: 'CryptoXP_11',
        verified: false,
        is_blue_verified: false,
        profile_image_shape: 'Circle',
      },
      edit_control: {
        edit_tweet_ids: ['1767178284628873338'],
        editable_until_msecs: '1710166710000',
        is_edit_eligible: false,
        edits_remaining: '5',
      },
      conversation_count: 0,
      news_action_type: 'conversation',
      parent: {
        lang: 'en',
        reply_count: 119,
        retweet_count: 224,
        favorite_count: 310,
        possibly_sensitive: false,
        created_at: '2024-01-28T03:18:47.000Z',
        display_text_range: [0, 219],
        entities: {
          hashtags: [
            {
              indices: [58, 65],
              text: 'crypto',
            },
          ],
          urls: [
            {
              display_url: 'eonian.finance',
              expanded_url: 'https://eonian.finance',
              indices: [196, 219],
              url: 'https://t.co/ieieSlLHh5',
            },
          ],
          user_mentions: [],
          symbols: [],
          media: [
            {
              display_url: 'pic.x.com/l6kgkoakqj',
              expanded_url: 'https://twitter.com/EonianFinance/status/1751444681634787806/video/1',
              indices: [220, 243],
              url: 'https://t.co/L6KGKOAkQJ',
            },
          ],
        },
        id_str: '1751444681634787806',
        text: 'Launch of First Decentralized Savings Account\nInsure your #crypto from wallet hacks with zero fees, while passively earning savings premium on your holdings.\n\nLearn more and keep your money safe: https://t.co/ieieSlLHh5 https://t.co/L6KGKOAkQJ',
        user: {
          id_str: '1584314875991523328',
          name: 'Eonian',
          profile_image_url_https: 'https://pbs.twimg.com/profile_images/1768404732949733377/T_w4Y8-E_normal.jpg',
          screen_name: 'EonianFinance',
          verified: false,
          is_blue_verified: true,
          profile_image_shape: 'Circle',
        },
        edit_control: {
          edit_tweet_ids: ['1751444681634787806'],
          editable_until_msecs: '1706415527000',
          is_edit_eligible: true,
          edits_remaining: '5',
        },
        mediaDetails: [
          {
            additional_media_info: {},
            display_url: 'pic.twitter.com/L6KGKOAkQJ',
            expanded_url: 'https://twitter.com/EonianFinance/status/1751444681634787806/video/1',
            ext_media_availability: {
              status: 'Available',
            },
            indices: [220, 243],
            media_url_https: 'https://pbs.twimg.com/ext_tw_video_thumb/1751443920339226624/pu/img/M2wWH3j9NagQhB4p.jpg',
            original_info: {
              height: 1080,
              width: 1920,
              focus_rects: [],
            },
            sizes: {
              large: {
                h: 1080,
                resize: 'fit',
                w: 1920,
              },
              medium: {
                h: 675,
                resize: 'fit',
                w: 1200,
              },
              small: {
                h: 383,
                resize: 'fit',
                w: 680,
              },
              thumb: {
                h: 150,
                resize: 'crop',
                w: 150,
              },
            },
            type: 'video',
            url: 'https://t.co/L6KGKOAkQJ',
            video_info: {
              aspect_ratio: [16, 9],
              duration_millis: 26221,
              variants: [
                {
                  content_type: 'application/x-mpegURL',
                  url: 'https://video.twimg.com/ext_tw_video/1751443920339226624/pu/pl/5V9UUfMQpj2Is9tO.m3u8?tag=14',
                },
                {
                  bitrate: 256000,
                  content_type: 'video/mp4',
                  url: 'https://video.twimg.com/ext_tw_video/1751443920339226624/pu/vid/avc1/480x270/hgqlrSCMAe91lext.mp4?tag=14',
                },
                {
                  bitrate: 832000,
                  content_type: 'video/mp4',
                  url: 'https://video.twimg.com/ext_tw_video/1751443920339226624/pu/vid/avc1/640x360/QGmXdt2Y5iBrAyVR.mp4?tag=14',
                },
                {
                  bitrate: 2176000,
                  content_type: 'video/mp4',
                  url: 'https://video.twimg.com/ext_tw_video/1751443920339226624/pu/vid/avc1/1280x720/kFv4jIOxO3dF12WE.mp4?tag=14',
                },
                {
                  bitrate: 10368000,
                  content_type: 'video/mp4',
                  url: 'https://video.twimg.com/ext_tw_video/1751443920339226624/pu/vid/avc1/1920x1080/GWono6WDbJZs1sSX.mp4?tag=14',
                },
              ],
            },
          },
        ],
        photos: [],
        video: {
          aspectRatio: [16, 9],
          contentType: 'media_entity',
          durationMs: 26221,
          mediaAvailability: {
            status: 'available',
          },
          poster: 'https://pbs.twimg.com/ext_tw_video_thumb/1751443920339226624/pu/img/M2wWH3j9NagQhB4p.jpg',
          variants: [
            {
              type: 'application/x-mpegURL',
              src: 'https://video.twimg.com/ext_tw_video/1751443920339226624/pu/pl/5V9UUfMQpj2Is9tO.m3u8?tag=14',
            },
            {
              type: 'video/mp4',
              src: 'https://video.twimg.com/ext_tw_video/1751443920339226624/pu/vid/avc1/480x270/hgqlrSCMAe91lext.mp4?tag=14',
            },
            {
              type: 'video/mp4',
              src: 'https://video.twimg.com/ext_tw_video/1751443920339226624/pu/vid/avc1/640x360/QGmXdt2Y5iBrAyVR.mp4?tag=14',
            },
            {
              type: 'video/mp4',
              src: 'https://video.twimg.com/ext_tw_video/1751443920339226624/pu/vid/avc1/1280x720/kFv4jIOxO3dF12WE.mp4?tag=14',
            },
            {
              type: 'video/mp4',
              src: 'https://video.twimg.com/ext_tw_video/1751443920339226624/pu/vid/avc1/1920x1080/GWono6WDbJZs1sSX.mp4?tag=14',
            },
          ],
          videoId: {
            type: 'tweet',
            id: '1751444681634787806',
          },
          viewCount: 0,
        },
        isEdited: false,
        isStaleEdit: false,
      },
      isEdited: false,
      isStaleEdit: false,
    },
    '1791843687674126794': {
      __typename: 'Tweet',
      in_reply_to_screen_name: 'EonianFinance',
      in_reply_to_status_id_str: '1789924316739412125',
      in_reply_to_user_id_str: '1584314875991523328',
      lang: 'en',
      favorite_count: 0,
      created_at: '2024-05-18T14:50:00.000Z',
      display_text_range: [15, 54],
      entities: {
        hashtags: [],
        urls: [],
        user_mentions: [
          {
            id_str: '1584314875991523328',
            indices: [0, 14],
            name: 'Eonian',
            screen_name: 'EonianFinance',
          },
        ],
        symbols: [],
      },
      id_str: '1791843687674126794',
      text: '@EonianFinance Very exciting project. Glad to be here!',
      user: {
        id_str: '1758747538629267456',
        name: 'Anya (🎮,🟢)',
        profile_image_url_https: 'https://pbs.twimg.com/profile_images/1758747652127092736/dARcUKdT_normal.jpg',
        screen_name: 'ANYA_rekt',
        verified: false,
        is_blue_verified: false,
        profile_image_shape: 'Circle',
      },
      edit_control: {
        edit_tweet_ids: ['1791843687674126794'],
        editable_until_msecs: '1716047400000',
        is_edit_eligible: false,
        edits_remaining: '5',
      },
      conversation_count: 0,
      news_action_type: 'conversation',
      parent: {
        lang: 'en',
        reply_count: 35,
        retweet_count: 34,
        favorite_count: 38,
        possibly_sensitive: false,
        created_at: '2024-05-13T07:43:06.000Z',
        display_text_range: [0, 276],
        entities: {
          hashtags: [],
          urls: [],
          user_mentions: [],
          symbols: [],
          media: [
            {
              display_url: 'pic.x.com/r6tfmn7acr',
              expanded_url: 'https://twitter.com/EonianFinance/status/1789924316739412125/photo/1',
              indices: [277, 300],
              url: 'https://t.co/r6tfMn7Acr',
            },
          ],
        },
        id_str: '1789924316739412125',
        text: 'Open Beta Announce\nMore than a year ago, we launched our protocol in closed alpha. Since then, we have refined our solution, fixed many bugs, and added awesome features. That means very soon, we will be ready to launch our protocol in open beta and allow anyone to save their… https://t.co/r6tfMn7Acr',
        user: {
          id_str: '1584314875991523328',
          name: 'Eonian',
          profile_image_url_https: 'https://pbs.twimg.com/profile_images/1768404732949733377/T_w4Y8-E_normal.jpg',
          screen_name: 'EonianFinance',
          verified: false,
          is_blue_verified: true,
          profile_image_shape: 'Circle',
        },
        edit_control: {
          edit_tweet_ids: ['1789924316739412125'],
          editable_until_msecs: '1715589786000',
          is_edit_eligible: true,
          edits_remaining: '5',
        },
        mediaDetails: [
          {
            display_url: 'pic.twitter.com/r6tfMn7Acr',
            expanded_url: 'https://twitter.com/EonianFinance/status/1789924316739412125/photo/1',
            ext_media_availability: {
              status: 'Available',
            },
            indices: [277, 300],
            media_url_https: 'https://pbs.twimg.com/media/GNcWIa_W8AAvae_.jpg',
            original_info: {
              height: 1250,
              width: 1250,
              focus_rects: [
                {
                  x: 0,
                  y: 118,
                  w: 1250,
                  h: 700,
                },
                {
                  x: 0,
                  y: 0,
                  w: 1250,
                  h: 1250,
                },
                {
                  x: 45,
                  y: 0,
                  w: 1096,
                  h: 1250,
                },
                {
                  x: 281,
                  y: 0,
                  w: 625,
                  h: 1250,
                },
                {
                  x: 0,
                  y: 0,
                  w: 1250,
                  h: 1250,
                },
              ],
            },
            sizes: {
              large: {
                h: 1250,
                resize: 'fit',
                w: 1250,
              },
              medium: {
                h: 1200,
                resize: 'fit',
                w: 1200,
              },
              small: {
                h: 680,
                resize: 'fit',
                w: 680,
              },
              thumb: {
                h: 150,
                resize: 'crop',
                w: 150,
              },
            },
            type: 'photo',
            url: 'https://t.co/r6tfMn7Acr',
          },
        ],
        photos: [
          {
            backgroundColor: {
              red: 204,
              green: 214,
              blue: 221,
            },
            cropCandidates: [
              {
                x: 0,
                y: 118,
                w: 1250,
                h: 700,
              },
              {
                x: 0,
                y: 0,
                w: 1250,
                h: 1250,
              },
              {
                x: 45,
                y: 0,
                w: 1096,
                h: 1250,
              },
              {
                x: 281,
                y: 0,
                w: 625,
                h: 1250,
              },
              {
                x: 0,
                y: 0,
                w: 1250,
                h: 1250,
              },
            ],
            expandedUrl: 'https://twitter.com/EonianFinance/status/1789924316739412125/photo/1',
            url: 'https://pbs.twimg.com/media/GNcWIa_W8AAvae_.jpg',
            width: 1250,
            height: 1250,
          },
        ],
        isEdited: false,
        isStaleEdit: false,
      },
      isEdited: false,
      isStaleEdit: false,
    },
    '1752137237750563015': {
      __typename: 'Tweet',
      in_reply_to_screen_name: 'EonianFinance',
      in_reply_to_status_id_str: '1751444681634787806',
      in_reply_to_user_id_str: '1584314875991523328',
      lang: 'en',
      favorite_count: 1,
      created_at: '2024-01-30T01:10:45.000Z',
      display_text_range: [15, 55],
      entities: {
        hashtags: [],
        urls: [],
        user_mentions: [
          {
            id_str: '1584314875991523328',
            indices: [0, 14],
            name: 'Eonian',
            screen_name: 'EonianFinance',
          },
        ],
        symbols: [],
      },
      id_str: '1752137237750563015',
      text: '@EonianFinance Keep building for the sake of community.',
      user: {
        id_str: '1418246700414631937',
        name: '🦉🦉0xNadskie🕷️🕷️🛹🛹',
        profile_image_url_https: 'https://pbs.twimg.com/profile_images/1795754347126788096/7hOGbeQw_normal.jpg',
        screen_name: 'nadskie_18',
        verified: false,
        is_blue_verified: false,
        profile_image_shape: 'Circle',
      },
      edit_control: {
        edit_tweet_ids: ['1752137237750563015'],
        editable_until_msecs: '1706580645000',
        is_edit_eligible: false,
        edits_remaining: '5',
      },
      conversation_count: 1,
      news_action_type: 'conversation',
      parent: {
        lang: 'en',
        reply_count: 119,
        retweet_count: 224,
        favorite_count: 310,
        possibly_sensitive: false,
        created_at: '2024-01-28T03:18:47.000Z',
        display_text_range: [0, 219],
        entities: {
          hashtags: [
            {
              indices: [58, 65],
              text: 'crypto',
            },
          ],
          urls: [
            {
              display_url: 'eonian.finance',
              expanded_url: 'https://eonian.finance',
              indices: [196, 219],
              url: 'https://t.co/ieieSlLHh5',
            },
          ],
          user_mentions: [],
          symbols: [],
          media: [
            {
              display_url: 'pic.x.com/l6kgkoakqj',
              expanded_url: 'https://twitter.com/EonianFinance/status/1751444681634787806/video/1',
              indices: [220, 243],
              url: 'https://t.co/L6KGKOAkQJ',
            },
          ],
        },
        id_str: '1751444681634787806',
        text: 'Launch of First Decentralized Savings Account\nInsure your #crypto from wallet hacks with zero fees, while passively earning savings premium on your holdings.\n\nLearn more and keep your money safe: https://t.co/ieieSlLHh5 https://t.co/L6KGKOAkQJ',
        user: {
          id_str: '1584314875991523328',
          name: 'Eonian',
          profile_image_url_https: 'https://pbs.twimg.com/profile_images/1768404732949733377/T_w4Y8-E_normal.jpg',
          screen_name: 'EonianFinance',
          verified: false,
          is_blue_verified: true,
          profile_image_shape: 'Circle',
        },
        edit_control: {
          edit_tweet_ids: ['1751444681634787806'],
          editable_until_msecs: '1706415527000',
          is_edit_eligible: true,
          edits_remaining: '5',
        },
        mediaDetails: [
          {
            additional_media_info: {},
            display_url: 'pic.twitter.com/L6KGKOAkQJ',
            expanded_url: 'https://twitter.com/EonianFinance/status/1751444681634787806/video/1',
            ext_media_availability: {
              status: 'Available',
            },
            indices: [220, 243],
            media_url_https: 'https://pbs.twimg.com/ext_tw_video_thumb/1751443920339226624/pu/img/M2wWH3j9NagQhB4p.jpg',
            original_info: {
              height: 1080,
              width: 1920,
              focus_rects: [],
            },
            sizes: {
              large: {
                h: 1080,
                resize: 'fit',
                w: 1920,
              },
              medium: {
                h: 675,
                resize: 'fit',
                w: 1200,
              },
              small: {
                h: 383,
                resize: 'fit',
                w: 680,
              },
              thumb: {
                h: 150,
                resize: 'crop',
                w: 150,
              },
            },
            type: 'video',
            url: 'https://t.co/L6KGKOAkQJ',
            video_info: {
              aspect_ratio: [16, 9],
              duration_millis: 26221,
              variants: [
                {
                  content_type: 'application/x-mpegURL',
                  url: 'https://video.twimg.com/ext_tw_video/1751443920339226624/pu/pl/5V9UUfMQpj2Is9tO.m3u8?tag=14',
                },
                {
                  bitrate: 256000,
                  content_type: 'video/mp4',
                  url: 'https://video.twimg.com/ext_tw_video/1751443920339226624/pu/vid/avc1/480x270/hgqlrSCMAe91lext.mp4?tag=14',
                },
                {
                  bitrate: 832000,
                  content_type: 'video/mp4',
                  url: 'https://video.twimg.com/ext_tw_video/1751443920339226624/pu/vid/avc1/640x360/QGmXdt2Y5iBrAyVR.mp4?tag=14',
                },
                {
                  bitrate: 2176000,
                  content_type: 'video/mp4',
                  url: 'https://video.twimg.com/ext_tw_video/1751443920339226624/pu/vid/avc1/1280x720/kFv4jIOxO3dF12WE.mp4?tag=14',
                },
                {
                  bitrate: 10368000,
                  content_type: 'video/mp4',
                  url: 'https://video.twimg.com/ext_tw_video/1751443920339226624/pu/vid/avc1/1920x1080/GWono6WDbJZs1sSX.mp4?tag=14',
                },
              ],
            },
          },
        ],
        photos: [],
        video: {
          aspectRatio: [16, 9],
          contentType: 'media_entity',
          durationMs: 26221,
          mediaAvailability: {
            status: 'available',
          },
          poster: 'https://pbs.twimg.com/ext_tw_video_thumb/1751443920339226624/pu/img/M2wWH3j9NagQhB4p.jpg',
          variants: [
            {
              type: 'application/x-mpegURL',
              src: 'https://video.twimg.com/ext_tw_video/1751443920339226624/pu/pl/5V9UUfMQpj2Is9tO.m3u8?tag=14',
            },
            {
              type: 'video/mp4',
              src: 'https://video.twimg.com/ext_tw_video/1751443920339226624/pu/vid/avc1/480x270/hgqlrSCMAe91lext.mp4?tag=14',
            },
            {
              type: 'video/mp4',
              src: 'https://video.twimg.com/ext_tw_video/1751443920339226624/pu/vid/avc1/640x360/QGmXdt2Y5iBrAyVR.mp4?tag=14',
            },
            {
              type: 'video/mp4',
              src: 'https://video.twimg.com/ext_tw_video/1751443920339226624/pu/vid/avc1/1280x720/kFv4jIOxO3dF12WE.mp4?tag=14',
            },
            {
              type: 'video/mp4',
              src: 'https://video.twimg.com/ext_tw_video/1751443920339226624/pu/vid/avc1/1920x1080/GWono6WDbJZs1sSX.mp4?tag=14',
            },
          ],
          videoId: {
            type: 'tweet',
            id: '1751444681634787806',
          },
          viewCount: 0,
        },
        isEdited: false,
        isStaleEdit: false,
      },
      isEdited: false,
      isStaleEdit: false,
    },
    '1789954693709336841': {
      __typename: 'Tweet',
      in_reply_to_screen_name: 'EonianFinance',
      in_reply_to_status_id_str: '1789924316739412125',
      in_reply_to_user_id_str: '1584314875991523328',
      lang: 'en',
      place: {
        full_name: 'Kosovo',
        id: 'ce840961e49976cf',
      },
      favorite_count: 0,
      created_at: '2024-05-13T09:43:49.000Z',
      display_text_range: [15, 41],
      entities: {
        hashtags: [],
        urls: [],
        user_mentions: [
          {
            id_str: '1584314875991523328',
            indices: [0, 14],
            name: 'Eonian',
            screen_name: 'EonianFinance',
          },
        ],
        symbols: [],
      },
      id_str: '1789954693709336841',
      text: '@EonianFinance something indeed is coming',
      user: {
        id_str: '387337141',
        name: 'Qazim Rama 🥷',
        profile_image_url_https: 'https://pbs.twimg.com/profile_images/1506332833857552394/Kwrt1V_6_normal.png',
        screen_name: 'qazim_rama',
        verified: false,
        is_blue_verified: false,
        profile_image_shape: 'Circle',
      },
      edit_control: {
        edit_tweet_ids: ['1789954693709336841'],
        editable_until_msecs: '1715597029000',
        is_edit_eligible: false,
        edits_remaining: '5',
      },
      conversation_count: 0,
      news_action_type: 'conversation',
      parent: {
        lang: 'en',
        reply_count: 35,
        retweet_count: 34,
        favorite_count: 38,
        possibly_sensitive: false,
        created_at: '2024-05-13T07:43:06.000Z',
        display_text_range: [0, 276],
        entities: {
          hashtags: [],
          urls: [],
          user_mentions: [],
          symbols: [],
          media: [
            {
              display_url: 'pic.x.com/r6tfmn7acr',
              expanded_url: 'https://twitter.com/EonianFinance/status/1789924316739412125/photo/1',
              indices: [277, 300],
              url: 'https://t.co/r6tfMn7Acr',
            },
          ],
        },
        id_str: '1789924316739412125',
        text: 'Open Beta Announce\nMore than a year ago, we launched our protocol in closed alpha. Since then, we have refined our solution, fixed many bugs, and added awesome features. That means very soon, we will be ready to launch our protocol in open beta and allow anyone to save their… https://t.co/r6tfMn7Acr',
        user: {
          id_str: '1584314875991523328',
          name: 'Eonian',
          profile_image_url_https: 'https://pbs.twimg.com/profile_images/1768404732949733377/T_w4Y8-E_normal.jpg',
          screen_name: 'EonianFinance',
          verified: false,
          is_blue_verified: true,
          profile_image_shape: 'Circle',
        },
        edit_control: {
          edit_tweet_ids: ['1789924316739412125'],
          editable_until_msecs: '1715589786000',
          is_edit_eligible: true,
          edits_remaining: '5',
        },
        mediaDetails: [
          {
            display_url: 'pic.twitter.com/r6tfMn7Acr',
            expanded_url: 'https://twitter.com/EonianFinance/status/1789924316739412125/photo/1',
            ext_media_availability: {
              status: 'Available',
            },
            indices: [277, 300],
            media_url_https: 'https://pbs.twimg.com/media/GNcWIa_W8AAvae_.jpg',
            original_info: {
              height: 1250,
              width: 1250,
              focus_rects: [
                {
                  x: 0,
                  y: 118,
                  w: 1250,
                  h: 700,
                },
                {
                  x: 0,
                  y: 0,
                  w: 1250,
                  h: 1250,
                },
                {
                  x: 45,
                  y: 0,
                  w: 1096,
                  h: 1250,
                },
                {
                  x: 281,
                  y: 0,
                  w: 625,
                  h: 1250,
                },
                {
                  x: 0,
                  y: 0,
                  w: 1250,
                  h: 1250,
                },
              ],
            },
            sizes: {
              large: {
                h: 1250,
                resize: 'fit',
                w: 1250,
              },
              medium: {
                h: 1200,
                resize: 'fit',
                w: 1200,
              },
              small: {
                h: 680,
                resize: 'fit',
                w: 680,
              },
              thumb: {
                h: 150,
                resize: 'crop',
                w: 150,
              },
            },
            type: 'photo',
            url: 'https://t.co/r6tfMn7Acr',
          },
        ],
        photos: [
          {
            backgroundColor: {
              red: 204,
              green: 214,
              blue: 221,
            },
            cropCandidates: [
              {
                x: 0,
                y: 118,
                w: 1250,
                h: 700,
              },
              {
                x: 0,
                y: 0,
                w: 1250,
                h: 1250,
              },
              {
                x: 45,
                y: 0,
                w: 1096,
                h: 1250,
              },
              {
                x: 281,
                y: 0,
                w: 625,
                h: 1250,
              },
              {
                x: 0,
                y: 0,
                w: 1250,
                h: 1250,
              },
            ],
            expandedUrl: 'https://twitter.com/EonianFinance/status/1789924316739412125/photo/1',
            url: 'https://pbs.twimg.com/media/GNcWIa_W8AAvae_.jpg',
            width: 1250,
            height: 1250,
          },
        ],
        isEdited: false,
        isStaleEdit: false,
      },
      isEdited: false,
      isStaleEdit: false,
    },
    '1697744396374950148': {
      __typename: 'Tweet',
      in_reply_to_screen_name: 'EonianFinance',
      in_reply_to_status_id_str: '1680276680319836162',
      in_reply_to_user_id_str: '1584314875991523328',
      lang: 'en',
      favorite_count: 0,
      created_at: '2023-09-01T22:53:01.000Z',
      display_text_range: [15, 31],
      entities: {
        hashtags: [],
        urls: [],
        user_mentions: [
          {
            id_str: '1584314875991523328',
            indices: [0, 14],
            name: 'Eonian',
            screen_name: 'EonianFinance',
          },
        ],
        symbols: [],
      },
      id_str: '1697744396374950148',
      text: '@EonianFinance Awesome guys🚀😍',
      user: {
        id_str: '1694673245948063745',
        name: 'sherrif bayo',
        profile_image_url_https: 'https://pbs.twimg.com/profile_images/1694673577847529472/jh3tMBGD_normal.jpg',
        screen_name: 'BayoSherri60626',
        verified: false,
        is_blue_verified: false,
        profile_image_shape: 'Circle',
      },
      edit_control: {
        edit_tweet_ids: ['1697744396374950148'],
        editable_until_msecs: '1693612381000',
        is_edit_eligible: false,
        edits_remaining: '5',
      },
      conversation_count: 0,
      news_action_type: 'conversation',
      parent: {
        lang: 'en',
        reply_count: 75,
        retweet_count: 49,
        favorite_count: 64,
        possibly_sensitive: false,
        created_at: '2023-07-15T18:02:33.000Z',
        display_text_range: [0, 279],
        entities: {
          hashtags: [],
          urls: [
            {
              display_url: 'leovs09.notion.site/Community-Rewa…',
              expanded_url: 'https://leovs09.notion.site/Community-Rewards-System-eaa37db4f9944fddabaf2bca1e1066a0',
              indices: [256, 279],
              url: 'https://t.co/KEl9uFuL53',
            },
          ],
          user_mentions: [],
          symbols: [],
        },
        id_str: '1680276680319836162',
        text: 'We are glad to announce the launch of Our Level-Up Channel &amp; Rewards System!\n\nGet reward for engaging in our community. Earn points to level up and gain new roles, to qualify for token retrodrops. Higher roles = bigger rewards\n\nMore info in our Docs : https://t.co/KEl9uFuL53',
        user: {
          id_str: '1584314875991523328',
          name: 'Eonian',
          profile_image_url_https: 'https://pbs.twimg.com/profile_images/1768404732949733377/T_w4Y8-E_normal.jpg',
          screen_name: 'EonianFinance',
          verified: false,
          is_blue_verified: true,
          profile_image_shape: 'Circle',
        },
        edit_control: {
          edit_tweet_ids: ['1680276680319836162'],
          editable_until_msecs: '1689447753000',
          is_edit_eligible: true,
          edits_remaining: '5',
        },
        card: {
          card_platform: {
            platform: {
              audience: {
                name: 'production',
              },
              device: {
                name: 'iPhone',
                version: '13',
              },
            },
          },
          name: 'summary_large_image',
          url: 'https://t.co/KEl9uFuL53',
          binding_values: {
            photo_image_full_size_large: {
              image_value: {
                height: 419,
                width: 800,
                url: 'https://pbs.twimg.com/card_img/1800430057942294529/3zHgWOy8?format=jpg&name=800x419',
              },
              type: 'IMAGE',
            },
            thumbnail_image: {
              image_value: {
                height: 144,
                width: 144,
                url: 'https://pbs.twimg.com/card_img/1800430057942294529/3zHgWOy8?format=jpg&name=144x144',
              },
              type: 'IMAGE',
            },
            description: {
              string_value: 'Welcome to our in-depth guide to our Rewards System in the Discord community.',
              type: 'STRING',
            },
            domain: {
              string_value: 'leovs09.notion.site',
              type: 'STRING',
            },
            thumbnail_image_large: {
              image_value: {
                height: 320,
                width: 320,
                url: 'https://pbs.twimg.com/card_img/1800430057942294529/3zHgWOy8?format=jpg&name=800x320_1',
              },
              type: 'IMAGE',
            },
            summary_photo_image_small: {
              image_value: {
                height: 202,
                width: 386,
                url: 'https://pbs.twimg.com/card_img/1800430057942294529/3zHgWOy8?format=jpg&name=386x202',
              },
              type: 'IMAGE',
            },
            thumbnail_image_original: {
              image_value: {
                height: 2000,
                width: 2000,
                url: 'https://pbs.twimg.com/card_img/1800430057942294529/3zHgWOy8?format=jpg&name=orig',
              },
              type: 'IMAGE',
            },
            photo_image_full_size_small: {
              image_value: {
                height: 202,
                width: 386,
                url: 'https://pbs.twimg.com/card_img/1800430057942294529/3zHgWOy8?format=jpg&name=386x202',
              },
              type: 'IMAGE',
            },
            summary_photo_image_large: {
              image_value: {
                height: 419,
                width: 800,
                url: 'https://pbs.twimg.com/card_img/1800430057942294529/3zHgWOy8?format=jpg&name=800x419',
              },
              type: 'IMAGE',
            },
            thumbnail_image_small: {
              image_value: {
                height: 100,
                width: 100,
                url: 'https://pbs.twimg.com/card_img/1800430057942294529/3zHgWOy8?format=jpg&name=100x100',
              },
              type: 'IMAGE',
            },
            thumbnail_image_x_large: {
              image_value: {
                height: 2000,
                width: 2000,
                url: 'https://pbs.twimg.com/card_img/1800430057942294529/3zHgWOy8?format=png&name=2048x2048_2_exp',
              },
              type: 'IMAGE',
            },
            photo_image_full_size_original: {
              image_value: {
                height: 2000,
                width: 2000,
                url: 'https://pbs.twimg.com/card_img/1800430057942294529/3zHgWOy8?format=jpg&name=orig',
              },
              type: 'IMAGE',
            },
            vanity_url: {
              scribe_key: 'vanity_url',
              string_value: 'leovs09.notion.site',
              type: 'STRING',
            },
            photo_image_full_size: {
              image_value: {
                height: 314,
                width: 600,
                url: 'https://pbs.twimg.com/card_img/1800430057942294529/3zHgWOy8?format=jpg&name=600x314',
              },
              type: 'IMAGE',
            },
            thumbnail_image_color: {
              image_color_value: {
                palette: [
                  {
                    rgb: {
                      blue: 83,
                      green: 44,
                      red: 216,
                    },
                    percentage: 17.88,
                  },
                  {
                    rgb: {
                      blue: 115,
                      green: 60,
                      red: 193,
                    },
                    percentage: 16.71,
                  },
                  {
                    rgb: {
                      blue: 205,
                      green: 88,
                      red: 88,
                    },
                    percentage: 12.9,
                  },
                  {
                    rgb: {
                      blue: 148,
                      green: 70,
                      red: 159,
                    },
                    percentage: 12.13,
                  },
                  {
                    rgb: {
                      blue: 187,
                      green: 112,
                      red: 133,
                    },
                    percentage: 10,
                  },
                ],
              },
              type: 'IMAGE_COLOR',
            },
            title: {
              string_value: 'Community Rewards System | Notion',
              type: 'STRING',
            },
            summary_photo_image_color: {
              image_color_value: {
                palette: [
                  {
                    rgb: {
                      blue: 83,
                      green: 44,
                      red: 216,
                    },
                    percentage: 17.88,
                  },
                  {
                    rgb: {
                      blue: 115,
                      green: 60,
                      red: 193,
                    },
                    percentage: 16.71,
                  },
                  {
                    rgb: {
                      blue: 205,
                      green: 88,
                      red: 88,
                    },
                    percentage: 12.9,
                  },
                  {
                    rgb: {
                      blue: 148,
                      green: 70,
                      red: 159,
                    },
                    percentage: 12.13,
                  },
                  {
                    rgb: {
                      blue: 187,
                      green: 112,
                      red: 133,
                    },
                    percentage: 10,
                  },
                ],
              },
              type: 'IMAGE_COLOR',
            },
            summary_photo_image_x_large: {
              image_value: {
                height: 2000,
                width: 2000,
                url: 'https://pbs.twimg.com/card_img/1800430057942294529/3zHgWOy8?format=png&name=2048x2048_2_exp',
              },
              type: 'IMAGE',
            },
            summary_photo_image: {
              image_value: {
                height: 314,
                width: 600,
                url: 'https://pbs.twimg.com/card_img/1800430057942294529/3zHgWOy8?format=jpg&name=600x314',
              },
              type: 'IMAGE',
            },
            photo_image_full_size_color: {
              image_color_value: {
                palette: [
                  {
                    rgb: {
                      blue: 83,
                      green: 44,
                      red: 216,
                    },
                    percentage: 17.88,
                  },
                  {
                    rgb: {
                      blue: 115,
                      green: 60,
                      red: 193,
                    },
                    percentage: 16.71,
                  },
                  {
                    rgb: {
                      blue: 205,
                      green: 88,
                      red: 88,
                    },
                    percentage: 12.9,
                  },
                  {
                    rgb: {
                      blue: 148,
                      green: 70,
                      red: 159,
                    },
                    percentage: 12.13,
                  },
                  {
                    rgb: {
                      blue: 187,
                      green: 112,
                      red: 133,
                    },
                    percentage: 10,
                  },
                ],
              },
              type: 'IMAGE_COLOR',
            },
            photo_image_full_size_x_large: {
              image_value: {
                height: 2000,
                width: 2000,
                url: 'https://pbs.twimg.com/card_img/1800430057942294529/3zHgWOy8?format=png&name=2048x2048_2_exp',
              },
              type: 'IMAGE',
            },
            card_url: {
              scribe_key: 'card_url',
              string_value: 'https://t.co/KEl9uFuL53',
              type: 'STRING',
            },
            summary_photo_image_original: {
              image_value: {
                height: 2000,
                width: 2000,
                url: 'https://pbs.twimg.com/card_img/1800430057942294529/3zHgWOy8?format=jpg&name=orig',
              },
              type: 'IMAGE',
            },
          },
        },
        isEdited: false,
        isStaleEdit: false,
      },
      isEdited: false,
      isStaleEdit: false,
    },
    '1790006969123607025': {
      __typename: 'Tweet',
      in_reply_to_screen_name: 'EonianFinance',
      in_reply_to_status_id_str: '1789924316739412125',
      in_reply_to_user_id_str: '1584314875991523328',
      lang: 'en',
      favorite_count: 0,
      created_at: '2024-05-13T13:11:32.000Z',
      display_text_range: [15, 74],
      entities: {
        hashtags: [],
        urls: [],
        user_mentions: [
          {
            id_str: '1584314875991523328',
            indices: [0, 14],
            name: 'Eonian',
            screen_name: 'EonianFinance',
          },
        ],
        symbols: [],
      },
      id_str: '1790006969123607025',
      text: '@EonianFinance I enthusiastically participate in this and also support it.',
      user: {
        id_str: '1751208246155644928',
        name: 'Viktor Zahar♦️Tabi',
        profile_image_url_https: 'https://pbs.twimg.com/profile_images/1751210115628195841/OmmlFZQf_normal.jpg',
        screen_name: 'ViktorZ90',
        verified: false,
        is_blue_verified: false,
        profile_image_shape: 'Circle',
      },
      edit_control: {
        edit_tweet_ids: ['1790006969123607025'],
        editable_until_msecs: '1715609492000',
        is_edit_eligible: false,
        edits_remaining: '5',
      },
      conversation_count: 0,
      news_action_type: 'conversation',
      parent: {
        lang: 'en',
        reply_count: 35,
        retweet_count: 34,
        favorite_count: 38,
        possibly_sensitive: false,
        created_at: '2024-05-13T07:43:06.000Z',
        display_text_range: [0, 276],
        entities: {
          hashtags: [],
          urls: [],
          user_mentions: [],
          symbols: [],
          media: [
            {
              display_url: 'pic.x.com/r6tfmn7acr',
              expanded_url: 'https://twitter.com/EonianFinance/status/1789924316739412125/photo/1',
              indices: [277, 300],
              url: 'https://t.co/r6tfMn7Acr',
            },
          ],
        },
        id_str: '1789924316739412125',
        text: 'Open Beta Announce\nMore than a year ago, we launched our protocol in closed alpha. Since then, we have refined our solution, fixed many bugs, and added awesome features. That means very soon, we will be ready to launch our protocol in open beta and allow anyone to save their… https://t.co/r6tfMn7Acr',
        user: {
          id_str: '1584314875991523328',
          name: 'Eonian',
          profile_image_url_https: 'https://pbs.twimg.com/profile_images/1768404732949733377/T_w4Y8-E_normal.jpg',
          screen_name: 'EonianFinance',
          verified: false,
          is_blue_verified: true,
          profile_image_shape: 'Circle',
        },
        edit_control: {
          edit_tweet_ids: ['1789924316739412125'],
          editable_until_msecs: '1715589786000',
          is_edit_eligible: true,
          edits_remaining: '5',
        },
        mediaDetails: [
          {
            display_url: 'pic.twitter.com/r6tfMn7Acr',
            expanded_url: 'https://twitter.com/EonianFinance/status/1789924316739412125/photo/1',
            ext_media_availability: {
              status: 'Available',
            },
            indices: [277, 300],
            media_url_https: 'https://pbs.twimg.com/media/GNcWIa_W8AAvae_.jpg',
            original_info: {
              height: 1250,
              width: 1250,
              focus_rects: [
                {
                  x: 0,
                  y: 118,
                  w: 1250,
                  h: 700,
                },
                {
                  x: 0,
                  y: 0,
                  w: 1250,
                  h: 1250,
                },
                {
                  x: 45,
                  y: 0,
                  w: 1096,
                  h: 1250,
                },
                {
                  x: 281,
                  y: 0,
                  w: 625,
                  h: 1250,
                },
                {
                  x: 0,
                  y: 0,
                  w: 1250,
                  h: 1250,
                },
              ],
            },
            sizes: {
              large: {
                h: 1250,
                resize: 'fit',
                w: 1250,
              },
              medium: {
                h: 1200,
                resize: 'fit',
                w: 1200,
              },
              small: {
                h: 680,
                resize: 'fit',
                w: 680,
              },
              thumb: {
                h: 150,
                resize: 'crop',
                w: 150,
              },
            },
            type: 'photo',
            url: 'https://t.co/r6tfMn7Acr',
          },
        ],
        photos: [
          {
            backgroundColor: {
              red: 204,
              green: 214,
              blue: 221,
            },
            cropCandidates: [
              {
                x: 0,
                y: 118,
                w: 1250,
                h: 700,
              },
              {
                x: 0,
                y: 0,
                w: 1250,
                h: 1250,
              },
              {
                x: 45,
                y: 0,
                w: 1096,
                h: 1250,
              },
              {
                x: 281,
                y: 0,
                w: 625,
                h: 1250,
              },
              {
                x: 0,
                y: 0,
                w: 1250,
                h: 1250,
              },
            ],
            expandedUrl: 'https://twitter.com/EonianFinance/status/1789924316739412125/photo/1',
            url: 'https://pbs.twimg.com/media/GNcWIa_W8AAvae_.jpg',
            width: 1250,
            height: 1250,
          },
        ],
        isEdited: false,
        isStaleEdit: false,
      },
      isEdited: false,
      isStaleEdit: false,
    },
    '1765167523941826602': {
      __typename: 'Tweet',
      in_reply_to_screen_name: 'EonianFinance',
      in_reply_to_status_id_str: '1751444681634787806',
      in_reply_to_user_id_str: '1584314875991523328',
      lang: 'en',
      favorite_count: 0,
      created_at: '2024-03-06T00:08:27.000Z',
      display_text_range: [15, 34],
      entities: {
        hashtags: [],
        urls: [],
        user_mentions: [
          {
            id_str: '1584314875991523328',
            indices: [0, 14],
            name: 'Eonian',
            screen_name: 'EonianFinance',
          },
        ],
        symbols: [],
      },
      id_str: '1765167523941826602',
      text: '@EonianFinance great potential LFG',
      user: {
        id_str: '1738679854193868800',
        name: 'nicu',
        profile_image_url_https: 'https://pbs.twimg.com/profile_images/1750820710334013441/4Wvjs3EP_normal.jpg',
        screen_name: 'much_sin24',
        verified: false,
        is_blue_verified: false,
        profile_image_shape: 'Circle',
      },
      edit_control: {
        edit_tweet_ids: ['1765167523941826602'],
        editable_until_msecs: '1709687307000',
        is_edit_eligible: false,
        edits_remaining: '5',
      },
      conversation_count: 0,
      news_action_type: 'conversation',
      parent: {
        lang: 'en',
        reply_count: 119,
        retweet_count: 224,
        favorite_count: 310,
        possibly_sensitive: false,
        created_at: '2024-01-28T03:18:47.000Z',
        display_text_range: [0, 219],
        entities: {
          hashtags: [
            {
              indices: [58, 65],
              text: 'crypto',
            },
          ],
          urls: [
            {
              display_url: 'eonian.finance',
              expanded_url: 'https://eonian.finance',
              indices: [196, 219],
              url: 'https://t.co/ieieSlLHh5',
            },
          ],
          user_mentions: [],
          symbols: [],
          media: [
            {
              display_url: 'pic.x.com/l6kgkoakqj',
              expanded_url: 'https://twitter.com/EonianFinance/status/1751444681634787806/video/1',
              indices: [220, 243],
              url: 'https://t.co/L6KGKOAkQJ',
            },
          ],
        },
        id_str: '1751444681634787806',
        text: 'Launch of First Decentralized Savings Account\nInsure your #crypto from wallet hacks with zero fees, while passively earning savings premium on your holdings.\n\nLearn more and keep your money safe: https://t.co/ieieSlLHh5 https://t.co/L6KGKOAkQJ',
        user: {
          id_str: '1584314875991523328',
          name: 'Eonian',
          profile_image_url_https: 'https://pbs.twimg.com/profile_images/1768404732949733377/T_w4Y8-E_normal.jpg',
          screen_name: 'EonianFinance',
          verified: false,
          is_blue_verified: true,
          profile_image_shape: 'Circle',
        },
        edit_control: {
          edit_tweet_ids: ['1751444681634787806'],
          editable_until_msecs: '1706415527000',
          is_edit_eligible: true,
          edits_remaining: '5',
        },
        mediaDetails: [
          {
            additional_media_info: {},
            display_url: 'pic.twitter.com/L6KGKOAkQJ',
            expanded_url: 'https://twitter.com/EonianFinance/status/1751444681634787806/video/1',
            ext_media_availability: {
              status: 'Available',
            },
            indices: [220, 243],
            media_url_https: 'https://pbs.twimg.com/ext_tw_video_thumb/1751443920339226624/pu/img/M2wWH3j9NagQhB4p.jpg',
            original_info: {
              height: 1080,
              width: 1920,
              focus_rects: [],
            },
            sizes: {
              large: {
                h: 1080,
                resize: 'fit',
                w: 1920,
              },
              medium: {
                h: 675,
                resize: 'fit',
                w: 1200,
              },
              small: {
                h: 383,
                resize: 'fit',
                w: 680,
              },
              thumb: {
                h: 150,
                resize: 'crop',
                w: 150,
              },
            },
            type: 'video',
            url: 'https://t.co/L6KGKOAkQJ',
            video_info: {
              aspect_ratio: [16, 9],
              duration_millis: 26221,
              variants: [
                {
                  content_type: 'application/x-mpegURL',
                  url: 'https://video.twimg.com/ext_tw_video/1751443920339226624/pu/pl/5V9UUfMQpj2Is9tO.m3u8?tag=14',
                },
                {
                  bitrate: 256000,
                  content_type: 'video/mp4',
                  url: 'https://video.twimg.com/ext_tw_video/1751443920339226624/pu/vid/avc1/480x270/hgqlrSCMAe91lext.mp4?tag=14',
                },
                {
                  bitrate: 832000,
                  content_type: 'video/mp4',
                  url: 'https://video.twimg.com/ext_tw_video/1751443920339226624/pu/vid/avc1/640x360/QGmXdt2Y5iBrAyVR.mp4?tag=14',
                },
                {
                  bitrate: 2176000,
                  content_type: 'video/mp4',
                  url: 'https://video.twimg.com/ext_tw_video/1751443920339226624/pu/vid/avc1/1280x720/kFv4jIOxO3dF12WE.mp4?tag=14',
                },
                {
                  bitrate: 10368000,
                  content_type: 'video/mp4',
                  url: 'https://video.twimg.com/ext_tw_video/1751443920339226624/pu/vid/avc1/1920x1080/GWono6WDbJZs1sSX.mp4?tag=14',
                },
              ],
            },
          },
        ],
        photos: [],
        video: {
          aspectRatio: [16, 9],
          contentType: 'media_entity',
          durationMs: 26221,
          mediaAvailability: {
            status: 'available',
          },
          poster: 'https://pbs.twimg.com/ext_tw_video_thumb/1751443920339226624/pu/img/M2wWH3j9NagQhB4p.jpg',
          variants: [
            {
              type: 'application/x-mpegURL',
              src: 'https://video.twimg.com/ext_tw_video/1751443920339226624/pu/pl/5V9UUfMQpj2Is9tO.m3u8?tag=14',
            },
            {
              type: 'video/mp4',
              src: 'https://video.twimg.com/ext_tw_video/1751443920339226624/pu/vid/avc1/480x270/hgqlrSCMAe91lext.mp4?tag=14',
            },
            {
              type: 'video/mp4',
              src: 'https://video.twimg.com/ext_tw_video/1751443920339226624/pu/vid/avc1/640x360/QGmXdt2Y5iBrAyVR.mp4?tag=14',
            },
            {
              type: 'video/mp4',
              src: 'https://video.twimg.com/ext_tw_video/1751443920339226624/pu/vid/avc1/1280x720/kFv4jIOxO3dF12WE.mp4?tag=14',
            },
            {
              type: 'video/mp4',
              src: 'https://video.twimg.com/ext_tw_video/1751443920339226624/pu/vid/avc1/1920x1080/GWono6WDbJZs1sSX.mp4?tag=14',
            },
          ],
          videoId: {
            type: 'tweet',
            id: '1751444681634787806',
          },
          viewCount: 0,
        },
        isEdited: false,
        isStaleEdit: false,
      },
      isEdited: false,
      isStaleEdit: false,
    },
    '1697593964205879635': {
      __typename: 'Tweet',
      in_reply_to_screen_name: 'EonianFinance',
      in_reply_to_status_id_str: '1680276680319836162',
      in_reply_to_user_id_str: '1584314875991523328',
      lang: 'en',
      favorite_count: 0,
      created_at: '2023-09-01T12:55:15.000Z',
      display_text_range: [15, 66],
      entities: {
        hashtags: [],
        urls: [],
        user_mentions: [
          {
            id_str: '1584314875991523328',
            indices: [0, 14],
            name: 'Eonian',
            screen_name: 'EonianFinance',
          },
        ],
        symbols: [],
      },
      id_str: '1697593964205879635',
      text: '@EonianFinance Guys, you can\'t miss this, get engage while earning',
      user: {
        id_str: '1481494764927307776',
        name: 'Awasiakan Udo',
        profile_image_url_https: 'https://pbs.twimg.com/profile_images/1788583962845032448/0d_Y2SCW_normal.jpg',
        screen_name: 'AwasiakanUdo',
        verified: false,
        is_blue_verified: false,
        profile_image_shape: 'Circle',
      },
      edit_control: {
        edit_tweet_ids: ['1697593964205879635'],
        editable_until_msecs: '1693576515000',
        is_edit_eligible: false,
        edits_remaining: '5',
      },
      conversation_count: 0,
      news_action_type: 'conversation',
      parent: {
        lang: 'en',
        reply_count: 75,
        retweet_count: 49,
        favorite_count: 64,
        possibly_sensitive: false,
        created_at: '2023-07-15T18:02:33.000Z',
        display_text_range: [0, 279],
        entities: {
          hashtags: [],
          urls: [
            {
              display_url: 'leovs09.notion.site/Community-Rewa…',
              expanded_url: 'https://leovs09.notion.site/Community-Rewards-System-eaa37db4f9944fddabaf2bca1e1066a0',
              indices: [256, 279],
              url: 'https://t.co/KEl9uFuL53',
            },
          ],
          user_mentions: [],
          symbols: [],
        },
        id_str: '1680276680319836162',
        text: 'We are glad to announce the launch of Our Level-Up Channel &amp; Rewards System!\n\nGet reward for engaging in our community. Earn points to level up and gain new roles, to qualify for token retrodrops. Higher roles = bigger rewards\n\nMore info in our Docs : https://t.co/KEl9uFuL53',
        user: {
          id_str: '1584314875991523328',
          name: 'Eonian',
          profile_image_url_https: 'https://pbs.twimg.com/profile_images/1768404732949733377/T_w4Y8-E_normal.jpg',
          screen_name: 'EonianFinance',
          verified: false,
          is_blue_verified: true,
          profile_image_shape: 'Circle',
        },
        edit_control: {
          edit_tweet_ids: ['1680276680319836162'],
          editable_until_msecs: '1689447753000',
          is_edit_eligible: true,
          edits_remaining: '5',
        },
        card: {
          card_platform: {
            platform: {
              audience: {
                name: 'production',
              },
              device: {
                name: 'iPhone',
                version: '13',
              },
            },
          },
          name: 'summary_large_image',
          url: 'https://t.co/KEl9uFuL53',
          binding_values: {
            photo_image_full_size_large: {
              image_value: {
                height: 419,
                width: 800,
                url: 'https://pbs.twimg.com/card_img/1800430057942294529/3zHgWOy8?format=jpg&name=800x419',
              },
              type: 'IMAGE',
            },
            thumbnail_image: {
              image_value: {
                height: 144,
                width: 144,
                url: 'https://pbs.twimg.com/card_img/1800430057942294529/3zHgWOy8?format=jpg&name=144x144',
              },
              type: 'IMAGE',
            },
            description: {
              string_value: 'Welcome to our in-depth guide to our Rewards System in the Discord community.',
              type: 'STRING',
            },
            domain: {
              string_value: 'leovs09.notion.site',
              type: 'STRING',
            },
            thumbnail_image_large: {
              image_value: {
                height: 320,
                width: 320,
                url: 'https://pbs.twimg.com/card_img/1800430057942294529/3zHgWOy8?format=jpg&name=800x320_1',
              },
              type: 'IMAGE',
            },
            summary_photo_image_small: {
              image_value: {
                height: 202,
                width: 386,
                url: 'https://pbs.twimg.com/card_img/1800430057942294529/3zHgWOy8?format=jpg&name=386x202',
              },
              type: 'IMAGE',
            },
            thumbnail_image_original: {
              image_value: {
                height: 2000,
                width: 2000,
                url: 'https://pbs.twimg.com/card_img/1800430057942294529/3zHgWOy8?format=jpg&name=orig',
              },
              type: 'IMAGE',
            },
            photo_image_full_size_small: {
              image_value: {
                height: 202,
                width: 386,
                url: 'https://pbs.twimg.com/card_img/1800430057942294529/3zHgWOy8?format=jpg&name=386x202',
              },
              type: 'IMAGE',
            },
            summary_photo_image_large: {
              image_value: {
                height: 419,
                width: 800,
                url: 'https://pbs.twimg.com/card_img/1800430057942294529/3zHgWOy8?format=jpg&name=800x419',
              },
              type: 'IMAGE',
            },
            thumbnail_image_small: {
              image_value: {
                height: 100,
                width: 100,
                url: 'https://pbs.twimg.com/card_img/1800430057942294529/3zHgWOy8?format=jpg&name=100x100',
              },
              type: 'IMAGE',
            },
            thumbnail_image_x_large: {
              image_value: {
                height: 2000,
                width: 2000,
                url: 'https://pbs.twimg.com/card_img/1800430057942294529/3zHgWOy8?format=png&name=2048x2048_2_exp',
              },
              type: 'IMAGE',
            },
            photo_image_full_size_original: {
              image_value: {
                height: 2000,
                width: 2000,
                url: 'https://pbs.twimg.com/card_img/1800430057942294529/3zHgWOy8?format=jpg&name=orig',
              },
              type: 'IMAGE',
            },
            vanity_url: {
              scribe_key: 'vanity_url',
              string_value: 'leovs09.notion.site',
              type: 'STRING',
            },
            photo_image_full_size: {
              image_value: {
                height: 314,
                width: 600,
                url: 'https://pbs.twimg.com/card_img/1800430057942294529/3zHgWOy8?format=jpg&name=600x314',
              },
              type: 'IMAGE',
            },
            thumbnail_image_color: {
              image_color_value: {
                palette: [
                  {
                    rgb: {
                      blue: 83,
                      green: 44,
                      red: 216,
                    },
                    percentage: 17.88,
                  },
                  {
                    rgb: {
                      blue: 115,
                      green: 60,
                      red: 193,
                    },
                    percentage: 16.71,
                  },
                  {
                    rgb: {
                      blue: 205,
                      green: 88,
                      red: 88,
                    },
                    percentage: 12.9,
                  },
                  {
                    rgb: {
                      blue: 148,
                      green: 70,
                      red: 159,
                    },
                    percentage: 12.13,
                  },
                  {
                    rgb: {
                      blue: 187,
                      green: 112,
                      red: 133,
                    },
                    percentage: 10,
                  },
                ],
              },
              type: 'IMAGE_COLOR',
            },
            title: {
              string_value: 'Community Rewards System | Notion',
              type: 'STRING',
            },
            summary_photo_image_color: {
              image_color_value: {
                palette: [
                  {
                    rgb: {
                      blue: 83,
                      green: 44,
                      red: 216,
                    },
                    percentage: 17.88,
                  },
                  {
                    rgb: {
                      blue: 115,
                      green: 60,
                      red: 193,
                    },
                    percentage: 16.71,
                  },
                  {
                    rgb: {
                      blue: 205,
                      green: 88,
                      red: 88,
                    },
                    percentage: 12.9,
                  },
                  {
                    rgb: {
                      blue: 148,
                      green: 70,
                      red: 159,
                    },
                    percentage: 12.13,
                  },
                  {
                    rgb: {
                      blue: 187,
                      green: 112,
                      red: 133,
                    },
                    percentage: 10,
                  },
                ],
              },
              type: 'IMAGE_COLOR',
            },
            summary_photo_image_x_large: {
              image_value: {
                height: 2000,
                width: 2000,
                url: 'https://pbs.twimg.com/card_img/1800430057942294529/3zHgWOy8?format=png&name=2048x2048_2_exp',
              },
              type: 'IMAGE',
            },
            summary_photo_image: {
              image_value: {
                height: 314,
                width: 600,
                url: 'https://pbs.twimg.com/card_img/1800430057942294529/3zHgWOy8?format=jpg&name=600x314',
              },
              type: 'IMAGE',
            },
            photo_image_full_size_color: {
              image_color_value: {
                palette: [
                  {
                    rgb: {
                      blue: 83,
                      green: 44,
                      red: 216,
                    },
                    percentage: 17.88,
                  },
                  {
                    rgb: {
                      blue: 115,
                      green: 60,
                      red: 193,
                    },
                    percentage: 16.71,
                  },
                  {
                    rgb: {
                      blue: 205,
                      green: 88,
                      red: 88,
                    },
                    percentage: 12.9,
                  },
                  {
                    rgb: {
                      blue: 148,
                      green: 70,
                      red: 159,
                    },
                    percentage: 12.13,
                  },
                  {
                    rgb: {
                      blue: 187,
                      green: 112,
                      red: 133,
                    },
                    percentage: 10,
                  },
                ],
              },
              type: 'IMAGE_COLOR',
            },
            photo_image_full_size_x_large: {
              image_value: {
                height: 2000,
                width: 2000,
                url: 'https://pbs.twimg.com/card_img/1800430057942294529/3zHgWOy8?format=png&name=2048x2048_2_exp',
              },
              type: 'IMAGE',
            },
            card_url: {
              scribe_key: 'card_url',
              string_value: 'https://t.co/KEl9uFuL53',
              type: 'STRING',
            },
            summary_photo_image_original: {
              image_value: {
                height: 2000,
                width: 2000,
                url: 'https://pbs.twimg.com/card_img/1800430057942294529/3zHgWOy8?format=jpg&name=orig',
              },
              type: 'IMAGE',
            },
          },
        },
        isEdited: false,
        isStaleEdit: false,
      },
      isEdited: false,
      isStaleEdit: false,
    },
    '1700279948542370236': {
      __typename: 'Tweet',
      in_reply_to_screen_name: 'EonianFinance',
      in_reply_to_status_id_str: '1680276680319836162',
      in_reply_to_user_id_str: '1584314875991523328',
      lang: 'en',
      favorite_count: 0,
      created_at: '2023-09-08T22:48:24.000Z',
      display_text_range: [15, 40],
      entities: {
        hashtags: [],
        urls: [],
        user_mentions: [
          {
            id_str: '1584314875991523328',
            indices: [0, 14],
            name: 'Eonian',
            screen_name: 'EonianFinance',
          },
        ],
        symbols: [],
      },
      id_str: '1700279948542370236',
      text: '@EonianFinance I am joining this project',
      user: {
        id_str: '1699461723810328576',
        name: 'Alexandra adedayo',
        profile_image_url_https: 'https://pbs.twimg.com/profile_images/1699462002278572032/AjS7A7_F_normal.jpg',
        screen_name: 'Alexandrabayoo',
        verified: false,
        is_blue_verified: false,
        profile_image_shape: 'Circle',
      },
      edit_control: {
        edit_tweet_ids: ['1700279948542370236'],
        editable_until_msecs: '1694216904000',
        is_edit_eligible: false,
        edits_remaining: '5',
      },
      conversation_count: 0,
      news_action_type: 'conversation',
      parent: {
        lang: 'en',
        reply_count: 75,
        retweet_count: 49,
        favorite_count: 64,
        possibly_sensitive: false,
        created_at: '2023-07-15T18:02:33.000Z',
        display_text_range: [0, 279],
        entities: {
          hashtags: [],
          urls: [
            {
              display_url: 'leovs09.notion.site/Community-Rewa…',
              expanded_url: 'https://leovs09.notion.site/Community-Rewards-System-eaa37db4f9944fddabaf2bca1e1066a0',
              indices: [256, 279],
              url: 'https://t.co/KEl9uFuL53',
            },
          ],
          user_mentions: [],
          symbols: [],
        },
        id_str: '1680276680319836162',
        text: 'We are glad to announce the launch of Our Level-Up Channel &amp; Rewards System!\n\nGet reward for engaging in our community. Earn points to level up and gain new roles, to qualify for token retrodrops. Higher roles = bigger rewards\n\nMore info in our Docs : https://t.co/KEl9uFuL53',
        user: {
          id_str: '1584314875991523328',
          name: 'Eonian',
          profile_image_url_https: 'https://pbs.twimg.com/profile_images/1768404732949733377/T_w4Y8-E_normal.jpg',
          screen_name: 'EonianFinance',
          verified: false,
          is_blue_verified: true,
          profile_image_shape: 'Circle',
        },
        edit_control: {
          edit_tweet_ids: ['1680276680319836162'],
          editable_until_msecs: '1689447753000',
          is_edit_eligible: true,
          edits_remaining: '5',
        },
        card: {
          card_platform: {
            platform: {
              audience: {
                name: 'production',
              },
              device: {
                name: 'iPhone',
                version: '13',
              },
            },
          },
          name: 'summary_large_image',
          url: 'https://t.co/KEl9uFuL53',
          binding_values: {
            photo_image_full_size_large: {
              image_value: {
                height: 419,
                width: 800,
                url: 'https://pbs.twimg.com/card_img/1800430057942294529/3zHgWOy8?format=jpg&name=800x419',
              },
              type: 'IMAGE',
            },
            thumbnail_image: {
              image_value: {
                height: 144,
                width: 144,
                url: 'https://pbs.twimg.com/card_img/1800430057942294529/3zHgWOy8?format=jpg&name=144x144',
              },
              type: 'IMAGE',
            },
            description: {
              string_value: 'Welcome to our in-depth guide to our Rewards System in the Discord community.',
              type: 'STRING',
            },
            domain: {
              string_value: 'leovs09.notion.site',
              type: 'STRING',
            },
            thumbnail_image_large: {
              image_value: {
                height: 320,
                width: 320,
                url: 'https://pbs.twimg.com/card_img/1800430057942294529/3zHgWOy8?format=jpg&name=800x320_1',
              },
              type: 'IMAGE',
            },
            summary_photo_image_small: {
              image_value: {
                height: 202,
                width: 386,
                url: 'https://pbs.twimg.com/card_img/1800430057942294529/3zHgWOy8?format=jpg&name=386x202',
              },
              type: 'IMAGE',
            },
            thumbnail_image_original: {
              image_value: {
                height: 2000,
                width: 2000,
                url: 'https://pbs.twimg.com/card_img/1800430057942294529/3zHgWOy8?format=jpg&name=orig',
              },
              type: 'IMAGE',
            },
            photo_image_full_size_small: {
              image_value: {
                height: 202,
                width: 386,
                url: 'https://pbs.twimg.com/card_img/1800430057942294529/3zHgWOy8?format=jpg&name=386x202',
              },
              type: 'IMAGE',
            },
            summary_photo_image_large: {
              image_value: {
                height: 419,
                width: 800,
                url: 'https://pbs.twimg.com/card_img/1800430057942294529/3zHgWOy8?format=jpg&name=800x419',
              },
              type: 'IMAGE',
            },
            thumbnail_image_small: {
              image_value: {
                height: 100,
                width: 100,
                url: 'https://pbs.twimg.com/card_img/1800430057942294529/3zHgWOy8?format=jpg&name=100x100',
              },
              type: 'IMAGE',
            },
            thumbnail_image_x_large: {
              image_value: {
                height: 2000,
                width: 2000,
                url: 'https://pbs.twimg.com/card_img/1800430057942294529/3zHgWOy8?format=png&name=2048x2048_2_exp',
              },
              type: 'IMAGE',
            },
            photo_image_full_size_original: {
              image_value: {
                height: 2000,
                width: 2000,
                url: 'https://pbs.twimg.com/card_img/1800430057942294529/3zHgWOy8?format=jpg&name=orig',
              },
              type: 'IMAGE',
            },
            vanity_url: {
              scribe_key: 'vanity_url',
              string_value: 'leovs09.notion.site',
              type: 'STRING',
            },
            photo_image_full_size: {
              image_value: {
                height: 314,
                width: 600,
                url: 'https://pbs.twimg.com/card_img/1800430057942294529/3zHgWOy8?format=jpg&name=600x314',
              },
              type: 'IMAGE',
            },
            thumbnail_image_color: {
              image_color_value: {
                palette: [
                  {
                    rgb: {
                      blue: 83,
                      green: 44,
                      red: 216,
                    },
                    percentage: 17.88,
                  },
                  {
                    rgb: {
                      blue: 115,
                      green: 60,
                      red: 193,
                    },
                    percentage: 16.71,
                  },
                  {
                    rgb: {
                      blue: 205,
                      green: 88,
                      red: 88,
                    },
                    percentage: 12.9,
                  },
                  {
                    rgb: {
                      blue: 148,
                      green: 70,
                      red: 159,
                    },
                    percentage: 12.13,
                  },
                  {
                    rgb: {
                      blue: 187,
                      green: 112,
                      red: 133,
                    },
                    percentage: 10,
                  },
                ],
              },
              type: 'IMAGE_COLOR',
            },
            title: {
              string_value: 'Community Rewards System | Notion',
              type: 'STRING',
            },
            summary_photo_image_color: {
              image_color_value: {
                palette: [
                  {
                    rgb: {
                      blue: 83,
                      green: 44,
                      red: 216,
                    },
                    percentage: 17.88,
                  },
                  {
                    rgb: {
                      blue: 115,
                      green: 60,
                      red: 193,
                    },
                    percentage: 16.71,
                  },
                  {
                    rgb: {
                      blue: 205,
                      green: 88,
                      red: 88,
                    },
                    percentage: 12.9,
                  },
                  {
                    rgb: {
                      blue: 148,
                      green: 70,
                      red: 159,
                    },
                    percentage: 12.13,
                  },
                  {
                    rgb: {
                      blue: 187,
                      green: 112,
                      red: 133,
                    },
                    percentage: 10,
                  },
                ],
              },
              type: 'IMAGE_COLOR',
            },
            summary_photo_image_x_large: {
              image_value: {
                height: 2000,
                width: 2000,
                url: 'https://pbs.twimg.com/card_img/1800430057942294529/3zHgWOy8?format=png&name=2048x2048_2_exp',
              },
              type: 'IMAGE',
            },
            summary_photo_image: {
              image_value: {
                height: 314,
                width: 600,
                url: 'https://pbs.twimg.com/card_img/1800430057942294529/3zHgWOy8?format=jpg&name=600x314',
              },
              type: 'IMAGE',
            },
            photo_image_full_size_color: {
              image_color_value: {
                palette: [
                  {
                    rgb: {
                      blue: 83,
                      green: 44,
                      red: 216,
                    },
                    percentage: 17.88,
                  },
                  {
                    rgb: {
                      blue: 115,
                      green: 60,
                      red: 193,
                    },
                    percentage: 16.71,
                  },
                  {
                    rgb: {
                      blue: 205,
                      green: 88,
                      red: 88,
                    },
                    percentage: 12.9,
                  },
                  {
                    rgb: {
                      blue: 148,
                      green: 70,
                      red: 159,
                    },
                    percentage: 12.13,
                  },
                  {
                    rgb: {
                      blue: 187,
                      green: 112,
                      red: 133,
                    },
                    percentage: 10,
                  },
                ],
              },
              type: 'IMAGE_COLOR',
            },
            photo_image_full_size_x_large: {
              image_value: {
                height: 2000,
                width: 2000,
                url: 'https://pbs.twimg.com/card_img/1800430057942294529/3zHgWOy8?format=png&name=2048x2048_2_exp',
              },
              type: 'IMAGE',
            },
            card_url: {
              scribe_key: 'card_url',
              string_value: 'https://t.co/KEl9uFuL53',
              type: 'STRING',
            },
            summary_photo_image_original: {
              image_value: {
                height: 2000,
                width: 2000,
                url: 'https://pbs.twimg.com/card_img/1800430057942294529/3zHgWOy8?format=jpg&name=orig',
              },
              type: 'IMAGE',
            },
          },
        },
        isEdited: false,
        isStaleEdit: false,
      },
      isEdited: false,
      isStaleEdit: false,
    },
    '1790174258187923940': {
      __typename: 'Tweet',
      in_reply_to_screen_name: 'EonianFinance',
      in_reply_to_status_id_str: '1789924316739412125',
      in_reply_to_user_id_str: '1584314875991523328',
      lang: 'en',
      favorite_count: 0,
      created_at: '2024-05-14T00:16:17.000Z',
      display_text_range: [15, 61],
      entities: {
        hashtags: [],
        urls: [],
        user_mentions: [
          {
            id_str: '1584314875991523328',
            indices: [0, 14],
            name: 'Eonian',
            screen_name: 'EonianFinance',
          },
        ],
        symbols: [],
      },
      id_str: '1790174258187923940',
      text: '@EonianFinance Finally the highly anticipated news is here 🥰',
      user: {
        id_str: '1676632239814180871',
        name: 'William | DATSProject | #Voiagers 🦆',
        profile_image_url_https: 'https://pbs.twimg.com/profile_images/1788687179448803328/RyuVx_LP_normal.jpg',
        screen_name: 'William299905',
        verified: false,
        is_blue_verified: false,
        profile_image_shape: 'Circle',
      },
      edit_control: {
        edit_tweet_ids: ['1790174258187923940'],
        editable_until_msecs: '1715649377000',
        is_edit_eligible: false,
        edits_remaining: '5',
      },
      conversation_count: 0,
      news_action_type: 'conversation',
      parent: {
        lang: 'en',
        reply_count: 35,
        retweet_count: 34,
        favorite_count: 38,
        possibly_sensitive: false,
        created_at: '2024-05-13T07:43:06.000Z',
        display_text_range: [0, 276],
        entities: {
          hashtags: [],
          urls: [],
          user_mentions: [],
          symbols: [],
          media: [
            {
              display_url: 'pic.x.com/r6tfmn7acr',
              expanded_url: 'https://twitter.com/EonianFinance/status/1789924316739412125/photo/1',
              indices: [277, 300],
              url: 'https://t.co/r6tfMn7Acr',
            },
          ],
        },
        id_str: '1789924316739412125',
        text: 'Open Beta Announce\nMore than a year ago, we launched our protocol in closed alpha. Since then, we have refined our solution, fixed many bugs, and added awesome features. That means very soon, we will be ready to launch our protocol in open beta and allow anyone to save their… https://t.co/r6tfMn7Acr',
        user: {
          id_str: '1584314875991523328',
          name: 'Eonian',
          profile_image_url_https: 'https://pbs.twimg.com/profile_images/1768404732949733377/T_w4Y8-E_normal.jpg',
          screen_name: 'EonianFinance',
          verified: false,
          is_blue_verified: true,
          profile_image_shape: 'Circle',
        },
        edit_control: {
          edit_tweet_ids: ['1789924316739412125'],
          editable_until_msecs: '1715589786000',
          is_edit_eligible: true,
          edits_remaining: '5',
        },
        mediaDetails: [
          {
            display_url: 'pic.twitter.com/r6tfMn7Acr',
            expanded_url: 'https://twitter.com/EonianFinance/status/1789924316739412125/photo/1',
            ext_media_availability: {
              status: 'Available',
            },
            indices: [277, 300],
            media_url_https: 'https://pbs.twimg.com/media/GNcWIa_W8AAvae_.jpg',
            original_info: {
              height: 1250,
              width: 1250,
              focus_rects: [
                {
                  x: 0,
                  y: 118,
                  w: 1250,
                  h: 700,
                },
                {
                  x: 0,
                  y: 0,
                  w: 1250,
                  h: 1250,
                },
                {
                  x: 45,
                  y: 0,
                  w: 1096,
                  h: 1250,
                },
                {
                  x: 281,
                  y: 0,
                  w: 625,
                  h: 1250,
                },
                {
                  x: 0,
                  y: 0,
                  w: 1250,
                  h: 1250,
                },
              ],
            },
            sizes: {
              large: {
                h: 1250,
                resize: 'fit',
                w: 1250,
              },
              medium: {
                h: 1200,
                resize: 'fit',
                w: 1200,
              },
              small: {
                h: 680,
                resize: 'fit',
                w: 680,
              },
              thumb: {
                h: 150,
                resize: 'crop',
                w: 150,
              },
            },
            type: 'photo',
            url: 'https://t.co/r6tfMn7Acr',
          },
        ],
        photos: [
          {
            backgroundColor: {
              red: 204,
              green: 214,
              blue: 221,
            },
            cropCandidates: [
              {
                x: 0,
                y: 118,
                w: 1250,
                h: 700,
              },
              {
                x: 0,
                y: 0,
                w: 1250,
                h: 1250,
              },
              {
                x: 45,
                y: 0,
                w: 1096,
                h: 1250,
              },
              {
                x: 281,
                y: 0,
                w: 625,
                h: 1250,
              },
              {
                x: 0,
                y: 0,
                w: 1250,
                h: 1250,
              },
            ],
            expandedUrl: 'https://twitter.com/EonianFinance/status/1789924316739412125/photo/1',
            url: 'https://pbs.twimg.com/media/GNcWIa_W8AAvae_.jpg',
            width: 1250,
            height: 1250,
          },
        ],
        isEdited: false,
        isStaleEdit: false,
      },
      isEdited: false,
      isStaleEdit: false,
    },
    '1709136584077914477': {
      __typename: 'Tweet',
      in_reply_to_screen_name: 'EonianFinance',
      in_reply_to_status_id_str: '1680276680319836162',
      in_reply_to_user_id_str: '1584314875991523328',
      lang: 'en',
      favorite_count: 0,
      created_at: '2023-10-03T09:21:30.000Z',
      display_text_range: [15, 64],
      entities: {
        hashtags: [],
        urls: [],
        user_mentions: [
          {
            id_str: '1584314875991523328',
            indices: [0, 14],
            name: 'Eonian',
            screen_name: 'EonianFinance',
          },
        ],
        symbols: [],
      },
      id_str: '1709136584077914477',
      text: '@EonianFinance This is a great reward system you have developed.',
      user: {
        id_str: '1682365334861357056',
        name: 'Precious | AREON',
        profile_image_url_https: 'https://pbs.twimg.com/profile_images/1729679832236138496/2OpGNosW_normal.jpg',
        screen_name: 'Richie__29',
        verified: false,
        is_blue_verified: false,
        profile_image_shape: 'Circle',
      },
      edit_control: {
        edit_tweet_ids: ['1709136584077914477'],
        editable_until_msecs: '1696328490000',
        is_edit_eligible: false,
        edits_remaining: '5',
      },
      conversation_count: 0,
      news_action_type: 'conversation',
      parent: {
        lang: 'en',
        reply_count: 75,
        retweet_count: 49,
        favorite_count: 64,
        possibly_sensitive: false,
        created_at: '2023-07-15T18:02:33.000Z',
        display_text_range: [0, 279],
        entities: {
          hashtags: [],
          urls: [
            {
              display_url: 'leovs09.notion.site/Community-Rewa…',
              expanded_url: 'https://leovs09.notion.site/Community-Rewards-System-eaa37db4f9944fddabaf2bca1e1066a0',
              indices: [256, 279],
              url: 'https://t.co/KEl9uFuL53',
            },
          ],
          user_mentions: [],
          symbols: [],
        },
        id_str: '1680276680319836162',
        text: 'We are glad to announce the launch of Our Level-Up Channel &amp; Rewards System!\n\nGet reward for engaging in our community. Earn points to level up and gain new roles, to qualify for token retrodrops. Higher roles = bigger rewards\n\nMore info in our Docs : https://t.co/KEl9uFuL53',
        user: {
          id_str: '1584314875991523328',
          name: 'Eonian',
          profile_image_url_https: 'https://pbs.twimg.com/profile_images/1768404732949733377/T_w4Y8-E_normal.jpg',
          screen_name: 'EonianFinance',
          verified: false,
          is_blue_verified: true,
          profile_image_shape: 'Circle',
        },
        edit_control: {
          edit_tweet_ids: ['1680276680319836162'],
          editable_until_msecs: '1689447753000',
          is_edit_eligible: true,
          edits_remaining: '5',
        },
        card: {
          card_platform: {
            platform: {
              audience: {
                name: 'production',
              },
              device: {
                name: 'iPhone',
                version: '13',
              },
            },
          },
          name: 'summary_large_image',
          url: 'https://t.co/KEl9uFuL53',
          binding_values: {
            photo_image_full_size_large: {
              image_value: {
                height: 419,
                width: 800,
                url: 'https://pbs.twimg.com/card_img/1800430057942294529/3zHgWOy8?format=jpg&name=800x419',
              },
              type: 'IMAGE',
            },
            thumbnail_image: {
              image_value: {
                height: 144,
                width: 144,
                url: 'https://pbs.twimg.com/card_img/1800430057942294529/3zHgWOy8?format=jpg&name=144x144',
              },
              type: 'IMAGE',
            },
            description: {
              string_value: 'Welcome to our in-depth guide to our Rewards System in the Discord community.',
              type: 'STRING',
            },
            domain: {
              string_value: 'leovs09.notion.site',
              type: 'STRING',
            },
            thumbnail_image_large: {
              image_value: {
                height: 320,
                width: 320,
                url: 'https://pbs.twimg.com/card_img/1800430057942294529/3zHgWOy8?format=jpg&name=800x320_1',
              },
              type: 'IMAGE',
            },
            summary_photo_image_small: {
              image_value: {
                height: 202,
                width: 386,
                url: 'https://pbs.twimg.com/card_img/1800430057942294529/3zHgWOy8?format=jpg&name=386x202',
              },
              type: 'IMAGE',
            },
            thumbnail_image_original: {
              image_value: {
                height: 2000,
                width: 2000,
                url: 'https://pbs.twimg.com/card_img/1800430057942294529/3zHgWOy8?format=jpg&name=orig',
              },
              type: 'IMAGE',
            },
            photo_image_full_size_small: {
              image_value: {
                height: 202,
                width: 386,
                url: 'https://pbs.twimg.com/card_img/1800430057942294529/3zHgWOy8?format=jpg&name=386x202',
              },
              type: 'IMAGE',
            },
            summary_photo_image_large: {
              image_value: {
                height: 419,
                width: 800,
                url: 'https://pbs.twimg.com/card_img/1800430057942294529/3zHgWOy8?format=jpg&name=800x419',
              },
              type: 'IMAGE',
            },
            thumbnail_image_small: {
              image_value: {
                height: 100,
                width: 100,
                url: 'https://pbs.twimg.com/card_img/1800430057942294529/3zHgWOy8?format=jpg&name=100x100',
              },
              type: 'IMAGE',
            },
            thumbnail_image_x_large: {
              image_value: {
                height: 2000,
                width: 2000,
                url: 'https://pbs.twimg.com/card_img/1800430057942294529/3zHgWOy8?format=png&name=2048x2048_2_exp',
              },
              type: 'IMAGE',
            },
            photo_image_full_size_original: {
              image_value: {
                height: 2000,
                width: 2000,
                url: 'https://pbs.twimg.com/card_img/1800430057942294529/3zHgWOy8?format=jpg&name=orig',
              },
              type: 'IMAGE',
            },
            vanity_url: {
              scribe_key: 'vanity_url',
              string_value: 'leovs09.notion.site',
              type: 'STRING',
            },
            photo_image_full_size: {
              image_value: {
                height: 314,
                width: 600,
                url: 'https://pbs.twimg.com/card_img/1800430057942294529/3zHgWOy8?format=jpg&name=600x314',
              },
              type: 'IMAGE',
            },
            thumbnail_image_color: {
              image_color_value: {
                palette: [
                  {
                    rgb: {
                      blue: 83,
                      green: 44,
                      red: 216,
                    },
                    percentage: 17.88,
                  },
                  {
                    rgb: {
                      blue: 115,
                      green: 60,
                      red: 193,
                    },
                    percentage: 16.71,
                  },
                  {
                    rgb: {
                      blue: 205,
                      green: 88,
                      red: 88,
                    },
                    percentage: 12.9,
                  },
                  {
                    rgb: {
                      blue: 148,
                      green: 70,
                      red: 159,
                    },
                    percentage: 12.13,
                  },
                  {
                    rgb: {
                      blue: 187,
                      green: 112,
                      red: 133,
                    },
                    percentage: 10,
                  },
                ],
              },
              type: 'IMAGE_COLOR',
            },
            title: {
              string_value: 'Community Rewards System | Notion',
              type: 'STRING',
            },
            summary_photo_image_color: {
              image_color_value: {
                palette: [
                  {
                    rgb: {
                      blue: 83,
                      green: 44,
                      red: 216,
                    },
                    percentage: 17.88,
                  },
                  {
                    rgb: {
                      blue: 115,
                      green: 60,
                      red: 193,
                    },
                    percentage: 16.71,
                  },
                  {
                    rgb: {
                      blue: 205,
                      green: 88,
                      red: 88,
                    },
                    percentage: 12.9,
                  },
                  {
                    rgb: {
                      blue: 148,
                      green: 70,
                      red: 159,
                    },
                    percentage: 12.13,
                  },
                  {
                    rgb: {
                      blue: 187,
                      green: 112,
                      red: 133,
                    },
                    percentage: 10,
                  },
                ],
              },
              type: 'IMAGE_COLOR',
            },
            summary_photo_image_x_large: {
              image_value: {
                height: 2000,
                width: 2000,
                url: 'https://pbs.twimg.com/card_img/1800430057942294529/3zHgWOy8?format=png&name=2048x2048_2_exp',
              },
              type: 'IMAGE',
            },
            summary_photo_image: {
              image_value: {
                height: 314,
                width: 600,
                url: 'https://pbs.twimg.com/card_img/1800430057942294529/3zHgWOy8?format=jpg&name=600x314',
              },
              type: 'IMAGE',
            },
            photo_image_full_size_color: {
              image_color_value: {
                palette: [
                  {
                    rgb: {
                      blue: 83,
                      green: 44,
                      red: 216,
                    },
                    percentage: 17.88,
                  },
                  {
                    rgb: {
                      blue: 115,
                      green: 60,
                      red: 193,
                    },
                    percentage: 16.71,
                  },
                  {
                    rgb: {
                      blue: 205,
                      green: 88,
                      red: 88,
                    },
                    percentage: 12.9,
                  },
                  {
                    rgb: {
                      blue: 148,
                      green: 70,
                      red: 159,
                    },
                    percentage: 12.13,
                  },
                  {
                    rgb: {
                      blue: 187,
                      green: 112,
                      red: 133,
                    },
                    percentage: 10,
                  },
                ],
              },
              type: 'IMAGE_COLOR',
            },
            photo_image_full_size_x_large: {
              image_value: {
                height: 2000,
                width: 2000,
                url: 'https://pbs.twimg.com/card_img/1800430057942294529/3zHgWOy8?format=png&name=2048x2048_2_exp',
              },
              type: 'IMAGE',
            },
            card_url: {
              scribe_key: 'card_url',
              string_value: 'https://t.co/KEl9uFuL53',
              type: 'STRING',
            },
            summary_photo_image_original: {
              image_value: {
                height: 2000,
                width: 2000,
                url: 'https://pbs.twimg.com/card_img/1800430057942294529/3zHgWOy8?format=jpg&name=orig',
              },
              type: 'IMAGE',
            },
          },
        },
        isEdited: false,
        isStaleEdit: false,
      },
      isEdited: false,
      isStaleEdit: false,
    },
  },
  '1734116468994793841': {
    __typename: 'Tweet',
    in_reply_to_screen_name: 'EonianFinance',
    in_reply_to_status_id_str: '1682458657160671232',
    in_reply_to_user_id_str: '1584314875991523328',
    lang: 'en',
    favorite_count: 0,
    created_at: '2023-12-11T07:42:39.000Z',
    display_text_range: [15, 57],
    entities: {
      hashtags: [],
      urls: [],
      user_mentions: [
        {
          id_str: '1584314875991523328',
          indices: [0, 14],
          name: 'Eonian',
          screen_name: 'EonianFinance',
        },
      ],
      symbols: [],
    },
    id_str: '1734116468994793841',
    text: '@EonianFinance Amazing project! Definitely exploring this',
    user: {
      id_str: '1672053718072672256',
      name: 'Pampam',
      profile_image_url_https: 'https://pbs.twimg.com/profile_images/1751226159155593216/HBEtiNIc_normal.jpg',
      screen_name: 'piscopam',
      verified: false,
      is_blue_verified: false,
      profile_image_shape: 'Circle',
    },
    edit_control: {
      edit_tweet_ids: ['1734116468994793841'],
      editable_until_msecs: '1702284159000',
      is_edit_eligible: false,
      edits_remaining: '5',
    },
    conversation_count: 0,
    news_action_type: 'conversation',
    parent: {
      lang: 'en',
      reply_count: 130,
      retweet_count: 154,
      favorite_count: 184,
      possibly_sensitive: false,
      created_at: '2023-07-21T18:32:57.000Z',
      display_text_range: [0, 267],
      entities: {
        hashtags: [],
        urls: [],
        user_mentions: [
          {
            id_str: '1584314875991523328',
            indices: [68, 82],
            name: 'Eonian',
            screen_name: 'EonianFinance',
          },
        ],
        symbols: [],
        media: [
          {
            display_url: 'pic.x.com/4a99vhtdjn',
            expanded_url: 'https://twitter.com/EonianFinance/status/1682458657160671232/photo/1',
            indices: [268, 291],
            url: 'https://t.co/4a99vHtDJn',
          },
        ],
      },
      id_str: '1682458657160671232',
      text: 'Introducing Eonian - Your Ultimate Yield Aggregator building on BSC @EonianFinance \n\nAre you tired of making unsafe investments? Are you looking for the-one-solution to maximizing your yields? \n\nRevolutionize the way you invest, earn and grow your digital asset with… https://t.co/4a99vHtDJn',
      user: {
        id_str: '1584314875991523328',
        name: 'Eonian',
        profile_image_url_https: 'https://pbs.twimg.com/profile_images/1768404732949733377/T_w4Y8-E_normal.jpg',
        screen_name: 'EonianFinance',
        verified: false,
        is_blue_verified: true,
        profile_image_shape: 'Circle',
      },
      edit_control: {
        edit_tweet_ids: ['1682458657160671232'],
        editable_until_msecs: '1689967977000',
        is_edit_eligible: false,
        edits_remaining: '5',
      },
      mediaDetails: [
        {
          display_url: 'pic.twitter.com/4a99vHtDJn',
          expanded_url: 'https://twitter.com/EonianFinance/status/1682458657160671232/photo/1',
          ext_media_availability: {
            status: 'Available',
          },
          indices: [268, 291],
          media_url_https: 'https://pbs.twimg.com/media/F1lLNllX0AYKDlp.jpg',
          original_info: {
            height: 900,
            width: 1600,
            focus_rects: [
              {
                x: 0,
                y: 0,
                w: 1600,
                h: 896,
              },
              {
                x: 470,
                y: 0,
                w: 900,
                h: 900,
              },
              {
                x: 526,
                y: 0,
                w: 789,
                h: 900,
              },
              {
                x: 695,
                y: 0,
                w: 450,
                h: 900,
              },
              {
                x: 0,
                y: 0,
                w: 1600,
                h: 900,
              },
            ],
          },
          sizes: {
            large: {
              h: 900,
              resize: 'fit',
              w: 1600,
            },
            medium: {
              h: 675,
              resize: 'fit',
              w: 1200,
            },
            small: {
              h: 383,
              resize: 'fit',
              w: 680,
            },
            thumb: {
              h: 150,
              resize: 'crop',
              w: 150,
            },
          },
          type: 'photo',
          url: 'https://t.co/4a99vHtDJn',
        },
      ],
      photos: [
        {
          backgroundColor: {
            red: 204,
            green: 214,
            blue: 221,
          },
          cropCandidates: [
            {
              x: 0,
              y: 0,
              w: 1600,
              h: 896,
            },
            {
              x: 470,
              y: 0,
              w: 900,
              h: 900,
            },
            {
              x: 526,
              y: 0,
              w: 789,
              h: 900,
            },
            {
              x: 695,
              y: 0,
              w: 450,
              h: 900,
            },
            {
              x: 0,
              y: 0,
              w: 1600,
              h: 900,
            },
          ],
          expandedUrl: 'https://twitter.com/EonianFinance/status/1682458657160671232/photo/1',
          url: 'https://pbs.twimg.com/media/F1lLNllX0AYKDlp.jpg',
          width: 1600,
          height: 900,
        },
      ],
      isEdited: false,
      isStaleEdit: false,
    },
    isEdited: false,
    isStaleEdit: false,
  },
  '1697510888146710979': {
    __typename: 'Tweet',
    in_reply_to_screen_name: 'EonianFinance',
    in_reply_to_status_id_str: '1682458657160671232',
    in_reply_to_user_id_str: '1584314875991523328',
    lang: 'en',
    favorite_count: 0,
    created_at: '2023-09-01T07:25:08.000Z',
    display_text_range: [15, 37],
    entities: {
      hashtags: [],
      urls: [],
      user_mentions: [
        {
          id_str: '1584314875991523328',
          indices: [0, 14],
          name: 'Eonian',
          screen_name: 'EonianFinance',
        },
      ],
      symbols: [],
    },
    id_str: '1697510888146710979',
    text: '@EonianFinance This is a nice project',
    user: {
      id_str: '1517136019744645122',
      name: 'D\'Big Dog | BlastUP 💥| Hattori 🥷| Circular',
      profile_image_url_https: 'https://pbs.twimg.com/profile_images/1798438061820223488/kWFXbJE7_normal.jpg',
      screen_name: 'Ternajr01',
      verified: false,
      is_blue_verified: false,
      profile_image_shape: 'Circle',
    },
    edit_control: {
      edit_tweet_ids: ['1697510888146710979'],
      editable_until_msecs: '1693556708000',
      is_edit_eligible: false,
      edits_remaining: '5',
    },
    conversation_count: 0,
    news_action_type: 'conversation',
    parent: {
      lang: 'en',
      reply_count: 130,
      retweet_count: 154,
      favorite_count: 184,
      possibly_sensitive: false,
      created_at: '2023-07-21T18:32:57.000Z',
      display_text_range: [0, 267],
      entities: {
        hashtags: [],
        urls: [],
        user_mentions: [
          {
            id_str: '1584314875991523328',
            indices: [68, 82],
            name: 'Eonian',
            screen_name: 'EonianFinance',
          },
        ],
        symbols: [],
        media: [
          {
            display_url: 'pic.x.com/4a99vhtdjn',
            expanded_url: 'https://twitter.com/EonianFinance/status/1682458657160671232/photo/1',
            indices: [268, 291],
            url: 'https://t.co/4a99vHtDJn',
          },
        ],
      },
      id_str: '1682458657160671232',
      text: 'Introducing Eonian - Your Ultimate Yield Aggregator building on BSC @EonianFinance \n\nAre you tired of making unsafe investments? Are you looking for the-one-solution to maximizing your yields? \n\nRevolutionize the way you invest, earn and grow your digital asset with… https://t.co/4a99vHtDJn',
      user: {
        id_str: '1584314875991523328',
        name: 'Eonian',
        profile_image_url_https: 'https://pbs.twimg.com/profile_images/1768404732949733377/T_w4Y8-E_normal.jpg',
        screen_name: 'EonianFinance',
        verified: false,
        is_blue_verified: true,
        profile_image_shape: 'Circle',
      },
      edit_control: {
        edit_tweet_ids: ['1682458657160671232'],
        editable_until_msecs: '1689967977000',
        is_edit_eligible: false,
        edits_remaining: '5',
      },
      mediaDetails: [
        {
          display_url: 'pic.twitter.com/4a99vHtDJn',
          expanded_url: 'https://twitter.com/EonianFinance/status/1682458657160671232/photo/1',
          ext_media_availability: {
            status: 'Available',
          },
          indices: [268, 291],
          media_url_https: 'https://pbs.twimg.com/media/F1lLNllX0AYKDlp.jpg',
          original_info: {
            height: 900,
            width: 1600,
            focus_rects: [
              {
                x: 0,
                y: 0,
                w: 1600,
                h: 896,
              },
              {
                x: 470,
                y: 0,
                w: 900,
                h: 900,
              },
              {
                x: 526,
                y: 0,
                w: 789,
                h: 900,
              },
              {
                x: 695,
                y: 0,
                w: 450,
                h: 900,
              },
              {
                x: 0,
                y: 0,
                w: 1600,
                h: 900,
              },
            ],
          },
          sizes: {
            large: {
              h: 900,
              resize: 'fit',
              w: 1600,
            },
            medium: {
              h: 675,
              resize: 'fit',
              w: 1200,
            },
            small: {
              h: 383,
              resize: 'fit',
              w: 680,
            },
            thumb: {
              h: 150,
              resize: 'crop',
              w: 150,
            },
          },
          type: 'photo',
          url: 'https://t.co/4a99vHtDJn',
        },
      ],
      photos: [
        {
          backgroundColor: {
            red: 204,
            green: 214,
            blue: 221,
          },
          cropCandidates: [
            {
              x: 0,
              y: 0,
              w: 1600,
              h: 896,
            },
            {
              x: 470,
              y: 0,
              w: 900,
              h: 900,
            },
            {
              x: 526,
              y: 0,
              w: 789,
              h: 900,
            },
            {
              x: 695,
              y: 0,
              w: 450,
              h: 900,
            },
            {
              x: 0,
              y: 0,
              w: 1600,
              h: 900,
            },
          ],
          expandedUrl: 'https://twitter.com/EonianFinance/status/1682458657160671232/photo/1',
          url: 'https://pbs.twimg.com/media/F1lLNllX0AYKDlp.jpg',
          width: 1600,
          height: 900,
        },
      ],
      isEdited: false,
      isStaleEdit: false,
    },
    isEdited: false,
    isStaleEdit: false,
  },
  '1745790508276887688': {
    __typename: 'Tweet',
    in_reply_to_screen_name: 'EonianFinance',
    in_reply_to_status_id_str: '1682458657160671232',
    in_reply_to_user_id_str: '1584314875991523328',
    lang: 'en',
    favorite_count: 0,
    created_at: '2024-01-12T12:51:07.000Z',
    display_text_range: [15, 69],
    entities: {
      hashtags: [],
      urls: [],
      user_mentions: [
        {
          id_str: '1584314875991523328',
          indices: [0, 14],
          name: 'Eonian',
          screen_name: 'EonianFinance',
        },
      ],
      symbols: [],
    },
    id_str: '1745790508276887688',
    text: '@EonianFinance Now, you can earn and grow professionally with Eonian.',
    user: {
      id_str: '448967916',
      name: 'Leyla Mohamed🇹🇿',
      profile_image_url_https: 'https://pbs.twimg.com/profile_images/1805609948505669632/WpjTwvZN_normal.jpg',
      screen_name: 'LeyAllyie',
      verified: false,
      is_blue_verified: false,
      profile_image_shape: 'Circle',
    },
    edit_control: {
      edit_tweet_ids: ['1745790508276887688'],
      editable_until_msecs: '1705067467000',
      is_edit_eligible: false,
      edits_remaining: '5',
    },
    conversation_count: 0,
    news_action_type: 'conversation',
    parent: {
      lang: 'en',
      reply_count: 130,
      retweet_count: 154,
      favorite_count: 184,
      possibly_sensitive: false,
      created_at: '2023-07-21T18:32:57.000Z',
      display_text_range: [0, 267],
      entities: {
        hashtags: [],
        urls: [],
        user_mentions: [
          {
            id_str: '1584314875991523328',
            indices: [68, 82],
            name: 'Eonian',
            screen_name: 'EonianFinance',
          },
        ],
        symbols: [],
        media: [
          {
            display_url: 'pic.x.com/4a99vhtdjn',
            expanded_url: 'https://twitter.com/EonianFinance/status/1682458657160671232/photo/1',
            indices: [268, 291],
            url: 'https://t.co/4a99vHtDJn',
          },
        ],
      },
      id_str: '1682458657160671232',
      text: 'Introducing Eonian - Your Ultimate Yield Aggregator building on BSC @EonianFinance \n\nAre you tired of making unsafe investments? Are you looking for the-one-solution to maximizing your yields? \n\nRevolutionize the way you invest, earn and grow your digital asset with… https://t.co/4a99vHtDJn',
      user: {
        id_str: '1584314875991523328',
        name: 'Eonian',
        profile_image_url_https: 'https://pbs.twimg.com/profile_images/1768404732949733377/T_w4Y8-E_normal.jpg',
        screen_name: 'EonianFinance',
        verified: false,
        is_blue_verified: true,
        profile_image_shape: 'Circle',
      },
      edit_control: {
        edit_tweet_ids: ['1682458657160671232'],
        editable_until_msecs: '1689967977000',
        is_edit_eligible: false,
        edits_remaining: '5',
      },
      mediaDetails: [
        {
          display_url: 'pic.twitter.com/4a99vHtDJn',
          expanded_url: 'https://twitter.com/EonianFinance/status/1682458657160671232/photo/1',
          ext_media_availability: {
            status: 'Available',
          },
          indices: [268, 291],
          media_url_https: 'https://pbs.twimg.com/media/F1lLNllX0AYKDlp.jpg',
          original_info: {
            height: 900,
            width: 1600,
            focus_rects: [
              {
                x: 0,
                y: 0,
                w: 1600,
                h: 896,
              },
              {
                x: 470,
                y: 0,
                w: 900,
                h: 900,
              },
              {
                x: 526,
                y: 0,
                w: 789,
                h: 900,
              },
              {
                x: 695,
                y: 0,
                w: 450,
                h: 900,
              },
              {
                x: 0,
                y: 0,
                w: 1600,
                h: 900,
              },
            ],
          },
          sizes: {
            large: {
              h: 900,
              resize: 'fit',
              w: 1600,
            },
            medium: {
              h: 675,
              resize: 'fit',
              w: 1200,
            },
            small: {
              h: 383,
              resize: 'fit',
              w: 680,
            },
            thumb: {
              h: 150,
              resize: 'crop',
              w: 150,
            },
          },
          type: 'photo',
          url: 'https://t.co/4a99vHtDJn',
        },
      ],
      photos: [
        {
          backgroundColor: {
            red: 204,
            green: 214,
            blue: 221,
          },
          cropCandidates: [
            {
              x: 0,
              y: 0,
              w: 1600,
              h: 896,
            },
            {
              x: 470,
              y: 0,
              w: 900,
              h: 900,
            },
            {
              x: 526,
              y: 0,
              w: 789,
              h: 900,
            },
            {
              x: 695,
              y: 0,
              w: 450,
              h: 900,
            },
            {
              x: 0,
              y: 0,
              w: 1600,
              h: 900,
            },
          ],
          expandedUrl: 'https://twitter.com/EonianFinance/status/1682458657160671232/photo/1',
          url: 'https://pbs.twimg.com/media/F1lLNllX0AYKDlp.jpg',
          width: 1600,
          height: 900,
        },
      ],
      isEdited: false,
      isStaleEdit: false,
    },
    isEdited: false,
    isStaleEdit: false,
  },
  '1733124961043128508': {
    __typename: 'Tweet',
    in_reply_to_screen_name: 'EonianFinance',
    in_reply_to_status_id_str: '1682458657160671232',
    in_reply_to_user_id_str: '1584314875991523328',
    lang: 'en',
    favorite_count: 0,
    created_at: '2023-12-08T14:02:45.000Z',
    display_text_range: [15, 61],
    entities: {
      hashtags: [],
      urls: [],
      user_mentions: [
        {
          id_str: '1584314875991523328',
          indices: [0, 14],
          name: 'Eonian',
          screen_name: 'EonianFinance',
        },
      ],
      symbols: [],
    },
    id_str: '1733124961043128508',
    text: '@EonianFinance Definitely Innovative and enterprising project',
    user: {
      id_str: '1653346098277228548',
      name: 'CrypticWhale 💚',
      profile_image_url_https: 'https://pbs.twimg.com/profile_images/1760583176701820928/5xqe4JDt_normal.jpg',
      screen_name: 'CrypticWhale_',
      verified: false,
      is_blue_verified: false,
      profile_image_shape: 'Circle',
    },
    edit_control: {
      edit_tweet_ids: ['1733124961043128508'],
      editable_until_msecs: '1702047765000',
      is_edit_eligible: false,
      edits_remaining: '5',
    },
    conversation_count: 0,
    news_action_type: 'conversation',
    parent: {
      lang: 'en',
      reply_count: 130,
      retweet_count: 154,
      favorite_count: 184,
      possibly_sensitive: false,
      created_at: '2023-07-21T18:32:57.000Z',
      display_text_range: [0, 267],
      entities: {
        hashtags: [],
        urls: [],
        user_mentions: [
          {
            id_str: '1584314875991523328',
            indices: [68, 82],
            name: 'Eonian',
            screen_name: 'EonianFinance',
          },
        ],
        symbols: [],
        media: [
          {
            display_url: 'pic.x.com/4a99vhtdjn',
            expanded_url: 'https://twitter.com/EonianFinance/status/1682458657160671232/photo/1',
            indices: [268, 291],
            url: 'https://t.co/4a99vHtDJn',
          },
        ],
      },
      id_str: '1682458657160671232',
      text: 'Introducing Eonian - Your Ultimate Yield Aggregator building on BSC @EonianFinance \n\nAre you tired of making unsafe investments? Are you looking for the-one-solution to maximizing your yields? \n\nRevolutionize the way you invest, earn and grow your digital asset with… https://t.co/4a99vHtDJn',
      user: {
        id_str: '1584314875991523328',
        name: 'Eonian',
        profile_image_url_https: 'https://pbs.twimg.com/profile_images/1768404732949733377/T_w4Y8-E_normal.jpg',
        screen_name: 'EonianFinance',
        verified: false,
        is_blue_verified: true,
        profile_image_shape: 'Circle',
      },
      edit_control: {
        edit_tweet_ids: ['1682458657160671232'],
        editable_until_msecs: '1689967977000',
        is_edit_eligible: false,
        edits_remaining: '5',
      },
      mediaDetails: [
        {
          display_url: 'pic.twitter.com/4a99vHtDJn',
          expanded_url: 'https://twitter.com/EonianFinance/status/1682458657160671232/photo/1',
          ext_media_availability: {
            status: 'Available',
          },
          indices: [268, 291],
          media_url_https: 'https://pbs.twimg.com/media/F1lLNllX0AYKDlp.jpg',
          original_info: {
            height: 900,
            width: 1600,
            focus_rects: [
              {
                x: 0,
                y: 0,
                w: 1600,
                h: 896,
              },
              {
                x: 470,
                y: 0,
                w: 900,
                h: 900,
              },
              {
                x: 526,
                y: 0,
                w: 789,
                h: 900,
              },
              {
                x: 695,
                y: 0,
                w: 450,
                h: 900,
              },
              {
                x: 0,
                y: 0,
                w: 1600,
                h: 900,
              },
            ],
          },
          sizes: {
            large: {
              h: 900,
              resize: 'fit',
              w: 1600,
            },
            medium: {
              h: 675,
              resize: 'fit',
              w: 1200,
            },
            small: {
              h: 383,
              resize: 'fit',
              w: 680,
            },
            thumb: {
              h: 150,
              resize: 'crop',
              w: 150,
            },
          },
          type: 'photo',
          url: 'https://t.co/4a99vHtDJn',
        },
      ],
      photos: [
        {
          backgroundColor: {
            red: 204,
            green: 214,
            blue: 221,
          },
          cropCandidates: [
            {
              x: 0,
              y: 0,
              w: 1600,
              h: 896,
            },
            {
              x: 470,
              y: 0,
              w: 900,
              h: 900,
            },
            {
              x: 526,
              y: 0,
              w: 789,
              h: 900,
            },
            {
              x: 695,
              y: 0,
              w: 450,
              h: 900,
            },
            {
              x: 0,
              y: 0,
              w: 1600,
              h: 900,
            },
          ],
          expandedUrl: 'https://twitter.com/EonianFinance/status/1682458657160671232/photo/1',
          url: 'https://pbs.twimg.com/media/F1lLNllX0AYKDlp.jpg',
          width: 1600,
          height: 900,
        },
      ],
      isEdited: false,
      isStaleEdit: false,
    },
    isEdited: false,
    isStaleEdit: false,
  },
  '1697593261387403674': {
    __typename: 'Tweet',
    in_reply_to_screen_name: 'EonianFinance',
    in_reply_to_status_id_str: '1682458657160671232',
    in_reply_to_user_id_str: '1584314875991523328',
    lang: 'en',
    favorite_count: 0,
    created_at: '2023-09-01T12:52:27.000Z',
    display_text_range: [15, 64],
    entities: {
      hashtags: [],
      urls: [],
      user_mentions: [
        {
          id_str: '1584314875991523328',
          indices: [0, 14],
          name: 'Eonian',
          screen_name: 'EonianFinance',
        },
        {
          id_str: '1584314875991523328',
          indices: [15, 29],
          name: 'Eonian',
          screen_name: 'EonianFinance',
        },
      ],
      symbols: [],
    },
    id_str: '1697593261387403674',
    text: '@EonianFinance @EonianFinance  is the right place to invest guys',
    user: {
      id_str: '1481494764927307776',
      name: 'Awasiakan Udo',
      profile_image_url_https: 'https://pbs.twimg.com/profile_images/1788583962845032448/0d_Y2SCW_normal.jpg',
      screen_name: 'AwasiakanUdo',
      verified: false,
      is_blue_verified: false,
      profile_image_shape: 'Circle',
    },
    edit_control: {
      edit_tweet_ids: ['1697593261387403674'],
      editable_until_msecs: '1693576347000',
      is_edit_eligible: false,
      edits_remaining: '5',
    },
    conversation_count: 0,
    news_action_type: 'conversation',
    parent: {
      lang: 'en',
      reply_count: 130,
      retweet_count: 154,
      favorite_count: 184,
      possibly_sensitive: false,
      created_at: '2023-07-21T18:32:57.000Z',
      display_text_range: [0, 267],
      entities: {
        hashtags: [],
        urls: [],
        user_mentions: [
          {
            id_str: '1584314875991523328',
            indices: [68, 82],
            name: 'Eonian',
            screen_name: 'EonianFinance',
          },
        ],
        symbols: [],
        media: [
          {
            display_url: 'pic.x.com/4a99vhtdjn',
            expanded_url: 'https://twitter.com/EonianFinance/status/1682458657160671232/photo/1',
            indices: [268, 291],
            url: 'https://t.co/4a99vHtDJn',
          },
        ],
      },
      id_str: '1682458657160671232',
      text: 'Introducing Eonian - Your Ultimate Yield Aggregator building on BSC @EonianFinance \n\nAre you tired of making unsafe investments? Are you looking for the-one-solution to maximizing your yields? \n\nRevolutionize the way you invest, earn and grow your digital asset with… https://t.co/4a99vHtDJn',
      user: {
        id_str: '1584314875991523328',
        name: 'Eonian',
        profile_image_url_https: 'https://pbs.twimg.com/profile_images/1768404732949733377/T_w4Y8-E_normal.jpg',
        screen_name: 'EonianFinance',
        verified: false,
        is_blue_verified: true,
        profile_image_shape: 'Circle',
      },
      edit_control: {
        edit_tweet_ids: ['1682458657160671232'],
        editable_until_msecs: '1689967977000',
        is_edit_eligible: false,
        edits_remaining: '5',
      },
      mediaDetails: [
        {
          display_url: 'pic.twitter.com/4a99vHtDJn',
          expanded_url: 'https://twitter.com/EonianFinance/status/1682458657160671232/photo/1',
          ext_media_availability: {
            status: 'Available',
          },
          indices: [268, 291],
          media_url_https: 'https://pbs.twimg.com/media/F1lLNllX0AYKDlp.jpg',
          original_info: {
            height: 900,
            width: 1600,
            focus_rects: [
              {
                x: 0,
                y: 0,
                w: 1600,
                h: 896,
              },
              {
                x: 470,
                y: 0,
                w: 900,
                h: 900,
              },
              {
                x: 526,
                y: 0,
                w: 789,
                h: 900,
              },
              {
                x: 695,
                y: 0,
                w: 450,
                h: 900,
              },
              {
                x: 0,
                y: 0,
                w: 1600,
                h: 900,
              },
            ],
          },
          sizes: {
            large: {
              h: 900,
              resize: 'fit',
              w: 1600,
            },
            medium: {
              h: 675,
              resize: 'fit',
              w: 1200,
            },
            small: {
              h: 383,
              resize: 'fit',
              w: 680,
            },
            thumb: {
              h: 150,
              resize: 'crop',
              w: 150,
            },
          },
          type: 'photo',
          url: 'https://t.co/4a99vHtDJn',
        },
      ],
      photos: [
        {
          backgroundColor: {
            red: 204,
            green: 214,
            blue: 221,
          },
          cropCandidates: [
            {
              x: 0,
              y: 0,
              w: 1600,
              h: 896,
            },
            {
              x: 470,
              y: 0,
              w: 900,
              h: 900,
            },
            {
              x: 526,
              y: 0,
              w: 789,
              h: 900,
            },
            {
              x: 695,
              y: 0,
              w: 450,
              h: 900,
            },
            {
              x: 0,
              y: 0,
              w: 1600,
              h: 900,
            },
          ],
          expandedUrl: 'https://twitter.com/EonianFinance/status/1682458657160671232/photo/1',
          url: 'https://pbs.twimg.com/media/F1lLNllX0AYKDlp.jpg',
          width: 1600,
          height: 900,
        },
      ],
      isEdited: false,
      isStaleEdit: false,
    },
    isEdited: false,
    isStaleEdit: false,
  },
  '1697750320535728495': {
    __typename: 'Tweet',
    in_reply_to_screen_name: 'EonianFinance',
    in_reply_to_status_id_str: '1682458657160671232',
    in_reply_to_user_id_str: '1584314875991523328',
    lang: 'en',
    favorite_count: 0,
    created_at: '2023-09-01T23:16:33.000Z',
    display_text_range: [15, 34],
    entities: {
      hashtags: [],
      urls: [],
      user_mentions: [
        {
          id_str: '1584314875991523328',
          indices: [0, 14],
          name: 'Eonian',
          screen_name: 'EonianFinance',
        },
      ],
      symbols: [],
    },
    id_str: '1697750320535728495',
    text: '@EonianFinance Love this guys 🚀🚀',
    user: {
      id_str: '1694674933870112768',
      name: 'ademola Usman',
      profile_image_url_https: 'https://pbs.twimg.com/profile_images/1694675758331944963/nduI3z8l_normal.jpg',
      screen_name: 'ademolaUsm37680',
      verified: false,
      is_blue_verified: false,
      profile_image_shape: 'Circle',
    },
    edit_control: {
      edit_tweet_ids: ['1697750320535728495'],
      editable_until_msecs: '1693613793000',
      is_edit_eligible: false,
      edits_remaining: '5',
    },
    conversation_count: 0,
    news_action_type: 'conversation',
    parent: {
      lang: 'en',
      reply_count: 130,
      retweet_count: 154,
      favorite_count: 184,
      possibly_sensitive: false,
      created_at: '2023-07-21T18:32:57.000Z',
      display_text_range: [0, 267],
      entities: {
        hashtags: [],
        urls: [],
        user_mentions: [
          {
            id_str: '1584314875991523328',
            indices: [68, 82],
            name: 'Eonian',
            screen_name: 'EonianFinance',
          },
        ],
        symbols: [],
        media: [
          {
            display_url: 'pic.x.com/4a99vhtdjn',
            expanded_url: 'https://twitter.com/EonianFinance/status/1682458657160671232/photo/1',
            indices: [268, 291],
            url: 'https://t.co/4a99vHtDJn',
          },
        ],
      },
      id_str: '1682458657160671232',
      text: 'Introducing Eonian - Your Ultimate Yield Aggregator building on BSC @EonianFinance \n\nAre you tired of making unsafe investments? Are you looking for the-one-solution to maximizing your yields? \n\nRevolutionize the way you invest, earn and grow your digital asset with… https://t.co/4a99vHtDJn',
      user: {
        id_str: '1584314875991523328',
        name: 'Eonian',
        profile_image_url_https: 'https://pbs.twimg.com/profile_images/1768404732949733377/T_w4Y8-E_normal.jpg',
        screen_name: 'EonianFinance',
        verified: false,
        is_blue_verified: true,
        profile_image_shape: 'Circle',
      },
      edit_control: {
        edit_tweet_ids: ['1682458657160671232'],
        editable_until_msecs: '1689967977000',
        is_edit_eligible: false,
        edits_remaining: '5',
      },
      mediaDetails: [
        {
          display_url: 'pic.twitter.com/4a99vHtDJn',
          expanded_url: 'https://twitter.com/EonianFinance/status/1682458657160671232/photo/1',
          ext_media_availability: {
            status: 'Available',
          },
          indices: [268, 291],
          media_url_https: 'https://pbs.twimg.com/media/F1lLNllX0AYKDlp.jpg',
          original_info: {
            height: 900,
            width: 1600,
            focus_rects: [
              {
                x: 0,
                y: 0,
                w: 1600,
                h: 896,
              },
              {
                x: 470,
                y: 0,
                w: 900,
                h: 900,
              },
              {
                x: 526,
                y: 0,
                w: 789,
                h: 900,
              },
              {
                x: 695,
                y: 0,
                w: 450,
                h: 900,
              },
              {
                x: 0,
                y: 0,
                w: 1600,
                h: 900,
              },
            ],
          },
          sizes: {
            large: {
              h: 900,
              resize: 'fit',
              w: 1600,
            },
            medium: {
              h: 675,
              resize: 'fit',
              w: 1200,
            },
            small: {
              h: 383,
              resize: 'fit',
              w: 680,
            },
            thumb: {
              h: 150,
              resize: 'crop',
              w: 150,
            },
          },
          type: 'photo',
          url: 'https://t.co/4a99vHtDJn',
        },
      ],
      photos: [
        {
          backgroundColor: {
            red: 204,
            green: 214,
            blue: 221,
          },
          cropCandidates: [
            {
              x: 0,
              y: 0,
              w: 1600,
              h: 896,
            },
            {
              x: 470,
              y: 0,
              w: 900,
              h: 900,
            },
            {
              x: 526,
              y: 0,
              w: 789,
              h: 900,
            },
            {
              x: 695,
              y: 0,
              w: 450,
              h: 900,
            },
            {
              x: 0,
              y: 0,
              w: 1600,
              h: 900,
            },
          ],
          expandedUrl: 'https://twitter.com/EonianFinance/status/1682458657160671232/photo/1',
          url: 'https://pbs.twimg.com/media/F1lLNllX0AYKDlp.jpg',
          width: 1600,
          height: 900,
        },
      ],
      isEdited: false,
      isStaleEdit: false,
    },
    isEdited: false,
    isStaleEdit: false,
  },
  '1729494399493554258': {
    __typename: 'Tweet',
    in_reply_to_screen_name: 'EonianFinance',
    in_reply_to_status_id_str: '1682458657160671232',
    in_reply_to_user_id_str: '1584314875991523328',
    lang: 'en',
    favorite_count: 0,
    created_at: '2023-11-28T13:36:11.000Z',
    display_text_range: [15, 54],
    entities: {
      hashtags: [],
      urls: [],
      user_mentions: [
        {
          id_str: '1584314875991523328',
          indices: [0, 14],
          name: 'Eonian',
          screen_name: 'EonianFinance',
        },
        {
          id_str: '1584314875991523328',
          indices: [40, 54],
          name: 'Eonian',
          screen_name: 'EonianFinance',
        },
      ],
      symbols: [],
    },
    id_str: '1729494399493554258',
    text: '@EonianFinance Great innovation! Thanks @EonianFinance',
    user: {
      id_str: '964625496301547520',
      name: 'cici_de (💜,🏛️) $SEF 🩸💧 👑 👾 🍀 fuel ⚔️',
      profile_image_url_https: 'https://pbs.twimg.com/profile_images/1793024562306674689/mQ2sOOgC_normal.png',
      screen_name: 'koincici',
      verified: false,
      is_blue_verified: false,
      profile_image_shape: 'Circle',
    },
    edit_control: {
      edit_tweet_ids: ['1729494399493554258'],
      editable_until_msecs: '1701182171000',
      is_edit_eligible: false,
      edits_remaining: '5',
    },
    conversation_count: 0,
    news_action_type: 'conversation',
    parent: {
      lang: 'en',
      reply_count: 130,
      retweet_count: 154,
      favorite_count: 184,
      possibly_sensitive: false,
      created_at: '2023-07-21T18:32:57.000Z',
      display_text_range: [0, 267],
      entities: {
        hashtags: [],
        urls: [],
        user_mentions: [
          {
            id_str: '1584314875991523328',
            indices: [68, 82],
            name: 'Eonian',
            screen_name: 'EonianFinance',
          },
        ],
        symbols: [],
        media: [
          {
            display_url: 'pic.x.com/4a99vhtdjn',
            expanded_url: 'https://twitter.com/EonianFinance/status/1682458657160671232/photo/1',
            indices: [268, 291],
            url: 'https://t.co/4a99vHtDJn',
          },
        ],
      },
      id_str: '1682458657160671232',
      text: 'Introducing Eonian - Your Ultimate Yield Aggregator building on BSC @EonianFinance \n\nAre you tired of making unsafe investments? Are you looking for the-one-solution to maximizing your yields? \n\nRevolutionize the way you invest, earn and grow your digital asset with… https://t.co/4a99vHtDJn',
      user: {
        id_str: '1584314875991523328',
        name: 'Eonian',
        profile_image_url_https: 'https://pbs.twimg.com/profile_images/1768404732949733377/T_w4Y8-E_normal.jpg',
        screen_name: 'EonianFinance',
        verified: false,
        is_blue_verified: true,
        profile_image_shape: 'Circle',
      },
      edit_control: {
        edit_tweet_ids: ['1682458657160671232'],
        editable_until_msecs: '1689967977000',
        is_edit_eligible: false,
        edits_remaining: '5',
      },
      mediaDetails: [
        {
          display_url: 'pic.twitter.com/4a99vHtDJn',
          expanded_url: 'https://twitter.com/EonianFinance/status/1682458657160671232/photo/1',
          ext_media_availability: {
            status: 'Available',
          },
          indices: [268, 291],
          media_url_https: 'https://pbs.twimg.com/media/F1lLNllX0AYKDlp.jpg',
          original_info: {
            height: 900,
            width: 1600,
            focus_rects: [
              {
                x: 0,
                y: 0,
                w: 1600,
                h: 896,
              },
              {
                x: 470,
                y: 0,
                w: 900,
                h: 900,
              },
              {
                x: 526,
                y: 0,
                w: 789,
                h: 900,
              },
              {
                x: 695,
                y: 0,
                w: 450,
                h: 900,
              },
              {
                x: 0,
                y: 0,
                w: 1600,
                h: 900,
              },
            ],
          },
          sizes: {
            large: {
              h: 900,
              resize: 'fit',
              w: 1600,
            },
            medium: {
              h: 675,
              resize: 'fit',
              w: 1200,
            },
            small: {
              h: 383,
              resize: 'fit',
              w: 680,
            },
            thumb: {
              h: 150,
              resize: 'crop',
              w: 150,
            },
          },
          type: 'photo',
          url: 'https://t.co/4a99vHtDJn',
        },
      ],
      photos: [
        {
          backgroundColor: {
            red: 204,
            green: 214,
            blue: 221,
          },
          cropCandidates: [
            {
              x: 0,
              y: 0,
              w: 1600,
              h: 896,
            },
            {
              x: 470,
              y: 0,
              w: 900,
              h: 900,
            },
            {
              x: 526,
              y: 0,
              w: 789,
              h: 900,
            },
            {
              x: 695,
              y: 0,
              w: 450,
              h: 900,
            },
            {
              x: 0,
              y: 0,
              w: 1600,
              h: 900,
            },
          ],
          expandedUrl: 'https://twitter.com/EonianFinance/status/1682458657160671232/photo/1',
          url: 'https://pbs.twimg.com/media/F1lLNllX0AYKDlp.jpg',
          width: 1600,
          height: 900,
        },
      ],
      isEdited: false,
      isStaleEdit: false,
    },
    isEdited: false,
    isStaleEdit: false,
  },
}
